// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Rect$SmartcutsMacros = require("./Rect.bs.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Query$SmartcutsMacros = require("../../bs-select/src/Query.bs.js");
var Command$SmartcutsMacros = require("./Command.bs.js");
var Smartcut$SmartcutsMacros = require("./Smartcut.bs.js");
var CustomMap$SmartcutsMacros = require("./CustomMap.bs.js");
var AuthStatus$SmartcutsMacros = require("./AuthStatus.bs.js");
var CommandLog$SmartcutsMacros = require("./CommandLog.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../bs-utils/src/DeccoUtils.bs.js");
var SmartcutIds$SmartcutsMacros = require("./SmartcutIds.bs.js");
var MasterSecret$SmartcutsMacros = require("./MasterSecret.bs.js");
var LoginSmartcut$SmartcutsMacros = require("./LoginSmartcut.bs.js");
var CommandContext$SmartcutsMacros = require("./CommandContext.bs.js");
var DataExtraction$SmartcutsMacros = require("../../bs-data-extraction/src/DataExtraction.bs.js");
var DataStoreUtils$SmartcutsMacros = require("../../data/src/DataStoreUtils.bs.js");
var Modal__WebAuth$SmartcutsMacros = require("./Modal__WebAuth.bs.js");
var PlaybackValues$SmartcutsMacros = require("./PlaybackValues.bs.js");
var UserCredential$SmartcutsMacros = require("./UserCredential.bs.js");
var ExternalAccount$SmartcutsMacros = require("./ExternalAccount.bs.js");
var PaginationTypes$SmartcutsMacros = require("../../../src/common/PaginationTypes.bs.js");
var PlaybackOptions$SmartcutsMacros = require("./PlaybackOptions.bs.js");
var ClipboardHelpers$SmartcutsMacros = require("./ClipboardHelpers.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("./DOM__HtmlElement.bs.js");
var ScheduledTrigger$SmartcutsMacros = require("./ScheduledTrigger.bs.js");
var SmartcutExecution$SmartcutsMacros = require("./SmartcutExecution.bs.js");
var PendingCommandInfo$SmartcutsMacros = require("./PendingCommandInfo.bs.js");
var PermissionAndOrigin$SmartcutsMacros = require("./PermissionAndOrigin.bs.js");
var BrowserVaultUnlocked$SmartcutsMacros = require("./vault/BrowserVaultUnlocked.bs.js");
var RenderOnHost__Geometry$SmartcutsMacros = require("./RenderOnHost__Geometry.bs.js");
var UserCredential__Shared$SmartcutsMacros = require("./UserCredential__Shared.bs.js");
var HighlightElement__Shared$SmartcutsMacros = require("./HighlightElement__Shared.bs.js");
var WithElementGroupsCommand$SmartcutsMacros = require("./commands/WithElementGroupsCommand.bs.js");
var MultiUrlTriggering__Types$SmartcutsMacros = require("./app/MultiUrlTriggering/MultiUrlTriggering__Types.bs.js");
var ExtensionMessagingBuilders$SmartcutsMacros = require("./ExtensionMessagingBuilders.bs.js");
var GoogleApis__Sheets__Schema$SmartcutsMacros = require("../../bs-googleapis/apis/sheets/GoogleApis__Sheets__Schema.bs.js");
var MultiUrlTriggering__Shared$SmartcutsMacros = require("./app/MultiUrlTriggering/MultiUrlTriggering__Shared.bs.js");
var RenderOnHost__Notification$SmartcutsMacros = require("./RenderOnHost__Notification.bs.js");
var Segment__TrackedQuotaWarning$SmartcutsMacros = require("../../bs-analytics/src/Segment__TrackedQuotaWarning.bs.js");
var BgFx__UserCredentials__Shared$SmartcutsMacros = require("./Bg/Fx/BgFx__UserCredentials__Shared.bs.js");
var GoogleApis__Sheets__BatchUpdate$SmartcutsMacros = require("../../bs-googleapis/apis/sheets/GoogleApis__Sheets__BatchUpdate.bs.js");
var Segment__TrackedClickOnViewPlans$SmartcutsMacros = require("../../bs-analytics/src/Segment__TrackedClickOnViewPlans.bs.js");

function message_encode(encoder_message, v) {
  return [
          "Message_FromTab",
          Curry._1(encoder_message, v._0)
        ];
}

function message_decode(decoder_message, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "Message_FromTab") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Curry._1(decoder_message, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* Message_FromTab */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode(encoder_response, v) {
  return [
          "Response_FromTab",
          Curry._1(encoder_response, v._0)
        ];
}

function response_decode(decoder_response, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "Response_FromTab") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Curry._1(decoder_response, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* Response_FromTab */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function result_encode(encoder_response, v) {
  return Decco.resultToJson((function (param) {
                return response_encode(encoder_response, param);
              }), Decco.stringToJson, v);
}

function result_decode(decoder_response, v) {
  return Decco.resultFromJson((function (param) {
                return response_decode(decoder_response, param);
              }), Decco.stringFromJson, v);
}

function wrapMessage(message) {
  return /* Message_FromTab */{
          _0: message
        };
}

function wrapResponse(response) {
  return /* Response_FromTab */{
          _0: response
        };
}

function unwrapMessage(message) {
  return message._0;
}

function unwrapResponse(response) {
  return response._0;
}

var AllWrapper = {
  message_encode: message_encode,
  message_decode: message_decode,
  response_encode: response_encode,
  response_decode: response_decode,
  result_encode: result_encode,
  result_decode: result_decode,
  wrapMessage: wrapMessage,
  wrapResponse: wrapResponse,
  unwrapMessage: unwrapMessage,
  unwrapResponse: unwrapResponse
};

function message_encode$1(v) {
  return ["ContentScriptReady"];
}

function message_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ContentScriptReady") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* ContentScriptReady */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$1(v) {
  switch (v) {
    case /* AttachToRecording */0 :
        return ["AttachToRecording"];
    case /* AttachToPlayback */1 :
        return ["AttachToPlayback"];
    case /* AckContentScriptReady */2 :
        return ["AckContentScriptReady"];
    
  }
}

function response_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AckContentScriptReady" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AckContentScriptReady */2
                  };
          }
      case "AttachToPlayback" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AttachToPlayback */1
                  };
          }
      case "AttachToRecording" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AttachToRecording */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_ContentScriptReady = {
  message_encode: message_encode$1,
  message_decode: message_decode$1,
  response_encode: response_encode$1,
  response_decode: response_decode$1
};

function message_encode$2(v) {
  return ["AskBgToRefreshAuthStatus"];
}

function message_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToRefreshAuthStatus") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToRefreshAuthStatus */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$2(v) {
  return [
          "DidRefreshAuthStatus",
          AuthStatus$SmartcutsMacros.t_encode(v._0)
        ];
}

function response_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidRefreshAuthStatus") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = AuthStatus$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* DidRefreshAuthStatus */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToRefreshAuthStatus = {
  message_encode: message_encode$2,
  message_decode: message_decode$2,
  response_encode: response_encode$2,
  response_decode: response_decode$2
};

function message_encode$3(v) {
  return ["AskBgToFetchPlanSubscriptionProgress"];
}

function message_decode$3(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToFetchPlanSubscriptionProgress") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToFetchPlanSubscriptionProgress */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$3(v) {
  if (typeof v !== "number") {
    return [
            "DidFetchRemainingExecutionSteps",
            Decco.intToJson(v._0),
            Decco.intToJson(v._1),
            Decco.stringToJson(v._2),
            Decco.floatToJson(v._3)
          ];
  }
  switch (v) {
    case /* NotLoggedIn */0 :
        return ["NotLoggedIn"];
    case /* HasNoActiveSubscription */1 :
        return ["HasNoActiveSubscription"];
    case /* DbIssue */2 :
        return ["DbIssue"];
    
  }
}

function response_decode$3(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DbIssue" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DbIssue */2
                  };
          }
      case "DidFetchRemainingExecutionSteps" :
          if (tagged.length !== 5) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 3));
          var match$4 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 4));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                if (match$4.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: /* DidFetchRemainingExecutionSteps */{
                            _0: match$1._0,
                            _1: match$2._0,
                            _2: match$3._0,
                            _3: match$4._0
                          }
                        };
                }
                var e = match$4._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[3]" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "HasNoActiveSubscription" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* HasNoActiveSubscription */1
                  };
          }
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToFetchPlanSubscriptionProgress = {
  message_encode: message_encode$3,
  message_decode: message_decode$3,
  response_encode: response_encode$3,
  response_decode: response_decode$3
};

function message_encode$4(v) {
  return ["StartDebugSelector"];
}

function message_decode$4(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "StartDebugSelector") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* StartDebugSelector */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$4(v) {
  if (v) {
    return ["BgCouldNotFindActiveTab"];
  } else {
    return ["BgDidStartDebugSelector"];
  }
}

function response_decode$4(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BgCouldNotFindActiveTab" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgCouldNotFindActiveTab */1
                  };
          }
      case "BgDidStartDebugSelector" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgDidStartDebugSelector */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_StartDebugSelector = {
  message_encode: message_encode$4,
  message_decode: message_decode$4,
  response_encode: response_encode$4,
  response_decode: response_decode$4
};

function startRecordingLoginSmartcut_encode(v) {
  return Js_dict.fromArray([
              [
                "mainSmartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.mainSmartcutId)
              ],
              [
                "startingUrl",
                Decco.stringToJson(v.startingUrl)
              ]
            ]);
}

function startRecordingLoginSmartcut_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var mainSmartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mainSmartcutId"), null));
  if (mainSmartcutId.TAG === /* Ok */0) {
    var startingUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startingUrl"), null));
    if (startingUrl.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                mainSmartcutId: mainSmartcutId._0,
                startingUrl: startingUrl._0
              }
            };
    }
    var e = startingUrl._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".startingUrl" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = mainSmartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".mainSmartcutId" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function message_encode$5(v) {
  if (v) {
    return [
            "StartRecordingLoginSmartcut",
            startRecordingLoginSmartcut_encode(v._0)
          ];
  } else {
    return ["StartRecording"];
  }
}

function message_decode$5(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "StartRecording" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* StartRecording */0
                  };
          }
      case "StartRecordingLoginSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = startRecordingLoginSmartcut_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* StartRecordingLoginSmartcut */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$5(v) {
  switch (v) {
    case /* BgDidStartRecording */0 :
        return ["BgDidStartRecording"];
    case /* BgCouldNotFindActiveTab */1 :
        return ["BgCouldNotFindActiveTab"];
    case /* NotLoggedIn */2 :
        return ["NotLoggedIn"];
    
  }
}

function response_decode$5(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BgCouldNotFindActiveTab" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgCouldNotFindActiveTab */1
                  };
          }
      case "BgDidStartRecording" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgDidStartRecording */0
                  };
          }
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */2
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_StartRecording = {
  message_encode: message_encode$5,
  message_decode: message_decode$5,
  startRecordingLoginSmartcut_encode: startRecordingLoginSmartcut_encode,
  startRecordingLoginSmartcut_decode: startRecordingLoginSmartcut_decode,
  response_encode: response_encode$5,
  response_decode: response_decode$5
};

function message_encode$6(v) {
  return ["StopRecording"];
}

function message_decode$6(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "StopRecording") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* StopRecording */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$6(v) {
  return ["AckStopRecording"];
}

function response_decode$6(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckStopRecording") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckStopRecording */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_StopRecording = {
  message_encode: message_encode$6,
  message_decode: message_decode$6,
  response_encode: response_encode$6,
  response_decode: response_decode$6
};

function message_encode$7(v) {
  return ["DidStartRecording"];
}

function message_decode$7(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidStartRecording") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* DidStartRecording */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$7(v) {
  if (v) {
    return ["BgExitedRecording"];
  } else {
    return ["BgRecording"];
  }
}

function response_decode$7(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BgExitedRecording" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgExitedRecording */1
                  };
          }
      case "BgRecording" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgRecording */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_DidStartRecording = {
  message_encode: message_encode$7,
  message_decode: message_decode$7,
  response_encode: response_encode$7,
  response_decode: response_decode$7
};

function message_encode$8(v) {
  return [
          "NotifyBgAboutPossibleCommand",
          PendingCommandInfo$SmartcutsMacros.key_encode(v._0),
          Decco.optionToJson(Rect$SmartcutsMacros.t_encode, v._1)
        ];
}

function message_decode$8(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "NotifyBgAboutPossibleCommand") {
    if (tagged.length !== 3) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var match$1 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 1));
    var match$2 = Decco.optionFromJson(Rect$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
    if (match$1.TAG === /* Ok */0) {
      if (match$2.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: /* NotifyBgAboutPossibleCommand */{
                  _0: match$1._0,
                  _1: match$2._0
                }
              };
      }
      var e = match$2._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = match$1._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$8(v) {
  return ["AckPossibleCommand"];
}

function response_decode$8(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckPossibleCommand") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckPossibleCommand */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_NotifyBgAboutPossibleCommand = {
  message_encode: message_encode$8,
  message_decode: message_decode$8,
  response_encode: response_encode$8,
  response_decode: response_decode$8
};

function message_encode$9(v) {
  return [
          "ClearKeyThatDoesNotGenerateCommand",
          PendingCommandInfo$SmartcutsMacros.key_encode(v._0)
        ];
}

function message_decode$9(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ClearKeyThatDoesNotGenerateCommand") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = PendingCommandInfo$SmartcutsMacros.key_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ClearKeyThatDoesNotGenerateCommand */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$9(v) {
  return ["AckClearKeyThatDoesNotGenerateCommand"];
}

function response_decode$9(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckClearKeyThatDoesNotGenerateCommand") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckClearKeyThatDoesNotGenerateCommand */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_ClearKeyThatDoesNotGenerateCommand = {
  message_encode: message_encode$9,
  message_decode: message_decode$9,
  response_encode: response_encode$9,
  response_decode: response_decode$9
};

function message_encode$10(v) {
  if (v.TAG === /* RecordCommand */0) {
    return [
            "RecordCommand",
            Command$SmartcutsMacros.CommandWithContextLocal.t_encode(v._0),
            Decco.optionToJson((function (param) {
                    return [
                            PendingCommandInfo$SmartcutsMacros.key_encode(param[0]),
                            Decco.intToJson(param[1])
                          ];
                  }), v._1)
          ];
  } else {
    return [
            "RecordCommands",
            Decco.listToJson(Command$SmartcutsMacros.CommandWithContextLocal.t_encode, v._0),
            Decco.optionToJson((function (param) {
                    return [
                            PendingCommandInfo$SmartcutsMacros.key_encode(param[0]),
                            Decco.intToJson(param[1])
                          ];
                  }), v._1)
          ];
  }
}

function message_decode$10(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "RecordCommand" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Command$SmartcutsMacros.CommandWithContextLocal.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.optionFromJson((function (json) {
                  var match = Js_json.classify(json);
                  if (typeof match === "number") {
                    return Decco.error(undefined, "Not a tuple", json);
                  }
                  if (match.TAG !== /* JSONArray */3) {
                    return Decco.error(undefined, "Not a tuple", json);
                  }
                  var match$1 = match._0;
                  if (match$1.length !== 2) {
                    return Decco.error(undefined, "Incorrect cardinality", json);
                  }
                  var v0 = match$1[0];
                  var v1 = match$1[1];
                  var match$2 = PendingCommandInfo$SmartcutsMacros.key_decode(v0);
                  var match$3 = Decco.intFromJson(v1);
                  if (match$2.TAG === /* Ok */0) {
                    if (match$3.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: [
                                match$2._0,
                                match$3._0
                              ]
                            };
                    }
                    var e = match$3._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: "[1]" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = match$2._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }), Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* RecordCommand */0,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "RecordCommands" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.listFromJson(Command$SmartcutsMacros.CommandWithContextLocal.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.optionFromJson((function (json) {
                  var match = Js_json.classify(json);
                  if (typeof match === "number") {
                    return Decco.error(undefined, "Not a tuple", json);
                  }
                  if (match.TAG !== /* JSONArray */3) {
                    return Decco.error(undefined, "Not a tuple", json);
                  }
                  var match$1 = match._0;
                  if (match$1.length !== 2) {
                    return Decco.error(undefined, "Incorrect cardinality", json);
                  }
                  var v0 = match$1[0];
                  var v1 = match$1[1];
                  var match$2 = PendingCommandInfo$SmartcutsMacros.key_decode(v0);
                  var match$3 = Decco.intFromJson(v1);
                  if (match$2.TAG === /* Ok */0) {
                    if (match$3.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: [
                                match$2._0,
                                match$3._0
                              ]
                            };
                    }
                    var e = match$3._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: "[1]" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = match$2._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[0]" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }), Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* RecordCommands */1,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$2 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$10(v) {
  if (v) {
    return ["BgDidIgnoreCommand"];
  } else {
    return ["BgDidRecordCommand"];
  }
}

function response_decode$10(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BgDidIgnoreCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgDidIgnoreCommand */1
                  };
          }
      case "BgDidRecordCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgDidRecordCommand */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_RecordCommand = {
  message_encode: message_encode$10,
  message_decode: message_decode$10,
  response_encode: response_encode$10,
  response_decode: response_decode$10
};

function message_encode$11(v) {
  return [
          "FinishAuthoring",
          Smartcut$SmartcutsMacros.ForAuthoringSubmission.t_encode(v._0)
        ];
}

function message_decode$11(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "FinishAuthoring") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Smartcut$SmartcutsMacros.ForAuthoringSubmission.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* FinishAuthoring */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$11(v) {
  if (v) {
    return [
            "AckFinishAuthoring",
            SmartcutIds$SmartcutsMacros.recordedSmartcutId_encode(v._0)
          ];
  } else {
    return ["NotLoggedIn"];
  }
}

function response_decode$11(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AckFinishAuthoring" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = SmartcutIds$SmartcutsMacros.recordedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* AckFinishAuthoring */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_FinishAuthoring = {
  message_encode: message_encode$11,
  message_decode: message_decode$11,
  response_encode: response_encode$11,
  response_decode: response_decode$11
};

function message_encode$12(v) {
  return [
          "OpenPageForSmartcutId",
          SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
        ];
}

function message_decode$12(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "OpenPageForSmartcutId") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* OpenPageForSmartcutId */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$12(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["NotLoggedIn"];
    } else {
      return ["BgDidOpenSmartcutPage"];
    }
  } else {
    return [
            "DidNotFindSmartcutToOpenPage",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
          ];
  }
}

function response_decode$12(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BgDidOpenSmartcutPage" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgDidOpenSmartcutPage */0
                  };
          }
      case "DidNotFindSmartcutToOpenPage" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotFindSmartcutToOpenPage */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_OpenPageForSmartcutId = {
  message_encode: message_encode$12,
  message_decode: message_decode$12,
  response_encode: response_encode$12,
  response_decode: response_decode$12
};

function message_encode$13(v) {
  return [
          "ShowFormForSmartcutId",
          SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
        ];
}

function message_decode$13(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ShowFormForSmartcutId") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ShowFormForSmartcutId */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$13(v) {
  if (v) {
    return [
            "DidNotFindSmartcutToOpenForm",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
          ];
  } else {
    return ["BgDidShowFormForSmartcutId"];
  }
}

function response_decode$13(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BgDidShowFormForSmartcutId" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgDidShowFormForSmartcutId */0
                  };
          }
      case "DidNotFindSmartcutToOpenForm" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotFindSmartcutToOpenForm */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_ShowFormForSmartcutId = {
  message_encode: message_encode$13,
  message_decode: message_decode$13,
  response_encode: response_encode$13,
  response_decode: response_decode$13
};

function message_encode$14(v) {
  return [
          "AskBgToAdjustModalGeometry",
          RenderOnHost__Geometry$SmartcutsMacros.t_encode(v._0)
        ];
}

function message_decode$14(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToAdjustModalGeometry") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = RenderOnHost__Geometry$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToAdjustModalGeometry */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$14(v) {
  if (v) {
    return ["BgDidNotAdjustModalGeometry"];
  } else {
    return ["BgDidAdjustModalGeometry"];
  }
}

function response_decode$14(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BgDidAdjustModalGeometry" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgDidAdjustModalGeometry */0
                  };
          }
      case "BgDidNotAdjustModalGeometry" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgDidNotAdjustModalGeometry */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToAdjustModalGeometry = {
  message_encode: message_encode$14,
  message_decode: message_decode$14,
  response_encode: response_encode$14,
  response_decode: response_decode$14
};

function playbackData_encode(v) {
  if (v.TAG === /* SinglePlayback */0) {
    return [
            "SinglePlayback",
            PlaybackValues$SmartcutsMacros.t_encode(v._0)
          ];
  } else {
    return [
            "BatchPlayback",
            Decco.listToJson(PlaybackValues$SmartcutsMacros.t_encode, v._0)
          ];
  }
}

function playbackData_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BatchPlayback" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.listFromJson(PlaybackValues$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* BatchPlayback */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SinglePlayback" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = PlaybackValues$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SinglePlayback */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function initPlayback_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "installedSmartcutId",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
              ],
              [
                "playbackData",
                playbackData_encode(v.playbackData)
              ],
              [
                "userSpecifiedPlaybackOptions",
                PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode(v.userSpecifiedPlaybackOptions)
              ],
              [
                "startContext",
                PlaybackOptions$SmartcutsMacros.StartContext.t_encode(v.startContext)
              ]
            ]);
}

function initPlayback_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
    if (installedSmartcutId.TAG === /* Ok */0) {
      var playbackData = playbackData_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "playbackData"), null));
      if (playbackData.TAG === /* Ok */0) {
        var userSpecifiedPlaybackOptions = PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "userSpecifiedPlaybackOptions"), null));
        if (userSpecifiedPlaybackOptions.TAG === /* Ok */0) {
          var startContext = PlaybackOptions$SmartcutsMacros.StartContext.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "startContext"), null));
          if (startContext.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      id: id._0,
                      installedSmartcutId: installedSmartcutId._0,
                      playbackData: playbackData._0,
                      userSpecifiedPlaybackOptions: userSpecifiedPlaybackOptions._0,
                      startContext: startContext._0
                    }
                  };
          }
          var e = startContext._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".startContext" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = userSpecifiedPlaybackOptions._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".userSpecifiedPlaybackOptions" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = playbackData._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".playbackData" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = installedSmartcutId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".installedSmartcutId" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function message_encode$15(v) {
  return [
          "InitializePlayback",
          initPlayback_encode(v._0)
        ];
}

function message_decode$15(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "InitializePlayback") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = initPlayback_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* InitializePlayback */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$15(v) {
  return ["BgDidInitializePlayback"];
}

function response_decode$15(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "BgDidInitializePlayback") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* BgDidInitializePlayback */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_InitializePlayback = {
  message_encode: message_encode$15,
  message_decode: message_decode$15,
  initPlayback_encode: initPlayback_encode,
  initPlayback_decode: initPlayback_decode,
  playbackData_encode: playbackData_encode,
  playbackData_decode: playbackData_decode,
  response_encode: response_encode$15,
  response_decode: response_decode$15
};

function message_encode$16(v) {
  return [
          "GetAuthoringCommandLog",
          Decco.stringToJson(v._0)
        ];
}

function message_decode$16(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GetAuthoringCommandLog") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* GetAuthoringCommandLog */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$16(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["NotLoggedIn"];
    } else {
      return ["DidNotFindAuthoringCommandLog"];
    }
  } else {
    return [
            "DidFindAuthoringCommandLog",
            CommandLog$SmartcutsMacros.GlobalForAuthoring.t_encode(v._0)
          ];
  }
}

function response_decode$16(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidFindAuthoringCommandLog" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = CommandLog$SmartcutsMacros.GlobalForAuthoring.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidFindAuthoringCommandLog */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotFindAuthoringCommandLog" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotFindAuthoringCommandLog */0
                  };
          }
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_GetAuthoringCommandLog = {
  message_encode: message_encode$16,
  message_decode: message_decode$16,
  response_encode: response_encode$16,
  response_decode: response_decode$16
};

function message_encode$17(v) {
  return [
          "GetSmartcut",
          SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0),
          Decco.boolToJson(v._1)
        ];
}

function message_decode$17(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GetSmartcut") {
    if (tagged.length !== 3) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var match$1 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
    var match$2 = Decco.boolFromJson(Belt_Array.getExn(jsonArr$1, 2));
    if (match$1.TAG === /* Ok */0) {
      if (match$2.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: /* GetSmartcut */{
                  _0: match$1._0,
                  _1: match$2._0
                }
              };
      }
      var e = match$2._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = match$1._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$17(v) {
  if (typeof v === "number") {
    return ["NotLoggedIn"];
  } else if (v.TAG === /* DidFindSmartcut */0) {
    return [
            "DidFindSmartcut",
            Smartcut$SmartcutsMacros.LoadedSmartcut.t_encode(v._0)
          ];
  } else {
    return [
            "DidNotFindSmartcut",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
          ];
  }
}

function response_decode$17(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidFindSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Smartcut$SmartcutsMacros.LoadedSmartcut.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidFindSmartcut */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotFindSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidNotFindSmartcut */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_GetSmartcut = {
  message_encode: message_encode$17,
  message_decode: message_decode$17,
  response_encode: response_encode$17,
  response_decode: response_decode$17
};

function message_encode$18(v) {
  return ["GetMySmartcuts"];
}

function message_decode$18(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GetMySmartcuts") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* GetMySmartcuts */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$18(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["NotLoggedIn"];
    } else {
      return ["DidNotFindMySmartcuts"];
    }
  } else {
    return [
            "DidFindMySmartcuts",
            Decco.arrayToJson(Smartcut$SmartcutsMacros.LoadedSmartcut.t_encode, v._0)
          ];
  }
}

function response_decode$18(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidFindMySmartcuts" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson(Smartcut$SmartcutsMacros.LoadedSmartcut.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidFindMySmartcuts */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotFindMySmartcuts" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotFindMySmartcuts */0
                  };
          }
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_GetMySmartcuts = {
  message_encode: message_encode$18,
  message_decode: message_decode$18,
  response_encode: response_encode$18,
  response_decode: response_decode$18
};

function message_encode$19(v) {
  return [
          "InstallSmartcut",
          SmartcutIds$SmartcutsMacros.smartcutId_encode(v._0)
        ];
}

function message_decode$19(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "InstallSmartcut") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* InstallSmartcut */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$19(v) {
  if (v.TAG === /* DidInstallSmartcut */0) {
    return [
            "DidInstallSmartcut",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
          ];
  } else {
    return [
            "DidNotInstallSmartcut",
            Decco.stringToJson(v._0)
          ];
  }
}

function response_decode$19(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidInstallSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidInstallSmartcut */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotInstallSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidNotInstallSmartcut */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_InstallSmartcut = {
  message_encode: message_encode$19,
  message_decode: message_decode$19,
  response_encode: response_encode$19,
  response_decode: response_decode$19
};

function message_encode$20(v) {
  return [
          "DeleteSmartcut",
          SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
        ];
}

function message_decode$20(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DeleteSmartcut") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* DeleteSmartcut */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$20(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["NotLoggedIn"];
    } else {
      return ["DidDeleteSmartcut"];
    }
  } else {
    return [
            "DidNotDeleteSmartcut",
            Decco.stringToJson(v._0)
          ];
  }
}

function response_decode$20(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidDeleteSmartcut" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidDeleteSmartcut */0
                  };
          }
      case "DidNotDeleteSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotDeleteSmartcut */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_DeleteSmartcut = {
  message_encode: message_encode$20,
  message_decode: message_decode$20,
  response_encode: response_encode$20,
  response_decode: response_decode$20
};

function getExecutionHistoryForSmartcut_encode(v) {
  return Js_dict.fromArray([
              [
                "installedSmartcutId",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
              ],
              [
                "paginateExecutionHistory",
                PaginationTypes$SmartcutsMacros.paginationParams_encode(v.paginateExecutionHistory)
              ],
              [
                "paginateUnresolvedFailures",
                PaginationTypes$SmartcutsMacros.paginationParams_encode(v.paginateUnresolvedFailures)
              ]
            ]);
}

function getExecutionHistoryForSmartcut_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
  if (installedSmartcutId.TAG === /* Ok */0) {
    var paginateExecutionHistory = PaginationTypes$SmartcutsMacros.paginationParams_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateExecutionHistory"), null));
    if (paginateExecutionHistory.TAG === /* Ok */0) {
      var paginateUnresolvedFailures = PaginationTypes$SmartcutsMacros.paginationParams_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "paginateUnresolvedFailures"), null));
      if (paginateUnresolvedFailures.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  installedSmartcutId: installedSmartcutId._0,
                  paginateExecutionHistory: paginateExecutionHistory._0,
                  paginateUnresolvedFailures: paginateUnresolvedFailures._0
                }
              };
      }
      var e = paginateUnresolvedFailures._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".paginateUnresolvedFailures" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = paginateExecutionHistory._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".paginateExecutionHistory" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = installedSmartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".installedSmartcutId" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function message_encode$21(v) {
  return [
          "GetExecutionHistoryForSmartcut",
          getExecutionHistoryForSmartcut_encode(v._0)
        ];
}

function message_decode$21(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GetExecutionHistoryForSmartcut") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = getExecutionHistoryForSmartcut_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* GetExecutionHistoryForSmartcut */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function didFindExecutionHistory_encode(v) {
  return Js_dict.fromArray([
              [
                "executionHistory",
                PaginationTypes$SmartcutsMacros.paginatedResult_encode(SmartcutExecution$SmartcutsMacros.Execution.t_encode, v.executionHistory)
              ],
              [
                "executionSets",
                Decco.arrayToJson(SmartcutExecution$SmartcutsMacros.ExecutionSet.t_encode, v.executionSets)
              ],
              [
                "unresolvedFailures",
                PaginationTypes$SmartcutsMacros.paginatedResult_encode(SmartcutExecution$SmartcutsMacros.Execution.t_encode, v.unresolvedFailures)
              ],
              [
                "pendingExecutionSets",
                Decco.arrayToJson(SmartcutExecution$SmartcutsMacros.ExecutionSet.t_encode, v.pendingExecutionSets)
              ]
            ]);
}

function didFindExecutionHistory_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var executionHistory = PaginationTypes$SmartcutsMacros.paginatedResult_decode(SmartcutExecution$SmartcutsMacros.Execution.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "executionHistory"), null));
  if (executionHistory.TAG === /* Ok */0) {
    var executionSets = Decco.arrayFromJson(SmartcutExecution$SmartcutsMacros.ExecutionSet.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "executionSets"), null));
    if (executionSets.TAG === /* Ok */0) {
      var unresolvedFailures = PaginationTypes$SmartcutsMacros.paginatedResult_decode(SmartcutExecution$SmartcutsMacros.Execution.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "unresolvedFailures"), null));
      if (unresolvedFailures.TAG === /* Ok */0) {
        var pendingExecutionSets = Decco.arrayFromJson(SmartcutExecution$SmartcutsMacros.ExecutionSet.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pendingExecutionSets"), null));
        if (pendingExecutionSets.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    executionHistory: executionHistory._0,
                    executionSets: executionSets._0,
                    unresolvedFailures: unresolvedFailures._0,
                    pendingExecutionSets: pendingExecutionSets._0
                  }
                };
        }
        var e = pendingExecutionSets._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".pendingExecutionSets" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = unresolvedFailures._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".unresolvedFailures" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = executionSets._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".executionSets" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = executionHistory._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".executionHistory" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function response_encode$21(v) {
  if (typeof v === "number") {
    return ["NotLoggedIn"];
  } else if (v.TAG === /* DidFindExecutionHistory */0) {
    return [
            "DidFindExecutionHistory",
            didFindExecutionHistory_encode(v._0)
          ];
  } else {
    return [
            "DidNotFindSmartcut",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
          ];
  }
}

function response_decode$21(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidFindExecutionHistory" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = didFindExecutionHistory_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidFindExecutionHistory */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotFindSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidNotFindSmartcut */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_GetExecutionHistoryForSmartcut = {
  message_encode: message_encode$21,
  message_decode: message_decode$21,
  getExecutionHistoryForSmartcut_encode: getExecutionHistoryForSmartcut_encode,
  getExecutionHistoryForSmartcut_decode: getExecutionHistoryForSmartcut_decode,
  response_encode: response_encode$21,
  response_decode: response_decode$21,
  didFindExecutionHistory_encode: didFindExecutionHistory_encode,
  didFindExecutionHistory_decode: didFindExecutionHistory_decode
};

function message_encode$22(v) {
  return [
          "GetScheduledTriggersForSmartcut",
          SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
        ];
}

function message_decode$22(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GetScheduledTriggersForSmartcut") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* GetScheduledTriggersForSmartcut */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$22(v) {
  if (typeof v === "number") {
    return ["NotLoggedIn"];
  } else if (v.TAG === /* DidFindScheduledTriggers */0) {
    return [
            "DidFindScheduledTriggers",
            Decco.arrayToJson(ScheduledTrigger$SmartcutsMacros.t_encode, v._0)
          ];
  } else {
    return [
            "DidNotFindSmartcut",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
          ];
  }
}

function response_decode$22(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidFindScheduledTriggers" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson(ScheduledTrigger$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidFindScheduledTriggers */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotFindSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidNotFindSmartcut */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_GetScheduledTriggersForSmartcut = {
  message_encode: message_encode$22,
  message_decode: message_decode$22,
  response_encode: response_encode$22,
  response_decode: response_decode$22
};

function message_encode$23(v) {
  return [
          "FindExecutionById",
          Decco.stringToJson(v._0)
        ];
}

function message_decode$23(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "FindExecutionById") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* FindExecutionById */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$23(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["NotLoggedIn"];
    } else {
      return ["DidNotFindExecution"];
    }
  } else {
    return [
            "DidFindExecution",
            SmartcutExecution$SmartcutsMacros.Execution.t_encode(v._0)
          ];
  }
}

function response_decode$23(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidFindExecution" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = SmartcutExecution$SmartcutsMacros.Execution.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidFindExecution */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotFindExecution" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotFindExecution */0
                  };
          }
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_FindExecutionById = {
  message_encode: message_encode$23,
  message_decode: message_decode$23,
  response_encode: response_encode$23,
  response_decode: response_decode$23
};

function message_encode$24(v) {
  return [
          "UpdateExecutionStatus",
          Decco.stringToJson(v._0),
          SmartcutExecution$SmartcutsMacros.Execution.status_encode(v._1)
        ];
}

function message_decode$24(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "UpdateExecutionStatus") {
    if (tagged.length !== 3) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
    var match$2 = SmartcutExecution$SmartcutsMacros.Execution.status_decode(Belt_Array.getExn(jsonArr$1, 2));
    if (match$1.TAG === /* Ok */0) {
      if (match$2.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: /* UpdateExecutionStatus */{
                  _0: match$1._0,
                  _1: match$2._0
                }
              };
      }
      var e = match$2._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = match$1._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$24(v) {
  if (v) {
    return ["NotLoggedIn"];
  } else {
    return ["DidUpdateExecutionStatus"];
  }
}

function response_decode$24(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidUpdateExecutionStatus" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidUpdateExecutionStatus */0
                  };
          }
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UpdateExecutionStatus = {
  message_encode: message_encode$24,
  message_decode: message_decode$24,
  response_encode: response_encode$24,
  response_decode: response_decode$24
};

function message_encode$25(v) {
  return [
          "UpsertExecutionSet",
          SmartcutExecution$SmartcutsMacros.ExecutionSet.t_encode(v._0)
        ];
}

function message_decode$25(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "UpsertExecutionSet") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = SmartcutExecution$SmartcutsMacros.ExecutionSet.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* UpsertExecutionSet */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$25(v) {
  return [
          "DidUpsertExecutionSet",
          Decco.boolToJson(v._0)
        ];
}

function response_decode$25(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidUpsertExecutionSet") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.boolFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* DidUpsertExecutionSet */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UpsertExecutionSet = {
  message_encode: message_encode$25,
  message_decode: message_decode$25,
  response_encode: response_encode$25,
  response_decode: response_decode$25
};

function message_encode$26(v) {
  return [
          "DeleteExecutionSet",
          Decco.stringToJson(v._0)
        ];
}

function message_decode$26(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DeleteExecutionSet") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* DeleteExecutionSet */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$26(v) {
  if (v) {
    return ["NotLoggedIn"];
  } else {
    return ["DidDeleteExecutionSet"];
  }
}

function response_decode$26(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidDeleteExecutionSet" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidDeleteExecutionSet */0
                  };
          }
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_DeleteExecutionSet = {
  message_encode: message_encode$26,
  message_decode: message_decode$26,
  response_encode: response_encode$26,
  response_decode: response_decode$26
};

function progress_encode(v) {
  return Js_dict.fromArray([
              [
                "numExpectedPlaybacks",
                Decco.intToJson(v.numExpectedPlaybacks)
              ],
              [
                "numSucceeded",
                Decco.intToJson(v.numSucceeded)
              ],
              [
                "numFailed",
                Decco.intToJson(v.numFailed)
              ]
            ]);
}

function progress_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var numExpectedPlaybacks = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numExpectedPlaybacks"), null));
  if (numExpectedPlaybacks.TAG === /* Ok */0) {
    var numSucceeded = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numSucceeded"), null));
    if (numSucceeded.TAG === /* Ok */0) {
      var numFailed = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "numFailed"), null));
      if (numFailed.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  numExpectedPlaybacks: numExpectedPlaybacks._0,
                  numSucceeded: numSucceeded._0,
                  numFailed: numFailed._0
                }
              };
      }
      var e = numFailed._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".numFailed" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = numSucceeded._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".numSucceeded" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = numExpectedPlaybacks._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".numExpectedPlaybacks" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function stringifyProgress(progress) {
  return JSON.stringify(progress);
}

function message_encode$27(v) {
  return ["GetExecutionSetProgress"];
}

function message_decode$27(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GetExecutionSetProgress") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* GetExecutionSetProgress */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$27(v) {
  if (v) {
    return [
            "DidGetExecutionSetProgress",
            progress_encode(v._0)
          ];
  } else {
    return ["NotLoggedIn"];
  }
}

function response_decode$27(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidGetExecutionSetProgress" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = progress_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidGetExecutionSetProgress */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_GetExecutionSetProgress = {
  progress_encode: progress_encode,
  progress_decode: progress_decode,
  stringifyProgress: stringifyProgress,
  message_encode: message_encode$27,
  message_decode: message_decode$27,
  response_encode: response_encode$27,
  response_decode: response_decode$27
};

function message_encode$28(v) {
  return [
          "GetExecutionSetById",
          Decco.stringToJson(v._0)
        ];
}

function message_decode$28(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GetExecutionSetById") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* GetExecutionSetById */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function didGetExecutionSet_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "NotPlayingback" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = SmartcutExecution$SmartcutsMacros.ExecutionSet.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NotPlayingback */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Playingback" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = progress_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Playingback */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function didGetExecutionSet_encode(v) {
  if (v.TAG === /* Playingback */0) {
    return [
            "Playingback",
            progress_encode(v._0)
          ];
  } else {
    return [
            "NotPlayingback",
            SmartcutExecution$SmartcutsMacros.ExecutionSet.t_encode(v._0)
          ];
  }
}

function response_encode$28(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["NotLoggedIn"];
    } else {
      return ["DidNotGetExecutionSet"];
    }
  } else {
    return [
            "DidGetExecutionSet",
            didGetExecutionSet_encode(v._0)
          ];
  }
}

function response_decode$28(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidGetExecutionSet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = didGetExecutionSet_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidGetExecutionSet */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotGetExecutionSet" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotGetExecutionSet */0
                  };
          }
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyResponse(response) {
  if (typeof response === "number") {
    if (response !== 0) {
      return "NotLoggedIn";
    } else {
      return "DidNotGetExecutionSet";
    }
  }
  var progress = response._0;
  if (progress.TAG === /* Playingback */0) {
    return "DidGetExecutionSet(Playingback(" + (JSON.stringify(progress._0) + "))");
  } else {
    return "DidGetExecutionSet(NotPLayingback({ status: " + (SmartcutExecution$SmartcutsMacros.ExecutionSet.stringifyStatus(progress._0.status) + " }))");
  }
}

var MR_GetExecutionSetById = {
  message_encode: message_encode$28,
  message_decode: message_decode$28,
  response_encode: response_encode$28,
  response_decode: response_decode$28,
  didGetExecutionSet_encode: didGetExecutionSet_encode,
  didGetExecutionSet_decode: didGetExecutionSet_decode,
  stringifyResponse: stringifyResponse
};

function message_encode$29(v) {
  return [
          "UpsertScheduledTriggerAndCreateAlarm",
          ScheduledTrigger$SmartcutsMacros.t_encode(v._0)
        ];
}

function message_decode$29(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "UpsertScheduledTriggerAndCreateAlarm") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = ScheduledTrigger$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* UpsertScheduledTriggerAndCreateAlarm */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$29(v) {
  switch (v) {
    case /* DidUpsertScheduledTriggerAndCreateAlarm */0 :
        return ["DidUpsertScheduledTriggerAndCreateAlarm"];
    case /* DidNotFindSmartcut */1 :
        return ["DidNotFindSmartcut"];
    case /* NotLoggedIn */2 :
        return ["NotLoggedIn"];
    
  }
}

function response_decode$29(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidNotFindSmartcut" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotFindSmartcut */1
                  };
          }
      case "DidUpsertScheduledTriggerAndCreateAlarm" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidUpsertScheduledTriggerAndCreateAlarm */0
                  };
          }
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */2
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UpsertScheduledTriggerAndCreateAlarm = {
  message_encode: message_encode$29,
  message_decode: message_decode$29,
  response_encode: response_encode$29,
  response_decode: response_decode$29
};

function message_encode$30(v) {
  return [
          "ArchiveScheduledTrigger",
          Decco.stringToJson(v._0)
        ];
}

function message_decode$30(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ArchiveScheduledTrigger") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ArchiveScheduledTrigger */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$30(v) {
  switch (v) {
    case /* DidArchiveScheduledTrigger */0 :
        return ["DidArchiveScheduledTrigger"];
    case /* DidNotClearAlarmNorArchiveInDb */1 :
        return ["DidNotClearAlarmNorArchiveInDb"];
    case /* DidNotClearAlarmButDidArchiveInDb */2 :
        return ["DidNotClearAlarmButDidArchiveInDb"];
    case /* ClearedAlarmButDidNotArchiveInDb */3 :
        return ["ClearedAlarmButDidNotArchiveInDb"];
    case /* NotLoggedIn */4 :
        return ["NotLoggedIn"];
    
  }
}

function response_decode$30(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ClearedAlarmButDidNotArchiveInDb" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ClearedAlarmButDidNotArchiveInDb */3
                  };
          }
      case "DidArchiveScheduledTrigger" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidArchiveScheduledTrigger */0
                  };
          }
      case "DidNotClearAlarmButDidArchiveInDb" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotClearAlarmButDidArchiveInDb */2
                  };
          }
      case "DidNotClearAlarmNorArchiveInDb" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotClearAlarmNorArchiveInDb */1
                  };
          }
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */4
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_ArchiveScheduledTrigger = {
  message_encode: message_encode$30,
  message_decode: message_decode$30,
  response_encode: response_encode$30,
  response_decode: response_decode$30
};

function message_encode$31(v) {
  return [
          "SaveExternalAccount",
          ExternalAccount$SmartcutsMacros.t_encode(v._0)
        ];
}

function message_decode$31(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "SaveExternalAccount") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = ExternalAccount$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* SaveExternalAccount */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$31(v) {
  return ["DidSaveExternalAccount"];
}

function response_decode$31(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidSaveExternalAccount") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* DidSaveExternalAccount */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_SaveExternalAccount = {
  message_encode: message_encode$31,
  message_decode: message_decode$31,
  response_encode: response_encode$31,
  response_decode: response_decode$31
};

function message_encode$32(v) {
  return [
          "FindExternalAccountById",
          Decco.stringToJson(v._0)
        ];
}

function message_decode$32(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "FindExternalAccountById") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* FindExternalAccountById */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$32(v) {
  if (v) {
    return [
            "DidFindExternalAccount",
            ExternalAccount$SmartcutsMacros.t_encode(v._0)
          ];
  } else {
    return ["DidNotFindExternalAccount"];
  }
}

function response_decode$32(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidFindExternalAccount" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ExternalAccount$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidFindExternalAccount */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotFindExternalAccount" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotFindExternalAccount */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_FindExternalAccountById = {
  message_encode: message_encode$32,
  message_decode: message_decode$32,
  response_encode: response_encode$32,
  response_decode: response_decode$32
};

function message_encode$33(v) {
  return [
          "GetOAuthToken",
          Decco.boolToJson(v._0)
        ];
}

function message_decode$33(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GetOAuthToken") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.boolFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* GetOAuthToken */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$33(v) {
  if (v) {
    return [
            "DidGetOAuthToken",
            Decco.stringToJson(v._0)
          ];
  } else {
    return ["DidNotGetOAuthToken"];
  }
}

function response_decode$33(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidGetOAuthToken" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidGetOAuthToken */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotGetOAuthToken" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotGetOAuthToken */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_GetOAuthToken = {
  message_encode: message_encode$33,
  message_decode: message_decode$33,
  response_encode: response_encode$33,
  response_decode: response_decode$33
};

function message_encode$34(v) {
  return [
          "AskBgToWriteToClipboard",
          ClipboardHelpers$SmartcutsMacros.textOrImageResolved_encode(v._0)
        ];
}

function message_decode$34(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToWriteToClipboard") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = ClipboardHelpers$SmartcutsMacros.textOrImageResolved_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToWriteToClipboard */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$34(v) {
  return ["BgDidWriteToClipboard"];
}

function response_decode$34(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "BgDidWriteToClipboard") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* BgDidWriteToClipboard */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToClipboard = {
  message_encode: message_encode$34,
  message_decode: message_decode$34,
  response_encode: response_encode$34,
  response_decode: response_decode$34
};

var Sheet = DeccoUtils$SmartcutsMacros.MakeJSONDataWithDeccoFns({});

var Spreadsheet = DeccoUtils$SmartcutsMacros.MakeJSONDataWithDeccoFns({});

var ValueRange = DeccoUtils$SmartcutsMacros.MakeJSONDataWithDeccoFns({});

var GoogleSheet = {
  Sheet: Sheet,
  Spreadsheet: Spreadsheet,
  ValueRange: ValueRange
};

function param_encode(v) {
  return Js_dict.fromArray([
              [
                "title",
                Decco.stringToJson(v.title)
              ],
              [
                "sheets",
                Decco.arrayToJson((function (prim) {
                        return prim;
                      }), v.sheets)
              ],
              [
                "authToken",
                Decco.stringToJson(v.authToken)
              ]
            ]);
}

function param_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sheets = Decco.arrayFromJson(Sheet.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sheets"), null));
    if (sheets.TAG === /* Ok */0) {
      var authToken = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "authToken"), null));
      if (authToken.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  title: title._0,
                  sheets: sheets._0,
                  authToken: authToken._0
                }
              };
      }
      var e = authToken._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".authToken" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = sheets._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sheets" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function message_encode$35(v) {
  return [
          "CreateSpreadsheet",
          param_encode(v._0)
        ];
}

function message_decode$35(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "CreateSpreadsheet") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = param_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* CreateSpreadsheet */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$35(v) {
  if (typeof v !== "number") {
    return [
            "DidCreateSpreadsheet",
            v._0
          ];
  }
  switch (v) {
    case /* DidNotCreateSpreadsheet */0 :
        return ["DidNotCreateSpreadsheet"];
    case /* DidNotCreateSpreadsheetBecauseUnauthenticated */1 :
        return ["DidNotCreateSpreadsheetBecauseUnauthenticated"];
    case /* DidNotCreateSpreadsheetBecauseGapiNotLoaded */2 :
        return ["DidNotCreateSpreadsheetBecauseGapiNotLoaded"];
    
  }
}

function response_decode$35(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidCreateSpreadsheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(Spreadsheet.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidCreateSpreadsheet */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotCreateSpreadsheet" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotCreateSpreadsheet */0
                  };
          }
      case "DidNotCreateSpreadsheetBecauseGapiNotLoaded" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotCreateSpreadsheetBecauseGapiNotLoaded */2
                  };
          }
      case "DidNotCreateSpreadsheetBecauseUnauthenticated" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotCreateSpreadsheetBecauseUnauthenticated */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_CreateGoogleSheet = {
  message_encode: message_encode$35,
  message_decode: message_decode$35,
  param_encode: param_encode,
  param_decode: param_decode,
  response_encode: response_encode$35,
  response_decode: response_decode$35
};

function param_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var authToken = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "authToken"), null));
    if (authToken.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                spreadsheetId: spreadsheetId._0,
                authToken: authToken._0
              }
            };
    }
    var e = authToken._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".authToken" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function param_encode$1(v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "authToken",
                Decco.stringToJson(v.authToken)
              ]
            ]);
}

function message_encode$36(v) {
  return [
          "FetchGoogleSheet",
          param_encode$1(v._0)
        ];
}

function message_decode$36(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "FetchGoogleSheet") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = param_decode$1(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* FetchGoogleSheet */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$36(v) {
  if (typeof v !== "number") {
    return [
            "DidFetchGoogleSheet",
            v._0
          ];
  }
  switch (v) {
    case /* DidNotFetchGoogleSheet */0 :
        return ["DidNotFetchGoogleSheet"];
    case /* DidNotFetchGoogleSheetBecauseUnauthenticated */1 :
        return ["DidNotFetchGoogleSheetBecauseUnauthenticated"];
    case /* DidNotFetchGoogleSheetBecauseGapiNotLoaded */2 :
        return ["DidNotFetchGoogleSheetBecauseGapiNotLoaded"];
    
  }
}

function response_decode$36(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidFetchGoogleSheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(Spreadsheet.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidFetchGoogleSheet */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotFetchGoogleSheet" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotFetchGoogleSheet */0
                  };
          }
      case "DidNotFetchGoogleSheetBecauseGapiNotLoaded" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotFetchGoogleSheetBecauseGapiNotLoaded */2
                  };
          }
      case "DidNotFetchGoogleSheetBecauseUnauthenticated" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotFetchGoogleSheetBecauseUnauthenticated */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_FetchGoogleSheet = {
  message_encode: message_encode$36,
  message_decode: message_decode$36,
  param_encode: param_encode$1,
  param_decode: param_decode$1,
  response_encode: response_encode$36,
  response_decode: response_decode$36
};

function param_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var spreadsheetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "spreadsheetId"), null));
  if (spreadsheetId.TAG === /* Ok */0) {
    var authToken = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "authToken"), null));
    if (authToken.TAG === /* Ok */0) {
      var requestBody = GoogleApis__Sheets__BatchUpdate$SmartcutsMacros.RequestBody.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "requestBody"), null));
      if (requestBody.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  spreadsheetId: spreadsheetId._0,
                  authToken: authToken._0,
                  requestBody: requestBody._0
                }
              };
      }
      var e = requestBody._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".requestBody" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = authToken._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".authToken" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = spreadsheetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".spreadsheetId" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function param_encode$2(v) {
  return Js_dict.fromArray([
              [
                "spreadsheetId",
                Decco.stringToJson(v.spreadsheetId)
              ],
              [
                "authToken",
                Decco.stringToJson(v.authToken)
              ],
              [
                "requestBody",
                GoogleApis__Sheets__BatchUpdate$SmartcutsMacros.RequestBody.t_encode(v.requestBody)
              ]
            ]);
}

function message_encode$37(v) {
  return [
          "BatchUpdateSpreadsheet",
          param_encode$2(v._0)
        ];
}

function message_decode$37(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "BatchUpdateSpreadsheet") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = param_decode$2(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* BatchUpdateSpreadsheet */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$37(v) {
  switch (v) {
    case /* DidBatchUpdateSpreadsheet */0 :
        return ["DidBatchUpdateSpreadsheet"];
    case /* DidNotBatchUpdateSpreadsheet */1 :
        return ["DidNotBatchUpdateSpreadsheet"];
    case /* DidNotBatchUpdateSpreadsheetBecauseUnauthenticated */2 :
        return ["DidNotBatchUpdateSpreadsheetBecauseUnauthenticated"];
    case /* DidNotBatchUpdateSpreadsheetBecauseGapiNotLoaded */3 :
        return ["DidNotBatchUpdateSpreadsheetBecauseGapiNotLoaded"];
    
  }
}

function response_decode$37(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidBatchUpdateSpreadsheet" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidBatchUpdateSpreadsheet */0
                  };
          }
      case "DidNotBatchUpdateSpreadsheet" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotBatchUpdateSpreadsheet */1
                  };
          }
      case "DidNotBatchUpdateSpreadsheetBecauseGapiNotLoaded" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotBatchUpdateSpreadsheetBecauseGapiNotLoaded */3
                  };
          }
      case "DidNotBatchUpdateSpreadsheetBecauseUnauthenticated" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotBatchUpdateSpreadsheetBecauseUnauthenticated */2
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_BatchUpdateGoogleSheet = {
  message_encode: message_encode$37,
  message_decode: message_decode$37,
  param_encode: param_encode$2,
  param_decode: param_decode$2,
  response_encode: response_encode$37,
  response_decode: response_decode$37
};

function message_encode$38(v) {
  return [
          "InitGoogleAuthFlow",
          Modal__WebAuth$SmartcutsMacros.Context.t_encode(v._0)
        ];
}

function message_decode$38(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "InitGoogleAuthFlow") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Modal__WebAuth$SmartcutsMacros.Context.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* InitGoogleAuthFlow */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$38(v) {
  if (v) {
    return [
            "GoogleAuthFlowDidGetOAuthToken",
            Decco.stringToJson(v._0)
          ];
  } else {
    return ["GoogleAuthFlowWasCanceledByUser"];
  }
}

function response_decode$38(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "GoogleAuthFlowDidGetOAuthToken" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* GoogleAuthFlowDidGetOAuthToken */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "GoogleAuthFlowWasCanceledByUser" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* GoogleAuthFlowWasCanceledByUser */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_InitGoogleAuthFlow = {
  message_encode: message_encode$38,
  message_decode: message_decode$38,
  response_encode: response_encode$38,
  response_decode: response_decode$38
};

function message_encode$39(v) {
  return ["UserDidCloseGoogleOAuthModal"];
}

function message_decode$39(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "UserDidCloseGoogleOAuthModal") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* UserDidCloseGoogleOAuthModal */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$39(v) {
  return ["AckUserDidCloseGoogleOAuthModal"];
}

function response_decode$39(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckUserDidCloseGoogleOAuthModal") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckUserDidCloseGoogleOAuthModal */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UserDidCloseGoogleOAuthModal = {
  message_encode: message_encode$39,
  message_decode: message_decode$39,
  response_encode: response_encode$39,
  response_decode: response_decode$39
};

function link_encode(v) {
  return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, v);
}

function submitForPlayback_encode(v) {
  return Js_dict.fromArray([
              [
                "executionSetId",
                Decco.stringToJson(v.executionSetId)
              ],
              [
                "userSpecifiedPlaybackOptions",
                PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__encode(v.userSpecifiedPlaybackOptions)
              ],
              [
                "credentialDbIdsByHostname",
                CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(UserCredential$SmartcutsMacros.DbId.id_encode, v.credentialDbIdsByHostname)
              ]
            ]);
}

function initWithSmartcutId_encode(v) {
  return Js_dict.fromArray([
              [
                "installedSmartcutId",
                SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v.installedSmartcutId)
              ],
              [
                "tabId",
                Decco.intToJson(v.tabId)
              ]
            ]);
}

function submitForPlayback_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var executionSetId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "executionSetId"), null));
  if (executionSetId.TAG === /* Ok */0) {
    var userSpecifiedPlaybackOptions = PlaybackOptions$SmartcutsMacros.UserSpecifiedPlaybackOptions.t__decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "userSpecifiedPlaybackOptions"), null));
    if (userSpecifiedPlaybackOptions.TAG === /* Ok */0) {
      var credentialDbIdsByHostname = CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(UserCredential$SmartcutsMacros.DbId.id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "credentialDbIdsByHostname"), null));
      if (credentialDbIdsByHostname.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  executionSetId: executionSetId._0,
                  userSpecifiedPlaybackOptions: userSpecifiedPlaybackOptions._0,
                  credentialDbIdsByHostname: credentialDbIdsByHostname._0
                }
              };
      }
      var e = credentialDbIdsByHostname._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".credentialDbIdsByHostname" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = userSpecifiedPlaybackOptions._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".userSpecifiedPlaybackOptions" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = executionSetId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".executionSetId" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function initWithSmartcutId_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var installedSmartcutId = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "installedSmartcutId"), null));
  if (installedSmartcutId.TAG === /* Ok */0) {
    var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
    if (tabId.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                installedSmartcutId: installedSmartcutId._0,
                tabId: tabId._0
              }
            };
    }
    var e = tabId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".tabId" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = installedSmartcutId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".installedSmartcutId" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function link_decode(v) {
  return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, v);
}

function message_encode$40(v) {
  if (typeof v === "number") {
    return ["Cancel"];
  }
  switch (v.TAG | 0) {
    case /* InitWithSmartcutId */0 :
        return [
                "InitWithSmartcutId",
                initWithSmartcutId_encode(v._0)
              ];
    case /* UpdateLinks */1 :
        return [
                "UpdateLinks",
                Decco.arrayToJson(link_encode, v._0)
              ];
    case /* UpdateLinkAtIndex */2 :
        return [
                "UpdateLinkAtIndex",
                Decco.intToJson(v._0),
                MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, v._1)
              ];
    case /* SubmitForPlayback */3 :
        return [
                "SubmitForPlayback",
                submitForPlayback_encode(v._0)
              ];
    
  }
}

function message_decode$40(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Cancel" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Cancel */0
                  };
          }
      case "InitWithSmartcutId" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = initWithSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InitWithSmartcutId */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SubmitForPlayback" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = submitForPlayback_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SubmitForPlayback */3,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "UpdateLinkAtIndex" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var v$1 = Belt_Array.getExn(jsonArr$1, 2);
          var match$2 = MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, v$1);
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* UpdateLinkAtIndex */2,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$2 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "UpdateLinks" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.arrayFromJson(link_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UpdateLinks */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$4 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$40(v) {
  return ["Ok"];
}

function response_decode$40(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "Ok") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* Ok */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_MultiUrlTriggering = {
  message_encode: message_encode$40,
  message_decode: message_decode$40,
  initWithSmartcutId_encode: initWithSmartcutId_encode,
  initWithSmartcutId_decode: initWithSmartcutId_decode,
  submitForPlayback_encode: submitForPlayback_encode,
  submitForPlayback_decode: submitForPlayback_decode,
  link_encode: link_encode,
  link_decode: link_decode,
  response_encode: response_encode$40,
  response_decode: response_decode$40
};

function message_encode$41(v) {
  if (typeof v === "number") {
    if (v === /* FetchCandidateChains */0) {
      return ["FetchCandidateChains"];
    } else {
      return ["StopDebug"];
    }
  } else if (v.TAG === /* GoToStep */0) {
    return [
            "GoToStep",
            Decco.intToJson(v._0)
          ];
  } else {
    return [
            "HighlightCandidateChain",
            Decco.intToJson(v._0)
          ];
  }
}

function message_decode$41(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "FetchCandidateChains" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* FetchCandidateChains */0
                  };
          }
      case "GoToStep" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* GoToStep */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "HighlightCandidateChain" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* HighlightCandidateChain */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "StopDebug" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* StopDebug */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$41(v) {
  if (v) {
    return [
            "DidFetchCandidateChains",
            Decco.arrayToJson(Query$SmartcutsMacros.candidateBranch_encode, v._0)
          ];
  } else {
    return ["Ok"];
  }
}

function response_decode$41(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidFetchCandidateChains" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson(Query$SmartcutsMacros.candidateBranch_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidFetchCandidateChains */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Ok" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Ok */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_DebugSelector = {
  message_encode: message_encode$41,
  message_decode: message_decode$41,
  response_encode: response_encode$41,
  response_decode: response_decode$41
};

function message_encode$42(v) {
  return ["StopPlayback"];
}

function message_decode$42(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "StopPlayback") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* StopPlayback */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$42(v) {
  return ["Ok"];
}

function response_decode$42(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "Ok") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* Ok */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_PlaybackModeControl = {
  message_encode: message_encode$42,
  message_decode: message_decode$42,
  response_encode: response_encode$42,
  response_decode: response_decode$42
};

function message_encode$43(v) {
  return [
          "AskBgToUpdateLinkGroups",
          MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_encode(v._0)
        ];
}

function message_decode$43(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToUpdateLinkGroups") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToUpdateLinkGroups */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$43(v) {
  return ["AckUpdateLinkGroups"];
}

function response_decode$43(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckUpdateLinkGroups") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckUpdateLinkGroups */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_AskBgToUpdateLinkGroups = {
  message_encode: message_encode$43,
  message_decode: message_decode$43,
  response_encode: response_encode$43,
  response_decode: response_decode$43
};

function message_encode$44(v) {
  return [
          "AskBgToRecordPageAction",
          MultiUrlTriggering__Shared$SmartcutsMacros.pageAction_encode(v._0)
        ];
}

function message_decode$44(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToRecordPageAction") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = MultiUrlTriggering__Shared$SmartcutsMacros.pageAction_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToRecordPageAction */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$44(v) {
  return ["AckAskBgToRecordPageAction"];
}

function response_decode$44(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckAskBgToRecordPageAction") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckAskBgToRecordPageAction */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_AskBgToRecordPageAction = {
  message_encode: message_encode$44,
  message_decode: message_decode$44,
  response_encode: response_encode$44,
  response_decode: response_decode$44
};

function message_encode$45(v) {
  return [
          "AskBgToStopRecordPageAction",
          MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.t_encode(v._0)
        ];
}

function message_decode$45(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToStopRecordPageAction") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToStopRecordPageAction */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$45(v) {
  return ["AckAskBgToStopRecordPageAction"];
}

function response_decode$45(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckAskBgToStopRecordPageAction") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckAskBgToStopRecordPageAction */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_AskBgToStopRecordPageAction = {
  message_encode: message_encode$45,
  message_decode: message_decode$45,
  response_encode: response_encode$45,
  response_decode: response_decode$45
};

function message_encode$46(v) {
  return [
          "AskBgToPlaybackPageActionUntil",
          MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_encode(v._0)
        ];
}

function message_decode$46(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToPlaybackPageActionUntil") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToPlaybackPageActionUntil */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$46(v) {
  return ["AckAskBgToPlaybackPageAction"];
}

function response_decode$46(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckAskBgToPlaybackPageAction") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckAskBgToPlaybackPageAction */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_AskBgToPlaybackPageAction = {
  message_encode: message_encode$46,
  message_decode: message_decode$46,
  response_encode: response_encode$46,
  response_decode: response_decode$46
};

function message_encode$47(v) {
  if (v) {
    return ["AskBgToPlaybackPageActionFinished"];
  } else {
    return ["NotifyBgAboutToStartSinglePageAction"];
  }
}

function message_decode$47(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AskBgToPlaybackPageActionFinished" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AskBgToPlaybackPageActionFinished */1
                  };
          }
      case "NotifyBgAboutToStartSinglePageAction" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotifyBgAboutToStartSinglePageAction */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$47(v) {
  if (v) {
    return ["AckAskBgToPlaybackPageActionFinished"];
  } else {
    return ["AckNotifyBgAboutToStartSinglePageAction"];
  }
}

function response_decode$47(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AckAskBgToPlaybackPageActionFinished" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AckAskBgToPlaybackPageActionFinished */1
                  };
          }
      case "AckNotifyBgAboutToStartSinglePageAction" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AckNotifyBgAboutToStartSinglePageAction */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_DidFinishPlaybackPageAction = {
  message_encode: message_encode$47,
  message_decode: message_decode$47,
  response_encode: response_encode$47,
  response_decode: response_decode$47
};

function message_encode$48(v) {
  return [
          "AskBgToShowLinkWithId",
          Decco.stringToJson(v._0)
        ];
}

function message_decode$48(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToShowLinkWithId") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToShowLinkWithId */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$48(v) {
  return ["AckAskBgToShowLinkWithId"];
}

function response_decode$48(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckAskBgToShowLinkWithId") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckAskBgToShowLinkWithId */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_AskBgToShowLinkWithId = {
  message_encode: message_encode$48,
  message_decode: message_decode$48,
  response_encode: response_encode$48,
  response_decode: response_decode$48
};

function message_encode$49(v) {
  return ["AskBgToSaveUrlTriggeringAsSmartcut"];
}

function message_decode$49(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToSaveUrlTriggeringAsSmartcut") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToSaveUrlTriggeringAsSmartcut */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$49(v) {
  return ["AckAskBgToSaveUrlTriggeringAsSmartcut"];
}

function response_decode$49(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckAskBgToSaveUrlTriggeringAsSmartcut") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckAskBgToSaveUrlTriggeringAsSmartcut */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut = {
  message_encode: message_encode$49,
  message_decode: message_decode$49,
  response_encode: response_encode$49,
  response_decode: response_decode$49
};

function message_encode$50(v) {
  return ["MaybeReadyToPlaybackPagination"];
}

function message_decode$50(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "MaybeReadyToPlaybackPagination") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* MaybeReadyToPlaybackPagination */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$50(v) {
  return ["AckMaybeReadyToPlaybackPagination"];
}

function response_decode$50(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckMaybeReadyToPlaybackPagination") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckMaybeReadyToPlaybackPagination */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_MaybeReadyToPlaybackPagination = {
  message_encode: message_encode$50,
  message_decode: message_decode$50,
  response_encode: response_encode$50,
  response_decode: response_decode$50
};

function message_encode$51(v) {
  return [
          "AskBgToUpdatePaginateFn",
          MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.t_encode(v._0)
        ];
}

function message_decode$51(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToUpdatePaginateFn") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToUpdatePaginateFn */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$51(v) {
  return ["AckAskBgToUpdatePaginateFn"];
}

function response_decode$51(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckAskBgToUpdatePaginateFn") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckAskBgToUpdatePaginateFn */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_AskBgToUpdatePaginateFn = {
  message_encode: message_encode$51,
  message_decode: message_decode$51,
  response_encode: response_encode$51,
  response_decode: response_decode$51
};

function message_encode$52(v) {
  return [
          "AskBgToFocusTab",
          Decco.intToJson(v._0)
        ];
}

function message_decode$52(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToFocusTab") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToFocusTab */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$52(v) {
  return ["AckAskBgToFocusTab"];
}

function response_decode$52(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckAskBgToFocusTab") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckAskBgToFocusTab */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToFocusTab = {
  message_encode: message_encode$52,
  message_decode: message_decode$52,
  response_encode: response_encode$52,
  response_decode: response_decode$52
};

function message_encode$53(v) {
  return [
          "AskBgToFocusWindow",
          Decco.intToJson(v._0)
        ];
}

function message_decode$53(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToFocusWindow") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToFocusWindow */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$53(v) {
  return ["AckAskBgToFocusWindow"];
}

function response_decode$53(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckAskBgToFocusWindow") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckAskBgToFocusWindow */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToFocusWindow = {
  message_encode: message_encode$53,
  message_decode: message_decode$53,
  response_encode: response_encode$53,
  response_decode: response_decode$53
};

function message_encode$54(v) {
  return [
          "GetProgressBySmartcutId",
          SmartcutIds$SmartcutsMacros.recordedSmartcutId_encode(v._0)
        ];
}

function message_decode$54(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GetProgressBySmartcutId") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = SmartcutIds$SmartcutsMacros.recordedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* GetProgressBySmartcutId */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$54(v) {
  if (v) {
    return [
            "ProgressInPercent",
            Decco.intToJson(v._0)
          ];
  } else {
    return ["ProgressNotFound"];
  }
}

function response_decode$54(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ProgressInPercent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* ProgressInPercent */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ProgressNotFound" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ProgressNotFound */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_SmartcutSavingProgress = {
  message_encode: message_encode$54,
  message_decode: message_decode$54,
  response_encode: response_encode$54,
  response_decode: response_decode$54
};

function message_encode$55(v) {
  return [
          "RequestPermissions",
          Decco.arrayToJson(PermissionAndOrigin$SmartcutsMacros.t_encode, v._0),
          PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.t_encode(v._1)
        ];
}

function message_decode$55(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "RequestPermissions") {
    if (tagged.length !== 3) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var match$1 = Decco.arrayFromJson(PermissionAndOrigin$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 1));
    var match$2 = PermissionAndOrigin$SmartcutsMacros.PermissionTrigger.t_decode(Belt_Array.getExn(jsonArr$1, 2));
    if (match$1.TAG === /* Ok */0) {
      if (match$2.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: /* RequestPermissions */{
                  _0: match$1._0,
                  _1: match$2._0
                }
              };
      }
      var e = match$2._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = match$1._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$55(v) {
  return ["DidRequestPermissions"];
}

function response_decode$55(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidRequestPermissions") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* DidRequestPermissions */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_RequestPermissions = {
  message_encode: message_encode$55,
  message_decode: message_decode$55,
  response_encode: response_encode$55,
  response_decode: response_decode$55
};

function message_encode$56(v) {
  if (v) {
    return [
            "ConfirmedToRunFirstNExecutions",
            Decco.intToJson(v._0)
          ];
  } else {
    return ["Canceled"];
  }
}

function message_decode$56(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Canceled" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Canceled */0
                  };
          }
      case "ConfirmedToRunFirstNExecutions" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* ConfirmedToRunFirstNExecutions */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$56(v) {
  return ["AckConfirmExecutionQuotaResult"];
}

function response_decode$56(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckConfirmExecutionQuotaResult") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckConfirmExecutionQuotaResult */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_NotifyConfirmExecutionQuotaResult = {
  message_encode: message_encode$56,
  message_decode: message_decode$56,
  response_encode: response_encode$56,
  response_decode: response_decode$56
};

function trackWithSegmentInTab_encode(v) {
  switch (v.TAG | 0) {
    case /* TrackQuotaWarning */0 :
        return [
                "TrackQuotaWarning",
                Segment__TrackedQuotaWarning$SmartcutsMacros.t_encode(v._0)
              ];
    case /* TrackClickOnViewPlans */1 :
        return [
                "TrackClickOnViewPlans",
                Segment__TrackedClickOnViewPlans$SmartcutsMacros.t_encode(v._0)
              ];
    case /* TrackGoToChromeStorePageToWriteReview */2 :
        return [
                "TrackGoToChromeStorePageToWriteReview",
                Segment__TrackedQuotaWarning$SmartcutsMacros.t_encode(v._0)
              ];
    case /* TrackAdjustAndPlaybackAfterQuotaWarningModal */3 :
        return [
                "TrackAdjustAndPlaybackAfterQuotaWarningModal",
                Segment__TrackedQuotaWarning$SmartcutsMacros.t_encode(v._0)
              ];
    case /* TrackCloseQuotaWarningModal */4 :
        return [
                "TrackCloseQuotaWarningModal",
                Segment__TrackedQuotaWarning$SmartcutsMacros.t_encode(v._0)
              ];
    
  }
}

function trackWithSegmentInTab_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "TrackAdjustAndPlaybackAfterQuotaWarningModal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Segment__TrackedQuotaWarning$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TrackAdjustAndPlaybackAfterQuotaWarningModal */3,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "TrackClickOnViewPlans" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Segment__TrackedClickOnViewPlans$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TrackClickOnViewPlans */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "TrackCloseQuotaWarningModal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Segment__TrackedQuotaWarning$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TrackCloseQuotaWarningModal */4,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "TrackGoToChromeStorePageToWriteReview" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Segment__TrackedQuotaWarning$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TrackGoToChromeStorePageToWriteReview */2,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "TrackQuotaWarning" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Segment__TrackedQuotaWarning$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TrackQuotaWarning */0,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function message_encode$57(v) {
  return [
          "TrackWithSegment",
          trackWithSegmentInTab_encode(v._0)
        ];
}

function message_decode$57(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "TrackWithSegment") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = trackWithSegmentInTab_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* TrackWithSegment */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$57(v) {
  return ["BgDidTrackWithSegment"];
}

function response_decode$57(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "BgDidTrackWithSegment") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* BgDidTrackWithSegment */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_TrackWithSegment = {
  trackWithSegmentInTab_encode: trackWithSegmentInTab_encode,
  trackWithSegmentInTab_decode: trackWithSegmentInTab_decode,
  message_encode: message_encode$57,
  message_decode: message_decode$57,
  response_encode: response_encode$57,
  response_decode: response_decode$57
};

function message_encode$58(v) {
  return ["UserReadyLogInToWebsite"];
}

function message_decode$58(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "UserReadyLogInToWebsite") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* UserReadyLogInToWebsite */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$58(v) {
  return ["AckUserReadyLogInToWebsite"];
}

function response_decode$58(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckUserReadyLogInToWebsite") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckUserReadyLogInToWebsite */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UserReadyLogInToWebsite = {
  message_encode: message_encode$58,
  message_decode: message_decode$58,
  response_encode: response_encode$58,
  response_decode: response_decode$58
};

var include = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});

var t_encode = include.t_encode;

var t_decode = include.t_decode;

function stringify(params) {
  return JSON.stringify(Curry._1(t_encode, params));
}

var Params = {
  t_encode: t_encode,
  t_decode: t_decode,
  stringify: stringify
};

function message_encode$59(v) {
  return [
          "OpenNewWindow",
          Curry._1(t_encode, v._0)
        ];
}

function message_decode$59(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "OpenNewWindow") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Curry._1(t_decode, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* OpenNewWindow */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$59(v) {
  return ["AckOpenNewWindow"];
}

function response_decode$59(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckOpenNewWindow") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckOpenNewWindow */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_OpenNewWindow = {
  Params: Params,
  message_encode: message_encode$59,
  message_decode: message_decode$59,
  response_encode: response_encode$59,
  response_decode: response_decode$59
};

function message_encode$60(v) {
  return [
          "StoreAuthStatusItem",
          Decco.stringToJson(v._0),
          Decco.stringToJson(v._1)
        ];
}

function message_decode$60(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "StoreAuthStatusItem") {
    if (tagged.length !== 3) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
    var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
    if (match$1.TAG === /* Ok */0) {
      if (match$2.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: /* StoreAuthStatusItem */{
                  _0: match$1._0,
                  _1: match$2._0
                }
              };
      }
      var e = match$2._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = match$1._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$60(v) {
  return ["AckStoreAuthStatusItem"];
}

function response_decode$60(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckStoreAuthStatusItem") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckStoreAuthStatusItem */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_StoreAuthStatusItem = {
  message_encode: message_encode$60,
  message_decode: message_decode$60,
  response_encode: response_encode$60,
  response_decode: response_decode$60
};

function message_encode$61(v) {
  return [
          "AskBgToHighlightElement",
          HighlightElement__Shared$SmartcutsMacros.Callback.t_encode(v._0)
        ];
}

function message_decode$61(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToHighlightElement") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = HighlightElement__Shared$SmartcutsMacros.Callback.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToHighlightElement */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$61(v) {
  return ["AckHighlightElement"];
}

function response_decode$61(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckHighlightElement") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckHighlightElement */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToHighlightElement = {
  message_encode: message_encode$61,
  message_decode: message_decode$61,
  response_encode: response_encode$61,
  response_decode: response_decode$61
};

function message_encode$62(v) {
  return [
          "DidCloseExplainModalAndAskBgToHighlightElement",
          Decco.boolToJson(v._0)
        ];
}

function message_decode$62(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidCloseExplainModalAndAskBgToHighlightElement") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.boolFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* DidCloseExplainModalAndAskBgToHighlightElement */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$62(v) {
  return ["AckDidCloseExplainModalAndAskBgToHighlightElement"];
}

function response_decode$62(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckDidCloseExplainModalAndAskBgToHighlightElement") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckDidCloseExplainModalAndAskBgToHighlightElement */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_DidCloseExplainModalAndAskBgToHighlightElement = {
  message_encode: message_encode$62,
  message_decode: message_decode$62,
  response_encode: response_encode$62,
  response_decode: response_decode$62
};

function message_encode$63(v) {
  if (v) {
    return [
            "PopupAskBgToStopHighlightElementOnTab",
            Decco.intToJson(v._0)
          ];
  } else {
    return ["TabAskBgToStopHighlightElement"];
  }
}

function message_decode$63(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "PopupAskBgToStopHighlightElementOnTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* PopupAskBgToStopHighlightElementOnTab */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "TabAskBgToStopHighlightElement" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TabAskBgToStopHighlightElement */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$63(v) {
  return ["DidTeardownHighlightElementControl"];
}

function response_decode$63(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidTeardownHighlightElementControl") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* DidTeardownHighlightElementControl */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToStopHighlightElement = {
  message_encode: message_encode$63,
  message_decode: message_decode$63,
  response_encode: response_encode$63,
  response_decode: response_decode$63
};

function message_encode$64(v) {
  return ["GetUserCredentials"];
}

function message_decode$64(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GetUserCredentials") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* GetUserCredentials */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function vaultStatus_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "HasAskedTabToUnlockVault" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* HasAskedTabToUnlockVault */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "VaultLocked" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* VaultLocked */1
                  };
          }
      case "VaultUnlocked" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* VaultUnlocked */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function vaultStatus_encode(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["VaultLocked"];
    } else {
      return ["VaultUnlocked"];
    }
  } else {
    return [
            "HasAskedTabToUnlockVault",
            Decco.intToJson(v._0)
          ];
  }
}

function didGetUserCredentials_encode(v) {
  return Js_dict.fromArray([
              [
                "credentials",
                Decco.arrayToJson(UserCredential$SmartcutsMacros.WithReEntryStatusAndOAuthProviderCredential.t_encode, v.credentials)
              ],
              [
                "vaultStatus",
                vaultStatus_encode(v.vaultStatus)
              ]
            ]);
}

function didGetUserCredentials_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var credentials = Decco.arrayFromJson(UserCredential$SmartcutsMacros.WithReEntryStatusAndOAuthProviderCredential.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "credentials"), null));
  if (credentials.TAG === /* Ok */0) {
    var vaultStatus = vaultStatus_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vaultStatus"), null));
    if (vaultStatus.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                credentials: credentials._0,
                vaultStatus: vaultStatus._0
              }
            };
    }
    var e = vaultStatus._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vaultStatus" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = credentials._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".credentials" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function response_encode$64(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["VaultNotInitialized"];
    } else {
      return ["NotLoggedIn"];
    }
  } else {
    return [
            "DidGetUserCredentials",
            didGetUserCredentials_encode(v._0)
          ];
  }
}

function response_decode$64(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidGetUserCredentials" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = didGetUserCredentials_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidGetUserCredentials */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */0
                  };
          }
      case "VaultNotInitialized" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* VaultNotInitialized */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_GetUserCredentials = {
  message_encode: message_encode$64,
  message_decode: message_decode$64,
  response_encode: response_encode$64,
  response_decode: response_decode$64,
  didGetUserCredentials_encode: didGetUserCredentials_encode,
  didGetUserCredentials_decode: didGetUserCredentials_decode,
  vaultStatus_encode: vaultStatus_encode,
  vaultStatus_decode: vaultStatus_decode
};

function message_encode$65(v) {
  return [
          "UnlockVaultWithMasterSecret",
          MasterSecret$SmartcutsMacros.t_encode(v._0)
        ];
}

function message_decode$65(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "UnlockVaultWithMasterSecret") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = MasterSecret$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* UnlockVaultWithMasterSecret */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function error_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DeccoDecodeError" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DeccoDecodeError */3
                  };
          }
      case "IncorrectMasterSecret" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* IncorrectMasterSecret */1
                  };
          }
      case "KeyNotFound" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* KeyNotFound */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */4
                  };
          }
      case "UserCredentialsNotInitialized" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* UserCredentialsNotInitialized */0
                  };
          }
      case "VaultNotInitialized" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* VaultNotInitialized */2
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function error_encode(v) {
  if (typeof v !== "number") {
    return [
            "KeyNotFound",
            Decco.stringToJson(v._0)
          ];
  }
  switch (v) {
    case /* UserCredentialsNotInitialized */0 :
        return ["UserCredentialsNotInitialized"];
    case /* IncorrectMasterSecret */1 :
        return ["IncorrectMasterSecret"];
    case /* VaultNotInitialized */2 :
        return ["VaultNotInitialized"];
    case /* DeccoDecodeError */3 :
        return ["DeccoDecodeError"];
    case /* NotLoggedIn */4 :
        return ["NotLoggedIn"];
    
  }
}

function response_encode$65(v) {
  if (v) {
    return [
            "DidNotUnlockVault",
            error_encode(v._0)
          ];
  } else {
    return ["DidUnlockVaultWithMasterSecret"];
  }
}

function response_decode$65(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidNotUnlockVault" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = error_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotUnlockVault */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidUnlockVaultWithMasterSecret" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidUnlockVaultWithMasterSecret */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UnlockVaultWithMasterSecret = {
  message_encode: message_encode$65,
  message_decode: message_decode$65,
  response_encode: response_encode$65,
  response_decode: response_decode$65,
  error_encode: error_encode,
  error_decode: error_decode
};

function userCredentialsData_encode(v) {
  return Js_dict.fromArray([
              [
                "masterSecret",
                MasterSecret$SmartcutsMacros.t_encode(v.masterSecret)
              ],
              [
                "action",
                BgFx__UserCredentials__Shared$SmartcutsMacros.ModifyAction.t_encode(UserCredential__Shared$SmartcutsMacros.otherSecretData_encode, v.action)
              ]
            ]);
}

function userCredentialsData_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var masterSecret = MasterSecret$SmartcutsMacros.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "masterSecret"), null));
  if (masterSecret.TAG === /* Ok */0) {
    var action = BgFx__UserCredentials__Shared$SmartcutsMacros.ModifyAction.t_decode(UserCredential__Shared$SmartcutsMacros.otherSecretData_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "action"), null));
    if (action.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                masterSecret: masterSecret._0,
                action: action._0
              }
            };
    }
    var e = action._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".action" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = masterSecret._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".masterSecret" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function message_encode$66(v) {
  return [
          "ModifyUserCredentials",
          userCredentialsData_encode(v._0)
        ];
}

function message_decode$66(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ModifyUserCredentials") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = userCredentialsData_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ModifyUserCredentials */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function reason_encode(v) {
  if (typeof v === "number") {
    switch (v) {
      case /* IncorrectMasterSecret */0 :
          return ["IncorrectMasterSecret"];
      case /* VaultNotInitialized */1 :
          return ["VaultNotInitialized"];
      case /* VaultAlreadyExists */2 :
          return ["VaultAlreadyExists"];
      case /* DeccoDecodeError */3 :
          return ["DeccoDecodeError"];
      case /* NotLoggedIn */4 :
          return ["NotLoggedIn"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* FaunaGraphqlError */0 :
          return [
                  "FaunaGraphqlError",
                  DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.t_encode(v._0)
                ];
      case /* JsonDecodeError */1 :
          return [
                  "JsonDecodeError",
                  Decco.stringToJson(v._0)
                ];
      case /* KeyNotFound */2 :
          return [
                  "KeyNotFound",
                  Decco.stringToJson(v._0)
                ];
      
    }
  }
}

function reason_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DeccoDecodeError" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DeccoDecodeError */3
                  };
          }
      case "FaunaGraphqlError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FaunaGraphqlError */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "IncorrectMasterSecret" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* IncorrectMasterSecret */0
                  };
          }
      case "JsonDecodeError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* JsonDecodeError */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "KeyNotFound" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* KeyNotFound */2,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */4
                  };
          }
      case "VaultAlreadyExists" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* VaultAlreadyExists */2
                  };
          }
      case "VaultNotInitialized" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* VaultNotInitialized */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$66(v) {
  if (v.TAG === /* DidModifyUserCredentials */0) {
    return [
            "DidModifyUserCredentials",
            Curry._1(UserCredential$SmartcutsMacros.DbId.id_encode, v._0)
          ];
  } else {
    return [
            "DidNotModifyUserCredentials",
            reason_encode(v._0)
          ];
  }
}

function response_decode$66(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidModifyUserCredentials" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(UserCredential$SmartcutsMacros.DbId.id_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidModifyUserCredentials */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidNotModifyUserCredentials" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = reason_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidNotModifyUserCredentials */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_ModifyUserCredentials = {
  userCredentialsData_encode: userCredentialsData_encode,
  userCredentialsData_decode: userCredentialsData_decode,
  message_encode: message_encode$66,
  message_decode: message_decode$66,
  response_encode: response_encode$66,
  response_decode: response_decode$66,
  reason_encode: reason_encode,
  reason_decode: reason_decode
};

function message_encode$67(v) {
  return ["TabAskBgIfMasterSecretDoesExist"];
}

function message_decode$67(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "TabAskBgIfMasterSecretDoesExist") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* TabAskBgIfMasterSecretDoesExist */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$67(v) {
  if (v) {
    return ["MasterSecretDoesNotExist"];
  } else {
    return ["MasterSecretDoesExist"];
  }
}

function response_decode$67(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "MasterSecretDoesExist" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* MasterSecretDoesExist */0
                  };
          }
      case "MasterSecretDoesNotExist" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* MasterSecretDoesNotExist */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgIfMasterSecretDoesExist = {
  message_encode: message_encode$67,
  message_decode: message_decode$67,
  response_encode: response_encode$67,
  response_decode: response_decode$67
};

function message_encode$68(v) {
  return ["TabAskBgForMissingPasswords"];
}

function message_decode$68(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "TabAskBgForMissingPasswords") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* TabAskBgForMissingPasswords */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$68(v) {
  if (v) {
    return [
            "MissingPasswords",
            Decco.arrayToJson(UserCredential$SmartcutsMacros.DbId.id_encode, v._0)
          ];
  } else {
    return ["NoMissingPasswords"];
  }
}

function response_decode$68(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "MissingPasswords" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson(UserCredential$SmartcutsMacros.DbId.id_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* MissingPasswords */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NoMissingPasswords" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoMissingPasswords */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgForMissingPasswords = {
  message_encode: message_encode$68,
  message_decode: message_decode$68,
  response_encode: response_encode$68,
  response_decode: response_decode$68
};

function message_encode$69(v) {
  return [
          "AskBgToCreateVaultWithMasterSecret",
          MasterSecret$SmartcutsMacros.t_encode(v._0)
        ];
}

function message_decode$69(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToCreateVaultWithMasterSecret") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = MasterSecret$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToCreateVaultWithMasterSecret */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$69(v) {
  if (v) {
    return [
            "DidNotCreateVaultWithMasterSecret",
            BrowserVaultUnlocked$SmartcutsMacros.error_encode(v._0)
          ];
  } else {
    return ["DidCreateVaultWithMasterSecret"];
  }
}

function response_decode$69(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidCreateVaultWithMasterSecret" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidCreateVaultWithMasterSecret */0
                  };
          }
      case "DidNotCreateVaultWithMasterSecret" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = BrowserVaultUnlocked$SmartcutsMacros.error_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotCreateVaultWithMasterSecret */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function reason_encode$1(v) {
  return ["VaultAlreadyExists"];
}

function reason_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "VaultAlreadyExists") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* VaultAlreadyExists */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToCreateVaultWithMasterSecret = {
  message_encode: message_encode$69,
  message_decode: message_decode$69,
  response_encode: response_encode$69,
  response_decode: response_decode$69,
  reason_encode: reason_encode$1,
  reason_decode: reason_decode$1
};

function message_encode$70(v) {
  return [
          "AskBgToResetMasterSecret",
          MasterSecret$SmartcutsMacros.t_encode(v._0)
        ];
}

function message_decode$70(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToResetMasterSecret") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = MasterSecret$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToResetMasterSecret */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$70(v) {
  if (v) {
    return [
            "DidNotResetMasterSecret",
            Decco.stringToJson(v._0)
          ];
  } else {
    return ["DidResetMasterSecret"];
  }
}

function response_decode$70(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidNotResetMasterSecret" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotResetMasterSecret */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DidResetMasterSecret" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidResetMasterSecret */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToResetMasterSecret = {
  message_encode: message_encode$70,
  message_decode: message_decode$70,
  response_encode: response_encode$70,
  response_decode: response_decode$70
};

function detachLoginSmartcut_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var loginSmartcut = LoginSmartcut$SmartcutsMacros.SmartcutOrInstalledSmartcutPointer.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginSmartcut"), null));
  if (loginSmartcut.TAG === /* Ok */0) {
    var mainSmartcutId = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mainSmartcutId"), null));
    if (mainSmartcutId.TAG === /* Ok */0) {
      var hostname = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "hostname"), null));
      if (hostname.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  loginSmartcut: loginSmartcut._0,
                  mainSmartcutId: mainSmartcutId._0,
                  hostname: hostname._0
                }
              };
      }
      var e = hostname._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".hostname" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = mainSmartcutId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".mainSmartcutId" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = loginSmartcut._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".loginSmartcut" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function detachLoginSmartcut_encode(v) {
  return Js_dict.fromArray([
              [
                "loginSmartcut",
                LoginSmartcut$SmartcutsMacros.SmartcutOrInstalledSmartcutPointer.t_encode(v.loginSmartcut)
              ],
              [
                "mainSmartcutId",
                SmartcutIds$SmartcutsMacros.smartcutId_encode(v.mainSmartcutId)
              ],
              [
                "hostname",
                Decco.stringToJson(v.hostname)
              ]
            ]);
}

function message_encode$71(v) {
  return [
          "AskBgToDetachLoginSmartcut",
          detachLoginSmartcut_encode(v._0)
        ];
}

function message_decode$71(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToDetachLoginSmartcut") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = detachLoginSmartcut_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToDetachLoginSmartcut */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function reason_encode$2(v) {
  if (typeof v === "number") {
    if (v !== 0) {
      return ["CouldNotFindSmartcut"];
    } else {
      return ["NotLoggedIn"];
    }
  } else {
    return [
            "FaunaGraphqlError",
            DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.t_encode(v._0)
          ];
  }
}

function reason_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CouldNotFindSmartcut" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* CouldNotFindSmartcut */1
                  };
          }
      case "FaunaGraphqlError" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = DataStoreUtils$SmartcutsMacros.FaunaGraphqlError.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* FaunaGraphqlError */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NotLoggedIn" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotLoggedIn */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$71(v) {
  if (v) {
    return [
            "DidNotDetachLoginSmartcut",
            reason_encode$2(v._0)
          ];
  } else {
    return ["DidDetachLoginSmartcut"];
  }
}

function response_decode$71(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidDetachLoginSmartcut" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidDetachLoginSmartcut */0
                  };
          }
      case "DidNotDetachLoginSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = reason_decode$2(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotDetachLoginSmartcut */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToDetachLoginSmartcut = {
  message_encode: message_encode$71,
  message_decode: message_decode$71,
  detachLoginSmartcut_encode: detachLoginSmartcut_encode,
  detachLoginSmartcut_decode: detachLoginSmartcut_decode,
  response_encode: response_encode$71,
  response_decode: response_decode$71,
  reason_encode: reason_encode$2,
  reason_decode: reason_decode$2
};

function message_encode$72(v) {
  return ["AskBgToEnterDataExtractionMode"];
}

function message_decode$72(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToEnterDataExtractionMode") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToEnterDataExtractionMode */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$72(v) {
  if (v) {
    return ["BgCouldNotFindActiveTab"];
  } else {
    return ["DidEnterDataExtractionMode"];
  }
}

function response_decode$72(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BgCouldNotFindActiveTab" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BgCouldNotFindActiveTab */1
                  };
          }
      case "DidEnterDataExtractionMode" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidEnterDataExtractionMode */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToEnterDataExtractionMode = {
  message_encode: message_encode$72,
  message_decode: message_decode$72,
  response_encode: response_encode$72,
  response_decode: response_decode$72
};

function message_encode$73(v) {
  return [
          "AskBgToProcessDataExtractionSignal",
          Curry._1(DataExtraction$SmartcutsMacros.WebApi.Signal.t_encode, v._0)
        ];
}

function message_decode$73(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToProcessDataExtractionSignal") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Curry._1(DataExtraction$SmartcutsMacros.WebApi.Signal.t_decode, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToProcessDataExtractionSignal */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$73(v) {
  return [
          "DidProcessDataExtractionSignal",
          Curry._1(DataExtraction$SmartcutsMacros.WebApi.DataOutput.t_encode, v._0)
        ];
}

function response_decode$73(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidProcessDataExtractionSignal") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Curry._1(DataExtraction$SmartcutsMacros.WebApi.DataOutput.t_decode, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* DidProcessDataExtractionSignal */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToProcessDataExtractionSignal = {
  message_encode: message_encode$73,
  message_decode: message_decode$73,
  response_encode: response_encode$73,
  response_decode: response_decode$73
};

function message_encode$74(v) {
  return [
          "SaveDataExtractionAsSmartcut",
          Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_encode, v._0),
          CommandContext$SmartcutsMacros.commandContextLocal_encode(v._1)
        ];
}

function message_decode$74(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "SaveDataExtractionAsSmartcut") {
    if (tagged.length !== 3) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var match$1 = Curry._1(WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_decode, Belt_Array.getExn(jsonArr$1, 1));
    var match$2 = CommandContext$SmartcutsMacros.commandContextLocal_decode(Belt_Array.getExn(jsonArr$1, 2));
    if (match$1.TAG === /* Ok */0) {
      if (match$2.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: /* SaveDataExtractionAsSmartcut */{
                  _0: match$1._0,
                  _1: match$2._0
                }
              };
      }
      var e = match$2._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = match$1._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$74(v) {
  return ["AckSaveDataExtractionAsSmartcut"];
}

function response_decode$74(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckSaveDataExtractionAsSmartcut") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckSaveDataExtractionAsSmartcut */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToSaveDataExtractionAsSmartcut = {
  message_encode: message_encode$74,
  message_decode: message_decode$74,
  response_encode: response_encode$74,
  response_decode: response_decode$74
};

function message_encode$75(v) {
  return ["AskBgToExitFromDataExtractionMode"];
}

function message_decode$75(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToExitFromDataExtractionMode") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToExitFromDataExtractionMode */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$75(v) {
  return ["DidExitFromDataExtractionMode"];
}

function response_decode$75(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidExitFromDataExtractionMode") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* DidExitFromDataExtractionMode */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToExitFromDataExtractionMode = {
  message_encode: message_encode$75,
  message_decode: message_decode$75,
  response_encode: response_encode$75,
  response_decode: response_decode$75
};

function message_encode$76(v) {
  return [
          "AskBgToRenderNotification",
          RenderOnHost__Notification$SmartcutsMacros.t_encode(v._0)
        ];
}

function message_decode$76(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskBgToRenderNotification") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = RenderOnHost__Notification$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskBgToRenderNotification */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$76(v) {
  return ["DidRenderNotification"];
}

function response_decode$76(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidRenderNotification") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* DidRenderNotification */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskBgToRenderNotification = {
  message_encode: message_encode$76,
  message_decode: message_decode$76,
  response_encode: response_encode$76,
  response_decode: response_decode$76
};

function message_encode$77(v) {
  switch (v.TAG | 0) {
    case /* Message_ContentScriptReady */0 :
        return [
                "Message_ContentScriptReady",
                ["ContentScriptReady"]
              ];
    case /* Message_AskBgToRefreshAuthStatus */1 :
        return [
                "Message_AskBgToRefreshAuthStatus",
                ["AskBgToRefreshAuthStatus"]
              ];
    case /* Message_AskBgToFetchPlanSubscriptionProgress */2 :
        return [
                "Message_AskBgToFetchPlanSubscriptionProgress",
                ["AskBgToFetchPlanSubscriptionProgress"]
              ];
    case /* Message_StartDebugSelector */3 :
        return [
                "Message_StartDebugSelector",
                ["StartDebugSelector"]
              ];
    case /* Message_StartRecording */4 :
        return [
                "Message_StartRecording",
                message_encode$5(v._0)
              ];
    case /* Message_StopRecording */5 :
        return [
                "Message_StopRecording",
                ["StopRecording"]
              ];
    case /* Message_DidStartRecording */6 :
        return [
                "Message_DidStartRecording",
                ["DidStartRecording"]
              ];
    case /* Message_NotifyBgAboutPossibleCommand */7 :
        return [
                "Message_NotifyBgAboutPossibleCommand",
                message_encode$8(v._0)
              ];
    case /* Message_ClearKeyThatDoesNotGenerateCommand */8 :
        return [
                "Message_ClearKeyThatDoesNotGenerateCommand",
                message_encode$9(v._0)
              ];
    case /* Message_RecordCommand */9 :
        return [
                "Message_RecordCommand",
                message_encode$10(v._0)
              ];
    case /* Message_FinishAuthoring */10 :
        return [
                "Message_FinishAuthoring",
                message_encode$11(v._0)
              ];
    case /* Message_OpenPageForSmartcutId */11 :
        return [
                "Message_OpenPageForSmartcutId",
                message_encode$12(v._0)
              ];
    case /* Message_ShowFormForSmartcutId */12 :
        return [
                "Message_ShowFormForSmartcutId",
                message_encode$13(v._0)
              ];
    case /* Message_AskBgToAdjustModalGeometry */13 :
        return [
                "Message_AskBgToAdjustModalGeometry",
                message_encode$14(v._0)
              ];
    case /* Message_InitializePlayback */14 :
        return [
                "Message_InitializePlayback",
                message_encode$15(v._0)
              ];
    case /* Message_GetAuthoringCommandLog */15 :
        return [
                "Message_GetAuthoringCommandLog",
                message_encode$16(v._0)
              ];
    case /* Message_GetSmartcut */16 :
        return [
                "Message_GetSmartcut",
                message_encode$17(v._0)
              ];
    case /* Message_GetMySmartcuts */17 :
        return [
                "Message_GetMySmartcuts",
                ["GetMySmartcuts"]
              ];
    case /* Message_InstallSmartcut */18 :
        return [
                "Message_InstallSmartcut",
                message_encode$19(v._0)
              ];
    case /* Message_DeleteSmartcut */19 :
        return [
                "Message_DeleteSmartcut",
                message_encode$20(v._0)
              ];
    case /* Message_GetExecutionHistoryForSmartcut */20 :
        return [
                "Message_GetExecutionHistoryForSmartcut",
                message_encode$21(v._0)
              ];
    case /* Message_GetScheduledTriggersForSmartcut */21 :
        return [
                "Message_GetScheduledTriggersForSmartcut",
                message_encode$22(v._0)
              ];
    case /* Message_FindExecutionById */22 :
        return [
                "Message_FindExecutionById",
                message_encode$23(v._0)
              ];
    case /* Message_UpdateExecutionStatus */23 :
        return [
                "Message_UpdateExecutionStatus",
                message_encode$24(v._0)
              ];
    case /* Message_UpsertExecutionSet */24 :
        return [
                "Message_UpsertExecutionSet",
                message_encode$25(v._0)
              ];
    case /* Message_DeleteExecutionSet */25 :
        return [
                "Message_DeleteExecutionSet",
                message_encode$26(v._0)
              ];
    case /* Message_GetExecutionSetProgress */26 :
        return [
                "Message_GetExecutionSetProgress",
                ["GetExecutionSetProgress"]
              ];
    case /* Message_GetExecutionSetById */27 :
        return [
                "Message_GetExecutionSetById",
                message_encode$28(v._0)
              ];
    case /* Message_UpsertScheduledTriggerAndCreateAlarm */28 :
        return [
                "Message_UpsertScheduledTriggerAndCreateAlarm",
                message_encode$29(v._0)
              ];
    case /* Message_ArchiveScheduledTrigger */29 :
        return [
                "Message_ArchiveScheduledTrigger",
                message_encode$30(v._0)
              ];
    case /* Message_SaveExternalAccount */30 :
        return [
                "Message_SaveExternalAccount",
                message_encode$31(v._0)
              ];
    case /* Message_FindExternalAccountById */31 :
        return [
                "Message_FindExternalAccountById",
                message_encode$32(v._0)
              ];
    case /* Message_GetOAuthToken */32 :
        return [
                "Message_GetOAuthToken",
                message_encode$33(v._0)
              ];
    case /* Message_AskBgToClipboard */33 :
        return [
                "Message_AskBgToClipboard",
                message_encode$34(v._0)
              ];
    case /* Message_CreateGoogleSheet */34 :
        return [
                "Message_CreateGoogleSheet",
                message_encode$35(v._0)
              ];
    case /* Message_FetchGoogleSheet */35 :
        return [
                "Message_FetchGoogleSheet",
                message_encode$36(v._0)
              ];
    case /* Message_BatchUpdateGoogleSheet */36 :
        return [
                "Message_BatchUpdateGoogleSheet",
                message_encode$37(v._0)
              ];
    case /* Message_InitGoogleAuthFlow */37 :
        return [
                "Message_InitGoogleAuthFlow",
                message_encode$38(v._0)
              ];
    case /* Message_UserDidCloseGoogleOAuthModal */38 :
        return [
                "Message_UserDidCloseGoogleOAuthModal",
                ["UserDidCloseGoogleOAuthModal"]
              ];
    case /* Message_MultiUrlTriggering */39 :
        return [
                "Message_MultiUrlTriggering",
                message_encode$40(v._0)
              ];
    case /* Message_DebugSelector */40 :
        return [
                "Message_DebugSelector",
                message_encode$41(v._0)
              ];
    case /* Message_PlaybackModeControl */41 :
        return [
                "Message_PlaybackModeControl",
                ["StopPlayback"]
              ];
    case /* Message_UrlTriggering_AskBgToUpdateLinkGroups */42 :
        return [
                "Message_UrlTriggering_AskBgToUpdateLinkGroups",
                message_encode$43(v._0)
              ];
    case /* Message_UrlTriggering_AskBgToRecordPageAction */43 :
        return [
                "Message_UrlTriggering_AskBgToRecordPageAction",
                message_encode$44(v._0)
              ];
    case /* Message_UrlTriggering_AskBgToStopRecordPageAction */44 :
        return [
                "Message_UrlTriggering_AskBgToStopRecordPageAction",
                message_encode$45(v._0)
              ];
    case /* Message_UrlTriggering_AskBgToUpdatePaginateFn */45 :
        return [
                "Message_UrlTriggering_AskBgToUpdatePaginateFn",
                message_encode$51(v._0)
              ];
    case /* Message_UrlTriggering_AskBgToPlaybackPageAction */46 :
        return [
                "Message_UrlTriggering_AskBgToPlaybackPageAction",
                message_encode$46(v._0)
              ];
    case /* Message_UrlTriggering_DidFinishPlaybackPageAction */47 :
        return [
                "Message_UrlTriggering_DidFinishPlaybackPageAction",
                message_encode$47(v._0)
              ];
    case /* Message_UrlTriggering_AskBgToShowLinkWithId */48 :
        return [
                "Message_UrlTriggering_AskBgToShowLinkWithId",
                message_encode$48(v._0)
              ];
    case /* Message_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut */49 :
        return [
                "Message_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut",
                ["AskBgToSaveUrlTriggeringAsSmartcut"]
              ];
    case /* Message_UrlTriggering_MaybeReadyToPlaybackPagination */50 :
        return [
                "Message_UrlTriggering_MaybeReadyToPlaybackPagination",
                ["MaybeReadyToPlaybackPagination"]
              ];
    case /* Message_AskBgToFocusTab */51 :
        return [
                "Message_AskBgToFocusTab",
                message_encode$52(v._0)
              ];
    case /* Message_AskBgToFocusWindow */52 :
        return [
                "Message_AskBgToFocusWindow",
                message_encode$53(v._0)
              ];
    case /* Message_SmartcutSavingProgress */53 :
        return [
                "Message_SmartcutSavingProgress",
                message_encode$54(v._0)
              ];
    case /* Message_RequestPermissions */54 :
        return [
                "Message_RequestPermissions",
                message_encode$55(v._0)
              ];
    case /* Message_NotifyConfirmExecutionQuotaResult */55 :
        return [
                "Message_NotifyConfirmExecutionQuotaResult",
                message_encode$56(v._0)
              ];
    case /* Message_TrackWithSegment */56 :
        return [
                "Message_TrackWithSegment",
                message_encode$57(v._0)
              ];
    case /* Message_UserReadyLogInToWebsite */57 :
        return [
                "Message_UserReadyLogInToWebsite",
                ["UserReadyLogInToWebsite"]
              ];
    case /* Message_OpenNewWindow */58 :
        return [
                "Message_OpenNewWindow",
                message_encode$59(v._0)
              ];
    case /* Message_StoreAuthStatusItem */59 :
        return [
                "Message_StoreAuthStatusItem",
                message_encode$60(v._0)
              ];
    case /* Message_AskBgToHighlightElement */60 :
        return [
                "Message_AskBgToHighlightElement",
                message_encode$61(v._0)
              ];
    case /* Message_DidCloseExplainModalAndAskBgToHighlightElement */61 :
        return [
                "Message_DidCloseExplainModalAndAskBgToHighlightElement",
                message_encode$62(v._0)
              ];
    case /* Message_AskBgToStopHighlightElement */62 :
        return [
                "Message_AskBgToStopHighlightElement",
                message_encode$63(v._0)
              ];
    case /* Message_GetUserCredentials */63 :
        return [
                "Message_GetUserCredentials",
                ["GetUserCredentials"]
              ];
    case /* Message_UnlockVaultWithMasterSecret */64 :
        return [
                "Message_UnlockVaultWithMasterSecret",
                message_encode$65(v._0)
              ];
    case /* Message_ModifyUserCredentials */65 :
        return [
                "Message_ModifyUserCredentials",
                message_encode$66(v._0)
              ];
    case /* Message_AskBgIfMasterSecretDoesExist */66 :
        return [
                "Message_AskBgIfMasterSecretDoesExist",
                ["TabAskBgIfMasterSecretDoesExist"]
              ];
    case /* Message_AskBgForMissingPasswords */67 :
        return [
                "Message_AskBgForMissingPasswords",
                ["TabAskBgForMissingPasswords"]
              ];
    case /* Message_AskBgToCreateVaultWithMasterSecret */68 :
        return [
                "Message_AskBgToCreateVaultWithMasterSecret",
                message_encode$69(v._0)
              ];
    case /* Message_AskBgToResetMasterSecret */69 :
        return [
                "Message_AskBgToResetMasterSecret",
                message_encode$70(v._0)
              ];
    case /* Message_AskBgToDetachLoginSmartcut */70 :
        return [
                "Message_AskBgToDetachLoginSmartcut",
                message_encode$71(v._0)
              ];
    case /* Message_AskBgToEnterDataExtractionMode */71 :
        return [
                "Message_AskBgToEnterDataExtractionMode",
                ["AskBgToEnterDataExtractionMode"]
              ];
    case /* Message_AskBgToProcessDataExtractionSignal */72 :
        return [
                "Message_AskBgToProcessDataExtractionSignal",
                message_encode$73(v._0)
              ];
    case /* Message_AskBgToExitFromDataExtractionMode */73 :
        return [
                "Message_AskBgToExitFromDataExtractionMode",
                ["AskBgToExitFromDataExtractionMode"]
              ];
    case /* Message_AskBgToSaveDataExtractionAsSmartcut */74 :
        return [
                "Message_AskBgToSaveDataExtractionAsSmartcut",
                message_encode$74(v._0)
              ];
    case /* Message_AskBgToRenderNotification */75 :
        return [
                "Message_AskBgToRenderNotification",
                message_encode$76(v._0)
              ];
    
  }
}

function message_decode$77(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Message_ArchiveScheduledTrigger" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = message_decode$30(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_ArchiveScheduledTrigger */29,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Message_AskBgForMissingPasswords" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = message_decode$68(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgForMissingPasswords */67,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Message_AskBgIfMasterSecretDoesExist" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = message_decode$67(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgIfMasterSecretDoesExist */66,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Message_AskBgToAdjustModalGeometry" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = message_decode$14(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToAdjustModalGeometry */13,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Message_AskBgToClipboard" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = message_decode$34(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToClipboard */33,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "Message_AskBgToCreateVaultWithMasterSecret" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = message_decode$69(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToCreateVaultWithMasterSecret */68,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "Message_AskBgToDetachLoginSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = message_decode$71(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToDetachLoginSmartcut */70,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "Message_AskBgToEnterDataExtractionMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = message_decode$72(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToEnterDataExtractionMode */71,
                      _0: v0$7._0
                    }
                  };
          }
          var e$7 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "Message_AskBgToExitFromDataExtractionMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = message_decode$75(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToExitFromDataExtractionMode */73,
                      _0: v0$8._0
                    }
                  };
          }
          var e$8 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "Message_AskBgToFetchPlanSubscriptionProgress" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = message_decode$3(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToFetchPlanSubscriptionProgress */2,
                      _0: v0$9._0
                    }
                  };
          }
          var e$9 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "Message_AskBgToFocusTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = message_decode$52(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToFocusTab */51,
                      _0: v0$10._0
                    }
                  };
          }
          var e$10 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "Message_AskBgToFocusWindow" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$11 = message_decode$53(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$11.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToFocusWindow */52,
                      _0: v0$11._0
                    }
                  };
          }
          var e$11 = v0$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "Message_AskBgToHighlightElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$12 = message_decode$61(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$12.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToHighlightElement */60,
                      _0: v0$12._0
                    }
                  };
          }
          var e$12 = v0$12._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "Message_AskBgToProcessDataExtractionSignal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$13 = message_decode$73(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$13.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToProcessDataExtractionSignal */72,
                      _0: v0$13._0
                    }
                  };
          }
          var e$13 = v0$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "Message_AskBgToRefreshAuthStatus" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$14 = message_decode$2(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$14.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToRefreshAuthStatus */1,
                      _0: v0$14._0
                    }
                  };
          }
          var e$14 = v0$14._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "Message_AskBgToRenderNotification" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$15 = message_decode$76(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$15.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToRenderNotification */75,
                      _0: v0$15._0
                    }
                  };
          }
          var e$15 = v0$15._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      case "Message_AskBgToResetMasterSecret" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$16 = message_decode$70(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$16.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToResetMasterSecret */69,
                      _0: v0$16._0
                    }
                  };
          }
          var e$16 = v0$16._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
      case "Message_AskBgToSaveDataExtractionAsSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$17 = message_decode$74(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$17.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToSaveDataExtractionAsSmartcut */74,
                      _0: v0$17._0
                    }
                  };
          }
          var e$17 = v0$17._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "Message_AskBgToStopHighlightElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$18 = message_decode$63(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$18.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskBgToStopHighlightElement */62,
                      _0: v0$18._0
                    }
                  };
          }
          var e$18 = v0$18._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
      case "Message_BatchUpdateGoogleSheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$19 = message_decode$37(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$19.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_BatchUpdateGoogleSheet */36,
                      _0: v0$19._0
                    }
                  };
          }
          var e$19 = v0$19._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                  }
                };
      case "Message_ClearKeyThatDoesNotGenerateCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$20 = message_decode$9(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$20.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_ClearKeyThatDoesNotGenerateCommand */8,
                      _0: v0$20._0
                    }
                  };
          }
          var e$20 = v0$20._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      case "Message_ContentScriptReady" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$21 = message_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$21.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_ContentScriptReady */0,
                      _0: v0$21._0
                    }
                  };
          }
          var e$21 = v0$21._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$21.path,
                    message: e$21.message,
                    value: e$21.value
                  }
                };
      case "Message_CreateGoogleSheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$22 = message_decode$35(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$22.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_CreateGoogleSheet */34,
                      _0: v0$22._0
                    }
                  };
          }
          var e$22 = v0$22._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$22.path,
                    message: e$22.message,
                    value: e$22.value
                  }
                };
      case "Message_DebugSelector" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$23 = message_decode$41(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$23.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_DebugSelector */40,
                      _0: v0$23._0
                    }
                  };
          }
          var e$23 = v0$23._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$23.path,
                    message: e$23.message,
                    value: e$23.value
                  }
                };
      case "Message_DeleteExecutionSet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$24 = message_decode$26(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$24.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_DeleteExecutionSet */25,
                      _0: v0$24._0
                    }
                  };
          }
          var e$24 = v0$24._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$24.path,
                    message: e$24.message,
                    value: e$24.value
                  }
                };
      case "Message_DeleteSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$25 = message_decode$20(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$25.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_DeleteSmartcut */19,
                      _0: v0$25._0
                    }
                  };
          }
          var e$25 = v0$25._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$25.path,
                    message: e$25.message,
                    value: e$25.value
                  }
                };
      case "Message_DidCloseExplainModalAndAskBgToHighlightElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$26 = message_decode$62(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$26.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_DidCloseExplainModalAndAskBgToHighlightElement */61,
                      _0: v0$26._0
                    }
                  };
          }
          var e$26 = v0$26._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$26.path,
                    message: e$26.message,
                    value: e$26.value
                  }
                };
      case "Message_DidStartRecording" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$27 = message_decode$7(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$27.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_DidStartRecording */6,
                      _0: v0$27._0
                    }
                  };
          }
          var e$27 = v0$27._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$27.path,
                    message: e$27.message,
                    value: e$27.value
                  }
                };
      case "Message_FetchGoogleSheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$28 = message_decode$36(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$28.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_FetchGoogleSheet */35,
                      _0: v0$28._0
                    }
                  };
          }
          var e$28 = v0$28._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$28.path,
                    message: e$28.message,
                    value: e$28.value
                  }
                };
      case "Message_FindExecutionById" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$29 = message_decode$23(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$29.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_FindExecutionById */22,
                      _0: v0$29._0
                    }
                  };
          }
          var e$29 = v0$29._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$29.path,
                    message: e$29.message,
                    value: e$29.value
                  }
                };
      case "Message_FindExternalAccountById" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$30 = message_decode$32(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$30.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_FindExternalAccountById */31,
                      _0: v0$30._0
                    }
                  };
          }
          var e$30 = v0$30._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$30.path,
                    message: e$30.message,
                    value: e$30.value
                  }
                };
      case "Message_FinishAuthoring" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$31 = message_decode$11(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$31.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_FinishAuthoring */10,
                      _0: v0$31._0
                    }
                  };
          }
          var e$31 = v0$31._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$31.path,
                    message: e$31.message,
                    value: e$31.value
                  }
                };
      case "Message_GetAuthoringCommandLog" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$32 = message_decode$16(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$32.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_GetAuthoringCommandLog */15,
                      _0: v0$32._0
                    }
                  };
          }
          var e$32 = v0$32._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$32.path,
                    message: e$32.message,
                    value: e$32.value
                  }
                };
      case "Message_GetExecutionHistoryForSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$33 = message_decode$21(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$33.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_GetExecutionHistoryForSmartcut */20,
                      _0: v0$33._0
                    }
                  };
          }
          var e$33 = v0$33._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$33.path,
                    message: e$33.message,
                    value: e$33.value
                  }
                };
      case "Message_GetExecutionSetById" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$34 = message_decode$28(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$34.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_GetExecutionSetById */27,
                      _0: v0$34._0
                    }
                  };
          }
          var e$34 = v0$34._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$34.path,
                    message: e$34.message,
                    value: e$34.value
                  }
                };
      case "Message_GetExecutionSetProgress" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$35 = message_decode$27(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$35.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_GetExecutionSetProgress */26,
                      _0: v0$35._0
                    }
                  };
          }
          var e$35 = v0$35._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$35.path,
                    message: e$35.message,
                    value: e$35.value
                  }
                };
      case "Message_GetMySmartcuts" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$36 = message_decode$18(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$36.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_GetMySmartcuts */17,
                      _0: v0$36._0
                    }
                  };
          }
          var e$36 = v0$36._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$36.path,
                    message: e$36.message,
                    value: e$36.value
                  }
                };
      case "Message_GetOAuthToken" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$37 = message_decode$33(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$37.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_GetOAuthToken */32,
                      _0: v0$37._0
                    }
                  };
          }
          var e$37 = v0$37._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$37.path,
                    message: e$37.message,
                    value: e$37.value
                  }
                };
      case "Message_GetScheduledTriggersForSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$38 = message_decode$22(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$38.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_GetScheduledTriggersForSmartcut */21,
                      _0: v0$38._0
                    }
                  };
          }
          var e$38 = v0$38._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$38.path,
                    message: e$38.message,
                    value: e$38.value
                  }
                };
      case "Message_GetSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$39 = message_decode$17(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$39.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_GetSmartcut */16,
                      _0: v0$39._0
                    }
                  };
          }
          var e$39 = v0$39._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$39.path,
                    message: e$39.message,
                    value: e$39.value
                  }
                };
      case "Message_GetUserCredentials" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$40 = message_decode$64(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$40.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_GetUserCredentials */63,
                      _0: v0$40._0
                    }
                  };
          }
          var e$40 = v0$40._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$40.path,
                    message: e$40.message,
                    value: e$40.value
                  }
                };
      case "Message_InitGoogleAuthFlow" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$41 = message_decode$38(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$41.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_InitGoogleAuthFlow */37,
                      _0: v0$41._0
                    }
                  };
          }
          var e$41 = v0$41._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$41.path,
                    message: e$41.message,
                    value: e$41.value
                  }
                };
      case "Message_InitializePlayback" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$42 = message_decode$15(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$42.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_InitializePlayback */14,
                      _0: v0$42._0
                    }
                  };
          }
          var e$42 = v0$42._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$42.path,
                    message: e$42.message,
                    value: e$42.value
                  }
                };
      case "Message_InstallSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$43 = message_decode$19(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$43.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_InstallSmartcut */18,
                      _0: v0$43._0
                    }
                  };
          }
          var e$43 = v0$43._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$43.path,
                    message: e$43.message,
                    value: e$43.value
                  }
                };
      case "Message_ModifyUserCredentials" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$44 = message_decode$66(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$44.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_ModifyUserCredentials */65,
                      _0: v0$44._0
                    }
                  };
          }
          var e$44 = v0$44._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$44.path,
                    message: e$44.message,
                    value: e$44.value
                  }
                };
      case "Message_MultiUrlTriggering" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$45 = message_decode$40(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$45.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_MultiUrlTriggering */39,
                      _0: v0$45._0
                    }
                  };
          }
          var e$45 = v0$45._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$45.path,
                    message: e$45.message,
                    value: e$45.value
                  }
                };
      case "Message_NotifyBgAboutPossibleCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$46 = message_decode$8(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$46.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_NotifyBgAboutPossibleCommand */7,
                      _0: v0$46._0
                    }
                  };
          }
          var e$46 = v0$46._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$46.path,
                    message: e$46.message,
                    value: e$46.value
                  }
                };
      case "Message_NotifyConfirmExecutionQuotaResult" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$47 = message_decode$56(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$47.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_NotifyConfirmExecutionQuotaResult */55,
                      _0: v0$47._0
                    }
                  };
          }
          var e$47 = v0$47._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$47.path,
                    message: e$47.message,
                    value: e$47.value
                  }
                };
      case "Message_OpenNewWindow" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$48 = message_decode$59(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$48.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_OpenNewWindow */58,
                      _0: v0$48._0
                    }
                  };
          }
          var e$48 = v0$48._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$48.path,
                    message: e$48.message,
                    value: e$48.value
                  }
                };
      case "Message_OpenPageForSmartcutId" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$49 = message_decode$12(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$49.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_OpenPageForSmartcutId */11,
                      _0: v0$49._0
                    }
                  };
          }
          var e$49 = v0$49._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$49.path,
                    message: e$49.message,
                    value: e$49.value
                  }
                };
      case "Message_PlaybackModeControl" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$50 = message_decode$42(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$50.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_PlaybackModeControl */41,
                      _0: v0$50._0
                    }
                  };
          }
          var e$50 = v0$50._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$50.path,
                    message: e$50.message,
                    value: e$50.value
                  }
                };
      case "Message_RecordCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$51 = message_decode$10(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$51.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_RecordCommand */9,
                      _0: v0$51._0
                    }
                  };
          }
          var e$51 = v0$51._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$51.path,
                    message: e$51.message,
                    value: e$51.value
                  }
                };
      case "Message_RequestPermissions" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$52 = message_decode$55(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$52.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_RequestPermissions */54,
                      _0: v0$52._0
                    }
                  };
          }
          var e$52 = v0$52._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$52.path,
                    message: e$52.message,
                    value: e$52.value
                  }
                };
      case "Message_SaveExternalAccount" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$53 = message_decode$31(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$53.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_SaveExternalAccount */30,
                      _0: v0$53._0
                    }
                  };
          }
          var e$53 = v0$53._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$53.path,
                    message: e$53.message,
                    value: e$53.value
                  }
                };
      case "Message_ShowFormForSmartcutId" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$54 = message_decode$13(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$54.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_ShowFormForSmartcutId */12,
                      _0: v0$54._0
                    }
                  };
          }
          var e$54 = v0$54._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$54.path,
                    message: e$54.message,
                    value: e$54.value
                  }
                };
      case "Message_SmartcutSavingProgress" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$55 = message_decode$54(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$55.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_SmartcutSavingProgress */53,
                      _0: v0$55._0
                    }
                  };
          }
          var e$55 = v0$55._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$55.path,
                    message: e$55.message,
                    value: e$55.value
                  }
                };
      case "Message_StartDebugSelector" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$56 = message_decode$4(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$56.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_StartDebugSelector */3,
                      _0: v0$56._0
                    }
                  };
          }
          var e$56 = v0$56._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$56.path,
                    message: e$56.message,
                    value: e$56.value
                  }
                };
      case "Message_StartRecording" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$57 = message_decode$5(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$57.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_StartRecording */4,
                      _0: v0$57._0
                    }
                  };
          }
          var e$57 = v0$57._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$57.path,
                    message: e$57.message,
                    value: e$57.value
                  }
                };
      case "Message_StopRecording" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$58 = message_decode$6(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$58.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_StopRecording */5,
                      _0: v0$58._0
                    }
                  };
          }
          var e$58 = v0$58._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$58.path,
                    message: e$58.message,
                    value: e$58.value
                  }
                };
      case "Message_StoreAuthStatusItem" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$59 = message_decode$60(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$59.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_StoreAuthStatusItem */59,
                      _0: v0$59._0
                    }
                  };
          }
          var e$59 = v0$59._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$59.path,
                    message: e$59.message,
                    value: e$59.value
                  }
                };
      case "Message_TrackWithSegment" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$60 = message_decode$57(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$60.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_TrackWithSegment */56,
                      _0: v0$60._0
                    }
                  };
          }
          var e$60 = v0$60._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$60.path,
                    message: e$60.message,
                    value: e$60.value
                  }
                };
      case "Message_UnlockVaultWithMasterSecret" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$61 = message_decode$65(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$61.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UnlockVaultWithMasterSecret */64,
                      _0: v0$61._0
                    }
                  };
          }
          var e$61 = v0$61._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$61.path,
                    message: e$61.message,
                    value: e$61.value
                  }
                };
      case "Message_UpdateExecutionStatus" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$62 = message_decode$24(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$62.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UpdateExecutionStatus */23,
                      _0: v0$62._0
                    }
                  };
          }
          var e$62 = v0$62._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$62.path,
                    message: e$62.message,
                    value: e$62.value
                  }
                };
      case "Message_UpsertExecutionSet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$63 = message_decode$25(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$63.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UpsertExecutionSet */24,
                      _0: v0$63._0
                    }
                  };
          }
          var e$63 = v0$63._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$63.path,
                    message: e$63.message,
                    value: e$63.value
                  }
                };
      case "Message_UpsertScheduledTriggerAndCreateAlarm" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$64 = message_decode$29(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$64.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UpsertScheduledTriggerAndCreateAlarm */28,
                      _0: v0$64._0
                    }
                  };
          }
          var e$64 = v0$64._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$64.path,
                    message: e$64.message,
                    value: e$64.value
                  }
                };
      case "Message_UrlTriggering_AskBgToPlaybackPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$65 = message_decode$46(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$65.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_AskBgToPlaybackPageAction */46,
                      _0: v0$65._0
                    }
                  };
          }
          var e$65 = v0$65._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$65.path,
                    message: e$65.message,
                    value: e$65.value
                  }
                };
      case "Message_UrlTriggering_AskBgToRecordPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$66 = message_decode$44(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$66.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_AskBgToRecordPageAction */43,
                      _0: v0$66._0
                    }
                  };
          }
          var e$66 = v0$66._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$66.path,
                    message: e$66.message,
                    value: e$66.value
                  }
                };
      case "Message_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$67 = message_decode$49(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$67.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut */49,
                      _0: v0$67._0
                    }
                  };
          }
          var e$67 = v0$67._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$67.path,
                    message: e$67.message,
                    value: e$67.value
                  }
                };
      case "Message_UrlTriggering_AskBgToShowLinkWithId" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$68 = message_decode$48(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$68.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_AskBgToShowLinkWithId */48,
                      _0: v0$68._0
                    }
                  };
          }
          var e$68 = v0$68._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$68.path,
                    message: e$68.message,
                    value: e$68.value
                  }
                };
      case "Message_UrlTriggering_AskBgToStopRecordPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$69 = message_decode$45(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$69.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_AskBgToStopRecordPageAction */44,
                      _0: v0$69._0
                    }
                  };
          }
          var e$69 = v0$69._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$69.path,
                    message: e$69.message,
                    value: e$69.value
                  }
                };
      case "Message_UrlTriggering_AskBgToUpdateLinkGroups" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$70 = message_decode$43(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$70.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_AskBgToUpdateLinkGroups */42,
                      _0: v0$70._0
                    }
                  };
          }
          var e$70 = v0$70._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$70.path,
                    message: e$70.message,
                    value: e$70.value
                  }
                };
      case "Message_UrlTriggering_AskBgToUpdatePaginateFn" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$71 = message_decode$51(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$71.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_AskBgToUpdatePaginateFn */45,
                      _0: v0$71._0
                    }
                  };
          }
          var e$71 = v0$71._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$71.path,
                    message: e$71.message,
                    value: e$71.value
                  }
                };
      case "Message_UrlTriggering_DidFinishPlaybackPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$72 = message_decode$47(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$72.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_DidFinishPlaybackPageAction */47,
                      _0: v0$72._0
                    }
                  };
          }
          var e$72 = v0$72._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$72.path,
                    message: e$72.message,
                    value: e$72.value
                  }
                };
      case "Message_UrlTriggering_MaybeReadyToPlaybackPagination" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$73 = message_decode$50(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$73.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_MaybeReadyToPlaybackPagination */50,
                      _0: v0$73._0
                    }
                  };
          }
          var e$73 = v0$73._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$73.path,
                    message: e$73.message,
                    value: e$73.value
                  }
                };
      case "Message_UserDidCloseGoogleOAuthModal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$74 = message_decode$39(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$74.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UserDidCloseGoogleOAuthModal */38,
                      _0: v0$74._0
                    }
                  };
          }
          var e$74 = v0$74._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$74.path,
                    message: e$74.message,
                    value: e$74.value
                  }
                };
      case "Message_UserReadyLogInToWebsite" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$75 = message_decode$58(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$75.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UserReadyLogInToWebsite */57,
                      _0: v0$75._0
                    }
                  };
          }
          var e$75 = v0$75._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$75.path,
                    message: e$75.message,
                    value: e$75.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$77(v) {
  switch (v.TAG | 0) {
    case /* Response_ContentScriptReady */0 :
        return [
                "Response_ContentScriptReady",
                response_encode$1(v._0)
              ];
    case /* Response_AskBgToRefreshAuthStatus */1 :
        return [
                "Response_AskBgToRefreshAuthStatus",
                response_encode$2(v._0)
              ];
    case /* Response_AskBgToFetchPlanSubscriptionProgress */2 :
        return [
                "Response_AskBgToFetchPlanSubscriptionProgress",
                response_encode$3(v._0)
              ];
    case /* Response_StartDebugSelector */3 :
        return [
                "Response_StartDebugSelector",
                response_encode$4(v._0)
              ];
    case /* Response_StartRecording */4 :
        return [
                "Response_StartRecording",
                response_encode$5(v._0)
              ];
    case /* Response_StopRecording */5 :
        return [
                "Response_StopRecording",
                ["AckStopRecording"]
              ];
    case /* Response_DidStartRecording */6 :
        return [
                "Response_DidStartRecording",
                response_encode$7(v._0)
              ];
    case /* Response_NotifyBgAboutPossibleCommand */7 :
        return [
                "Response_NotifyBgAboutPossibleCommand",
                ["AckPossibleCommand"]
              ];
    case /* Response_ClearKeyThatDoesNotGenerateCommand */8 :
        return [
                "Response_ClearKeyThatDoesNotGenerateCommand",
                ["AckClearKeyThatDoesNotGenerateCommand"]
              ];
    case /* Response_RecordCommand */9 :
        return [
                "Response_RecordCommand",
                response_encode$10(v._0)
              ];
    case /* Response_FinishAuthoring */10 :
        return [
                "Response_FinishAuthoring",
                response_encode$11(v._0)
              ];
    case /* Response_OpenPageForSmartcutId */11 :
        return [
                "Response_OpenPageForSmartcutId",
                response_encode$12(v._0)
              ];
    case /* Response_ShowFormForSmartcutId */12 :
        return [
                "Response_ShowFormForSmartcutId",
                response_encode$13(v._0)
              ];
    case /* Response_AskBgToAdjustModalGeometry */13 :
        return [
                "Response_AskBgToAdjustModalGeometry",
                response_encode$14(v._0)
              ];
    case /* Response_InitializePlayback */14 :
        return [
                "Response_InitializePlayback",
                ["BgDidInitializePlayback"]
              ];
    case /* Response_GetAuthoringCommandLog */15 :
        return [
                "Response_GetAuthoringCommandLog",
                response_encode$16(v._0)
              ];
    case /* Response_GetSmartcut */16 :
        return [
                "Response_GetSmartcut",
                response_encode$17(v._0)
              ];
    case /* Response_GetMySmartcuts */17 :
        return [
                "Response_GetMySmartcuts",
                response_encode$18(v._0)
              ];
    case /* Response_InstallSmartcut */18 :
        return [
                "Response_InstallSmartcut",
                response_encode$19(v._0)
              ];
    case /* Response_DeleteSmartcut */19 :
        return [
                "Response_DeleteSmartcut",
                response_encode$20(v._0)
              ];
    case /* Response_GetExecutionHistoryForSmartcut */20 :
        return [
                "Response_GetExecutionHistoryForSmartcut",
                response_encode$21(v._0)
              ];
    case /* Response_GetScheduledTriggersForSmartcut */21 :
        return [
                "Response_GetScheduledTriggersForSmartcut",
                response_encode$22(v._0)
              ];
    case /* Response_FindExecutionById */22 :
        return [
                "Response_FindExecutionById",
                response_encode$23(v._0)
              ];
    case /* Response_UpdateExecutionStatus */23 :
        return [
                "Response_UpdateExecutionStatus",
                response_encode$24(v._0)
              ];
    case /* Response_UpsertExecutionSet */24 :
        return [
                "Response_UpsertExecutionSet",
                response_encode$25(v._0)
              ];
    case /* Response_DeleteExecutionSet */25 :
        return [
                "Response_DeleteExecutionSet",
                response_encode$26(v._0)
              ];
    case /* Response_GetExecutionSetProgress */26 :
        return [
                "Response_GetExecutionSetProgress",
                response_encode$27(v._0)
              ];
    case /* Response_GetExecutionSetById */27 :
        return [
                "Response_GetExecutionSetById",
                response_encode$28(v._0)
              ];
    case /* Response_UpsertScheduledTriggerAndCreateAlarm */28 :
        return [
                "Response_UpsertScheduledTriggerAndCreateAlarm",
                response_encode$29(v._0)
              ];
    case /* Response_ArchiveScheduledTrigger */29 :
        return [
                "Response_ArchiveScheduledTrigger",
                response_encode$30(v._0)
              ];
    case /* Response_SaveExternalAccount */30 :
        return [
                "Response_SaveExternalAccount",
                ["DidSaveExternalAccount"]
              ];
    case /* Response_FindExternalAccountById */31 :
        return [
                "Response_FindExternalAccountById",
                response_encode$32(v._0)
              ];
    case /* Response_GetOAuthToken */32 :
        return [
                "Response_GetOAuthToken",
                response_encode$33(v._0)
              ];
    case /* Response_AskBgToClipboard */33 :
        return [
                "Response_AskBgToClipboard",
                ["BgDidWriteToClipboard"]
              ];
    case /* Response_CreateGoogleSheet */34 :
        return [
                "Response_CreateGoogleSheet",
                response_encode$35(v._0)
              ];
    case /* Response_FetchGoogleSheet */35 :
        return [
                "Response_FetchGoogleSheet",
                response_encode$36(v._0)
              ];
    case /* Response_BatchUpdateGoogleSheet */36 :
        return [
                "Response_BatchUpdateGoogleSheet",
                response_encode$37(v._0)
              ];
    case /* Response_InitGoogleAuthFlow */37 :
        return [
                "Response_InitGoogleAuthFlow",
                response_encode$38(v._0)
              ];
    case /* Response_UserDidCloseGoogleOAuthModal */38 :
        return [
                "Response_UserDidCloseGoogleOAuthModal",
                ["AckUserDidCloseGoogleOAuthModal"]
              ];
    case /* Response_MultiUrlTriggering */39 :
        return [
                "Response_MultiUrlTriggering",
                ["Ok"]
              ];
    case /* Response_DebugSelector */40 :
        return [
                "Response_DebugSelector",
                response_encode$41(v._0)
              ];
    case /* Response_PlaybackModeControl */41 :
        return [
                "Response_PlaybackModeControl",
                ["Ok"]
              ];
    case /* Response_UrlTriggering_AskBgToUpdateLinkGroups */42 :
        return [
                "Response_UrlTriggering_AskBgToUpdateLinkGroups",
                ["AckUpdateLinkGroups"]
              ];
    case /* Response_UrlTriggering_AskBgToRecordPageAction */43 :
        return [
                "Response_UrlTriggering_AskBgToRecordPageAction",
                ["AckAskBgToRecordPageAction"]
              ];
    case /* Response_UrlTriggering_AskBgToStopRecordPageAction */44 :
        return [
                "Response_UrlTriggering_AskBgToStopRecordPageAction",
                ["AckAskBgToStopRecordPageAction"]
              ];
    case /* Response_UrlTriggering_AskBgToUpdatePaginateFn */45 :
        return [
                "Response_UrlTriggering_AskBgToUpdatePaginateFn",
                ["AckAskBgToUpdatePaginateFn"]
              ];
    case /* Response_UrlTriggering_AskBgToPlaybackPageAction */46 :
        return [
                "Response_UrlTriggering_AskBgToPlaybackPageAction",
                ["AckAskBgToPlaybackPageAction"]
              ];
    case /* Response_UrlTriggering_DidFinishPlaybackPageAction */47 :
        return [
                "Response_UrlTriggering_DidFinishPlaybackPageAction",
                response_encode$47(v._0)
              ];
    case /* Response_UrlTriggering_AskBgToShowLinkWithId */48 :
        return [
                "Response_UrlTriggering_AskBgToShowLinkWithId",
                ["AckAskBgToShowLinkWithId"]
              ];
    case /* Response_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut */49 :
        return [
                "Response_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut",
                ["AckAskBgToSaveUrlTriggeringAsSmartcut"]
              ];
    case /* Response_UrlTriggering_MaybeReadyToPlaybackPagination */50 :
        return [
                "Response_UrlTriggering_MaybeReadyToPlaybackPagination",
                ["AckMaybeReadyToPlaybackPagination"]
              ];
    case /* Response_SmartcutSavingProgress */51 :
        return [
                "Response_SmartcutSavingProgress",
                response_encode$54(v._0)
              ];
    case /* Response_AskBgToFocusTab */52 :
        return [
                "Response_AskBgToFocusTab",
                ["AckAskBgToFocusTab"]
              ];
    case /* Response_AskBgToFocusWindow */53 :
        return [
                "Response_AskBgToFocusWindow",
                ["AckAskBgToFocusWindow"]
              ];
    case /* Response_RequestPermissions */54 :
        return [
                "Response_RequestPermissions",
                ["DidRequestPermissions"]
              ];
    case /* Response_NotifyConfirmExecutionQuotaResult */55 :
        return [
                "Response_NotifyConfirmExecutionQuotaResult",
                ["AckConfirmExecutionQuotaResult"]
              ];
    case /* Response_TrackWithSegment */56 :
        return [
                "Response_TrackWithSegment",
                ["BgDidTrackWithSegment"]
              ];
    case /* Response_UserReadyLogInToWebsite */57 :
        return [
                "Response_UserReadyLogInToWebsite",
                ["AckUserReadyLogInToWebsite"]
              ];
    case /* Response_OpenNewWindow */58 :
        return [
                "Response_OpenNewWindow",
                ["AckOpenNewWindow"]
              ];
    case /* Response_StoreAuthStatusItem */59 :
        return [
                "Response_StoreAuthStatusItem",
                ["AckStoreAuthStatusItem"]
              ];
    case /* Response_AskBgToHighlightElement */60 :
        return [
                "Response_AskBgToHighlightElement",
                ["AckHighlightElement"]
              ];
    case /* Response_DidCloseExplainModalAndAskBgToHighlightElement */61 :
        return [
                "Response_DidCloseExplainModalAndAskBgToHighlightElement",
                ["AckDidCloseExplainModalAndAskBgToHighlightElement"]
              ];
    case /* Response_AskBgToStopHighlightElement */62 :
        return [
                "Response_AskBgToStopHighlightElement",
                ["DidTeardownHighlightElementControl"]
              ];
    case /* Response_GetUserCredentials */63 :
        return [
                "Response_GetUserCredentials",
                response_encode$64(v._0)
              ];
    case /* Response_UnlockVaultWithMasterSecret */64 :
        return [
                "Response_UnlockVaultWithMasterSecret",
                response_encode$65(v._0)
              ];
    case /* Response_ModifyUserCredentials */65 :
        return [
                "Response_ModifyUserCredentials",
                response_encode$66(v._0)
              ];
    case /* Response_AskBgIfMasterSecretDoesExist */66 :
        return [
                "Response_AskBgIfMasterSecretDoesExist",
                response_encode$67(v._0)
              ];
    case /* Response_AskBgForMissingPasswords */67 :
        return [
                "Response_AskBgForMissingPasswords",
                response_encode$68(v._0)
              ];
    case /* Response_AskBgToCreateVaultWithMasterSecret */68 :
        return [
                "Response_AskBgToCreateVaultWithMasterSecret",
                response_encode$69(v._0)
              ];
    case /* Response_AskBgToResetMasterSecret */69 :
        return [
                "Response_AskBgToResetMasterSecret",
                response_encode$70(v._0)
              ];
    case /* Response_AskBgToDetachLoginSmartcut */70 :
        return [
                "Response_AskBgToDetachLoginSmartcut",
                response_encode$71(v._0)
              ];
    case /* Response_AskBgToEnterDataExtractionMode */71 :
        return [
                "Response_AskBgToEnterDataExtractionMode",
                response_encode$72(v._0)
              ];
    case /* Response_AskBgToProcessDataExtractionSignal */72 :
        return [
                "Response_AskBgToProcessDataExtractionSignal",
                response_encode$73(v._0)
              ];
    case /* Response_AskBgToExitFromDataExtractionMode */73 :
        return [
                "Response_AskBgToExitFromDataExtractionMode",
                ["DidExitFromDataExtractionMode"]
              ];
    case /* Response_AskBgToSaveDataExtractionAsSmartcut */74 :
        return [
                "Response_AskBgToSaveDataExtractionAsSmartcut",
                ["AckSaveDataExtractionAsSmartcut"]
              ];
    case /* Response_AskBgToRenderNotification */75 :
        return [
                "Response_AskBgToRenderNotification",
                ["DidRenderNotification"]
              ];
    
  }
}

function response_decode$77(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Response_ArchiveScheduledTrigger" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = response_decode$30(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_ArchiveScheduledTrigger */29,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Response_AskBgForMissingPasswords" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = response_decode$68(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgForMissingPasswords */67,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Response_AskBgIfMasterSecretDoesExist" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = response_decode$67(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgIfMasterSecretDoesExist */66,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Response_AskBgToAdjustModalGeometry" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = response_decode$14(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToAdjustModalGeometry */13,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Response_AskBgToClipboard" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = response_decode$34(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToClipboard */33,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "Response_AskBgToCreateVaultWithMasterSecret" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = response_decode$69(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToCreateVaultWithMasterSecret */68,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "Response_AskBgToDetachLoginSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = response_decode$71(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToDetachLoginSmartcut */70,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "Response_AskBgToEnterDataExtractionMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = response_decode$72(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToEnterDataExtractionMode */71,
                      _0: v0$7._0
                    }
                  };
          }
          var e$7 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "Response_AskBgToExitFromDataExtractionMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = response_decode$75(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToExitFromDataExtractionMode */73,
                      _0: v0$8._0
                    }
                  };
          }
          var e$8 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "Response_AskBgToFetchPlanSubscriptionProgress" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = response_decode$3(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToFetchPlanSubscriptionProgress */2,
                      _0: v0$9._0
                    }
                  };
          }
          var e$9 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "Response_AskBgToFocusTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = response_decode$52(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToFocusTab */52,
                      _0: v0$10._0
                    }
                  };
          }
          var e$10 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "Response_AskBgToFocusWindow" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$11 = response_decode$53(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$11.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToFocusWindow */53,
                      _0: v0$11._0
                    }
                  };
          }
          var e$11 = v0$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "Response_AskBgToHighlightElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$12 = response_decode$61(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$12.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToHighlightElement */60,
                      _0: v0$12._0
                    }
                  };
          }
          var e$12 = v0$12._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "Response_AskBgToProcessDataExtractionSignal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$13 = response_decode$73(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$13.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToProcessDataExtractionSignal */72,
                      _0: v0$13._0
                    }
                  };
          }
          var e$13 = v0$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "Response_AskBgToRefreshAuthStatus" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$14 = response_decode$2(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$14.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToRefreshAuthStatus */1,
                      _0: v0$14._0
                    }
                  };
          }
          var e$14 = v0$14._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "Response_AskBgToRenderNotification" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$15 = response_decode$76(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$15.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToRenderNotification */75,
                      _0: v0$15._0
                    }
                  };
          }
          var e$15 = v0$15._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      case "Response_AskBgToResetMasterSecret" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$16 = response_decode$70(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$16.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToResetMasterSecret */69,
                      _0: v0$16._0
                    }
                  };
          }
          var e$16 = v0$16._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
      case "Response_AskBgToSaveDataExtractionAsSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$17 = response_decode$74(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$17.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToSaveDataExtractionAsSmartcut */74,
                      _0: v0$17._0
                    }
                  };
          }
          var e$17 = v0$17._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "Response_AskBgToStopHighlightElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$18 = response_decode$63(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$18.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskBgToStopHighlightElement */62,
                      _0: v0$18._0
                    }
                  };
          }
          var e$18 = v0$18._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
      case "Response_BatchUpdateGoogleSheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$19 = response_decode$37(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$19.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_BatchUpdateGoogleSheet */36,
                      _0: v0$19._0
                    }
                  };
          }
          var e$19 = v0$19._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                  }
                };
      case "Response_ClearKeyThatDoesNotGenerateCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$20 = response_decode$9(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$20.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_ClearKeyThatDoesNotGenerateCommand */8,
                      _0: v0$20._0
                    }
                  };
          }
          var e$20 = v0$20._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      case "Response_ContentScriptReady" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$21 = response_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$21.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_ContentScriptReady */0,
                      _0: v0$21._0
                    }
                  };
          }
          var e$21 = v0$21._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$21.path,
                    message: e$21.message,
                    value: e$21.value
                  }
                };
      case "Response_CreateGoogleSheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$22 = response_decode$35(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$22.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_CreateGoogleSheet */34,
                      _0: v0$22._0
                    }
                  };
          }
          var e$22 = v0$22._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$22.path,
                    message: e$22.message,
                    value: e$22.value
                  }
                };
      case "Response_DebugSelector" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$23 = response_decode$41(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$23.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_DebugSelector */40,
                      _0: v0$23._0
                    }
                  };
          }
          var e$23 = v0$23._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$23.path,
                    message: e$23.message,
                    value: e$23.value
                  }
                };
      case "Response_DeleteExecutionSet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$24 = response_decode$26(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$24.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_DeleteExecutionSet */25,
                      _0: v0$24._0
                    }
                  };
          }
          var e$24 = v0$24._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$24.path,
                    message: e$24.message,
                    value: e$24.value
                  }
                };
      case "Response_DeleteSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$25 = response_decode$20(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$25.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_DeleteSmartcut */19,
                      _0: v0$25._0
                    }
                  };
          }
          var e$25 = v0$25._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$25.path,
                    message: e$25.message,
                    value: e$25.value
                  }
                };
      case "Response_DidCloseExplainModalAndAskBgToHighlightElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$26 = response_decode$62(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$26.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_DidCloseExplainModalAndAskBgToHighlightElement */61,
                      _0: v0$26._0
                    }
                  };
          }
          var e$26 = v0$26._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$26.path,
                    message: e$26.message,
                    value: e$26.value
                  }
                };
      case "Response_DidStartRecording" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$27 = response_decode$7(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$27.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_DidStartRecording */6,
                      _0: v0$27._0
                    }
                  };
          }
          var e$27 = v0$27._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$27.path,
                    message: e$27.message,
                    value: e$27.value
                  }
                };
      case "Response_FetchGoogleSheet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$28 = response_decode$36(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$28.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_FetchGoogleSheet */35,
                      _0: v0$28._0
                    }
                  };
          }
          var e$28 = v0$28._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$28.path,
                    message: e$28.message,
                    value: e$28.value
                  }
                };
      case "Response_FindExecutionById" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$29 = response_decode$23(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$29.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_FindExecutionById */22,
                      _0: v0$29._0
                    }
                  };
          }
          var e$29 = v0$29._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$29.path,
                    message: e$29.message,
                    value: e$29.value
                  }
                };
      case "Response_FindExternalAccountById" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$30 = response_decode$32(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$30.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_FindExternalAccountById */31,
                      _0: v0$30._0
                    }
                  };
          }
          var e$30 = v0$30._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$30.path,
                    message: e$30.message,
                    value: e$30.value
                  }
                };
      case "Response_FinishAuthoring" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$31 = response_decode$11(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$31.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_FinishAuthoring */10,
                      _0: v0$31._0
                    }
                  };
          }
          var e$31 = v0$31._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$31.path,
                    message: e$31.message,
                    value: e$31.value
                  }
                };
      case "Response_GetAuthoringCommandLog" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$32 = response_decode$16(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$32.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_GetAuthoringCommandLog */15,
                      _0: v0$32._0
                    }
                  };
          }
          var e$32 = v0$32._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$32.path,
                    message: e$32.message,
                    value: e$32.value
                  }
                };
      case "Response_GetExecutionHistoryForSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$33 = response_decode$21(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$33.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_GetExecutionHistoryForSmartcut */20,
                      _0: v0$33._0
                    }
                  };
          }
          var e$33 = v0$33._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$33.path,
                    message: e$33.message,
                    value: e$33.value
                  }
                };
      case "Response_GetExecutionSetById" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$34 = response_decode$28(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$34.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_GetExecutionSetById */27,
                      _0: v0$34._0
                    }
                  };
          }
          var e$34 = v0$34._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$34.path,
                    message: e$34.message,
                    value: e$34.value
                  }
                };
      case "Response_GetExecutionSetProgress" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$35 = response_decode$27(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$35.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_GetExecutionSetProgress */26,
                      _0: v0$35._0
                    }
                  };
          }
          var e$35 = v0$35._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$35.path,
                    message: e$35.message,
                    value: e$35.value
                  }
                };
      case "Response_GetMySmartcuts" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$36 = response_decode$18(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$36.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_GetMySmartcuts */17,
                      _0: v0$36._0
                    }
                  };
          }
          var e$36 = v0$36._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$36.path,
                    message: e$36.message,
                    value: e$36.value
                  }
                };
      case "Response_GetOAuthToken" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$37 = response_decode$33(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$37.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_GetOAuthToken */32,
                      _0: v0$37._0
                    }
                  };
          }
          var e$37 = v0$37._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$37.path,
                    message: e$37.message,
                    value: e$37.value
                  }
                };
      case "Response_GetScheduledTriggersForSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$38 = response_decode$22(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$38.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_GetScheduledTriggersForSmartcut */21,
                      _0: v0$38._0
                    }
                  };
          }
          var e$38 = v0$38._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$38.path,
                    message: e$38.message,
                    value: e$38.value
                  }
                };
      case "Response_GetSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$39 = response_decode$17(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$39.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_GetSmartcut */16,
                      _0: v0$39._0
                    }
                  };
          }
          var e$39 = v0$39._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$39.path,
                    message: e$39.message,
                    value: e$39.value
                  }
                };
      case "Response_GetUserCredentials" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$40 = response_decode$64(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$40.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_GetUserCredentials */63,
                      _0: v0$40._0
                    }
                  };
          }
          var e$40 = v0$40._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$40.path,
                    message: e$40.message,
                    value: e$40.value
                  }
                };
      case "Response_InitGoogleAuthFlow" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$41 = response_decode$38(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$41.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_InitGoogleAuthFlow */37,
                      _0: v0$41._0
                    }
                  };
          }
          var e$41 = v0$41._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$41.path,
                    message: e$41.message,
                    value: e$41.value
                  }
                };
      case "Response_InitializePlayback" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$42 = response_decode$15(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$42.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_InitializePlayback */14,
                      _0: v0$42._0
                    }
                  };
          }
          var e$42 = v0$42._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$42.path,
                    message: e$42.message,
                    value: e$42.value
                  }
                };
      case "Response_InstallSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$43 = response_decode$19(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$43.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_InstallSmartcut */18,
                      _0: v0$43._0
                    }
                  };
          }
          var e$43 = v0$43._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$43.path,
                    message: e$43.message,
                    value: e$43.value
                  }
                };
      case "Response_ModifyUserCredentials" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$44 = response_decode$66(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$44.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_ModifyUserCredentials */65,
                      _0: v0$44._0
                    }
                  };
          }
          var e$44 = v0$44._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$44.path,
                    message: e$44.message,
                    value: e$44.value
                  }
                };
      case "Response_MultiUrlTriggering" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$45 = response_decode$40(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$45.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_MultiUrlTriggering */39,
                      _0: v0$45._0
                    }
                  };
          }
          var e$45 = v0$45._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$45.path,
                    message: e$45.message,
                    value: e$45.value
                  }
                };
      case "Response_NotifyBgAboutPossibleCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$46 = response_decode$8(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$46.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_NotifyBgAboutPossibleCommand */7,
                      _0: v0$46._0
                    }
                  };
          }
          var e$46 = v0$46._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$46.path,
                    message: e$46.message,
                    value: e$46.value
                  }
                };
      case "Response_NotifyConfirmExecutionQuotaResult" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$47 = response_decode$56(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$47.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_NotifyConfirmExecutionQuotaResult */55,
                      _0: v0$47._0
                    }
                  };
          }
          var e$47 = v0$47._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$47.path,
                    message: e$47.message,
                    value: e$47.value
                  }
                };
      case "Response_OpenNewWindow" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$48 = response_decode$59(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$48.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_OpenNewWindow */58,
                      _0: v0$48._0
                    }
                  };
          }
          var e$48 = v0$48._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$48.path,
                    message: e$48.message,
                    value: e$48.value
                  }
                };
      case "Response_OpenPageForSmartcutId" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$49 = response_decode$12(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$49.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_OpenPageForSmartcutId */11,
                      _0: v0$49._0
                    }
                  };
          }
          var e$49 = v0$49._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$49.path,
                    message: e$49.message,
                    value: e$49.value
                  }
                };
      case "Response_PlaybackModeControl" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$50 = response_decode$42(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$50.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_PlaybackModeControl */41,
                      _0: v0$50._0
                    }
                  };
          }
          var e$50 = v0$50._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$50.path,
                    message: e$50.message,
                    value: e$50.value
                  }
                };
      case "Response_RecordCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$51 = response_decode$10(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$51.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_RecordCommand */9,
                      _0: v0$51._0
                    }
                  };
          }
          var e$51 = v0$51._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$51.path,
                    message: e$51.message,
                    value: e$51.value
                  }
                };
      case "Response_RequestPermissions" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$52 = response_decode$55(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$52.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_RequestPermissions */54,
                      _0: v0$52._0
                    }
                  };
          }
          var e$52 = v0$52._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$52.path,
                    message: e$52.message,
                    value: e$52.value
                  }
                };
      case "Response_SaveExternalAccount" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$53 = response_decode$31(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$53.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_SaveExternalAccount */30,
                      _0: v0$53._0
                    }
                  };
          }
          var e$53 = v0$53._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$53.path,
                    message: e$53.message,
                    value: e$53.value
                  }
                };
      case "Response_ShowFormForSmartcutId" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$54 = response_decode$13(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$54.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_ShowFormForSmartcutId */12,
                      _0: v0$54._0
                    }
                  };
          }
          var e$54 = v0$54._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$54.path,
                    message: e$54.message,
                    value: e$54.value
                  }
                };
      case "Response_SmartcutSavingProgress" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$55 = response_decode$54(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$55.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_SmartcutSavingProgress */51,
                      _0: v0$55._0
                    }
                  };
          }
          var e$55 = v0$55._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$55.path,
                    message: e$55.message,
                    value: e$55.value
                  }
                };
      case "Response_StartDebugSelector" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$56 = response_decode$4(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$56.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_StartDebugSelector */3,
                      _0: v0$56._0
                    }
                  };
          }
          var e$56 = v0$56._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$56.path,
                    message: e$56.message,
                    value: e$56.value
                  }
                };
      case "Response_StartRecording" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$57 = response_decode$5(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$57.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_StartRecording */4,
                      _0: v0$57._0
                    }
                  };
          }
          var e$57 = v0$57._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$57.path,
                    message: e$57.message,
                    value: e$57.value
                  }
                };
      case "Response_StopRecording" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$58 = response_decode$6(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$58.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_StopRecording */5,
                      _0: v0$58._0
                    }
                  };
          }
          var e$58 = v0$58._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$58.path,
                    message: e$58.message,
                    value: e$58.value
                  }
                };
      case "Response_StoreAuthStatusItem" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$59 = response_decode$60(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$59.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_StoreAuthStatusItem */59,
                      _0: v0$59._0
                    }
                  };
          }
          var e$59 = v0$59._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$59.path,
                    message: e$59.message,
                    value: e$59.value
                  }
                };
      case "Response_TrackWithSegment" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$60 = response_decode$57(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$60.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_TrackWithSegment */56,
                      _0: v0$60._0
                    }
                  };
          }
          var e$60 = v0$60._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$60.path,
                    message: e$60.message,
                    value: e$60.value
                  }
                };
      case "Response_UnlockVaultWithMasterSecret" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$61 = response_decode$65(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$61.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UnlockVaultWithMasterSecret */64,
                      _0: v0$61._0
                    }
                  };
          }
          var e$61 = v0$61._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$61.path,
                    message: e$61.message,
                    value: e$61.value
                  }
                };
      case "Response_UpdateExecutionStatus" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$62 = response_decode$24(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$62.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UpdateExecutionStatus */23,
                      _0: v0$62._0
                    }
                  };
          }
          var e$62 = v0$62._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$62.path,
                    message: e$62.message,
                    value: e$62.value
                  }
                };
      case "Response_UpsertExecutionSet" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$63 = response_decode$25(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$63.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UpsertExecutionSet */24,
                      _0: v0$63._0
                    }
                  };
          }
          var e$63 = v0$63._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$63.path,
                    message: e$63.message,
                    value: e$63.value
                  }
                };
      case "Response_UpsertScheduledTriggerAndCreateAlarm" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$64 = response_decode$29(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$64.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UpsertScheduledTriggerAndCreateAlarm */28,
                      _0: v0$64._0
                    }
                  };
          }
          var e$64 = v0$64._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$64.path,
                    message: e$64.message,
                    value: e$64.value
                  }
                };
      case "Response_UrlTriggering_AskBgToPlaybackPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$65 = response_decode$46(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$65.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_AskBgToPlaybackPageAction */46,
                      _0: v0$65._0
                    }
                  };
          }
          var e$65 = v0$65._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$65.path,
                    message: e$65.message,
                    value: e$65.value
                  }
                };
      case "Response_UrlTriggering_AskBgToRecordPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$66 = response_decode$44(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$66.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_AskBgToRecordPageAction */43,
                      _0: v0$66._0
                    }
                  };
          }
          var e$66 = v0$66._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$66.path,
                    message: e$66.message,
                    value: e$66.value
                  }
                };
      case "Response_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$67 = response_decode$49(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$67.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut */49,
                      _0: v0$67._0
                    }
                  };
          }
          var e$67 = v0$67._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$67.path,
                    message: e$67.message,
                    value: e$67.value
                  }
                };
      case "Response_UrlTriggering_AskBgToShowLinkWithId" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$68 = response_decode$48(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$68.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_AskBgToShowLinkWithId */48,
                      _0: v0$68._0
                    }
                  };
          }
          var e$68 = v0$68._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$68.path,
                    message: e$68.message,
                    value: e$68.value
                  }
                };
      case "Response_UrlTriggering_AskBgToStopRecordPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$69 = response_decode$45(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$69.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_AskBgToStopRecordPageAction */44,
                      _0: v0$69._0
                    }
                  };
          }
          var e$69 = v0$69._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$69.path,
                    message: e$69.message,
                    value: e$69.value
                  }
                };
      case "Response_UrlTriggering_AskBgToUpdateLinkGroups" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$70 = response_decode$43(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$70.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_AskBgToUpdateLinkGroups */42,
                      _0: v0$70._0
                    }
                  };
          }
          var e$70 = v0$70._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$70.path,
                    message: e$70.message,
                    value: e$70.value
                  }
                };
      case "Response_UrlTriggering_AskBgToUpdatePaginateFn" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$71 = response_decode$51(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$71.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_AskBgToUpdatePaginateFn */45,
                      _0: v0$71._0
                    }
                  };
          }
          var e$71 = v0$71._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$71.path,
                    message: e$71.message,
                    value: e$71.value
                  }
                };
      case "Response_UrlTriggering_DidFinishPlaybackPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$72 = response_decode$47(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$72.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_DidFinishPlaybackPageAction */47,
                      _0: v0$72._0
                    }
                  };
          }
          var e$72 = v0$72._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$72.path,
                    message: e$72.message,
                    value: e$72.value
                  }
                };
      case "Response_UrlTriggering_MaybeReadyToPlaybackPagination" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$73 = response_decode$50(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$73.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_MaybeReadyToPlaybackPagination */50,
                      _0: v0$73._0
                    }
                  };
          }
          var e$73 = v0$73._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$73.path,
                    message: e$73.message,
                    value: e$73.value
                  }
                };
      case "Response_UserDidCloseGoogleOAuthModal" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$74 = response_decode$39(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$74.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UserDidCloseGoogleOAuthModal */38,
                      _0: v0$74._0
                    }
                  };
          }
          var e$74 = v0$74._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$74.path,
                    message: e$74.message,
                    value: e$74.value
                  }
                };
      case "Response_UserReadyLogInToWebsite" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$75 = response_decode$58(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$75.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UserReadyLogInToWebsite */57,
                      _0: v0$75._0
                    }
                  };
          }
          var e$75 = v0$75._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$75.path,
                    message: e$75.message,
                    value: e$75.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_All = {
  message_encode: message_encode$77,
  message_decode: message_decode$77,
  response_encode: response_encode$77,
  response_decode: response_decode$77
};

function message_encode$78(v) {
  return ["ContentScriptReady"];
}

var message_decode$78 = message_decode$1;

var response_encode$78 = response_encode$1;

var response_decode$78 = response_decode$1;

var allMessage_encode = message_encode$77;

var allMessage_decode = message_decode$77;

var allResponse_encode = response_encode$77;

var allResponse_decode = response_decode$77;

var responseError_encode = Decco.stringToJson;

var responseError_decode = Decco.stringFromJson;

function wrapMessageAsAllMessage(message) {
  return {
          TAG: /* Message_ContentScriptReady */0,
          _0: message
        };
}

function unwrapAllResponseAsResponse(allResponse) {
  if (allResponse.TAG === /* Response_ContentScriptReady */0) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse(response) {
  return {
          TAG: /* Response_ContentScriptReady */0,
          _0: response
        };
}

var MRTransform_ContentScriptReady = {
  message_encode: message_encode$78,
  message_decode: message_decode$78,
  response_encode: response_encode$78,
  response_decode: response_decode$78,
  allMessage_encode: allMessage_encode,
  allMessage_decode: allMessage_decode,
  allResponse_encode: allResponse_encode,
  allResponse_decode: allResponse_decode,
  responseError_encode: responseError_encode,
  responseError_decode: responseError_decode,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse
};

var partial_arg = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var ContentScriptReady = partial_arg(MRTransform_ContentScriptReady, AllWrapper);

function message_encode$79(v) {
  return ["AskBgToRefreshAuthStatus"];
}

var message_decode$79 = message_decode$2;

var response_encode$79 = response_encode$2;

var response_decode$79 = response_decode$2;

var allMessage_encode$1 = message_encode$77;

var allMessage_decode$1 = message_decode$77;

var allResponse_encode$1 = response_encode$77;

var allResponse_decode$1 = response_decode$77;

var responseError_encode$1 = Decco.stringToJson;

var responseError_decode$1 = Decco.stringFromJson;

function wrapMessageAsAllMessage$1(message) {
  return {
          TAG: /* Message_AskBgToRefreshAuthStatus */1,
          _0: message
        };
}

function unwrapAllResponseAsResponse$1(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToRefreshAuthStatus */1) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$1(response) {
  return {
          TAG: /* Response_AskBgToRefreshAuthStatus */1,
          _0: response
        };
}

var MRTransform_AskBgToRefreshAuthStatus = {
  message_encode: message_encode$79,
  message_decode: message_decode$79,
  response_encode: response_encode$79,
  response_decode: response_decode$79,
  allMessage_encode: allMessage_encode$1,
  allMessage_decode: allMessage_decode$1,
  allResponse_encode: allResponse_encode$1,
  allResponse_decode: allResponse_decode$1,
  responseError_encode: responseError_encode$1,
  responseError_decode: responseError_decode$1,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$1,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$1,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$1
};

var partial_arg$1 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToRefreshAuthStatus = partial_arg$1(MRTransform_AskBgToRefreshAuthStatus, AllWrapper);

function message_encode$80(v) {
  return ["AskBgToFetchPlanSubscriptionProgress"];
}

var message_decode$80 = message_decode$3;

var response_encode$80 = response_encode$3;

var response_decode$80 = response_decode$3;

var allMessage_encode$2 = message_encode$77;

var allMessage_decode$2 = message_decode$77;

var allResponse_encode$2 = response_encode$77;

var allResponse_decode$2 = response_decode$77;

var responseError_encode$2 = Decco.stringToJson;

var responseError_decode$2 = Decco.stringFromJson;

function wrapMessageAsAllMessage$2(message) {
  return {
          TAG: /* Message_AskBgToFetchPlanSubscriptionProgress */2,
          _0: message
        };
}

function unwrapAllResponseAsResponse$2(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToFetchPlanSubscriptionProgress */2) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$2(response) {
  return {
          TAG: /* Response_AskBgToFetchPlanSubscriptionProgress */2,
          _0: response
        };
}

var MRTransform_AskBgToFetchPlanSubscriptionProgress = {
  message_encode: message_encode$80,
  message_decode: message_decode$80,
  response_encode: response_encode$80,
  response_decode: response_decode$80,
  allMessage_encode: allMessage_encode$2,
  allMessage_decode: allMessage_decode$2,
  allResponse_encode: allResponse_encode$2,
  allResponse_decode: allResponse_decode$2,
  responseError_encode: responseError_encode$2,
  responseError_decode: responseError_decode$2,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$2,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$2,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$2
};

var partial_arg$2 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToFetchPlanSubscriptionProgress = partial_arg$2(MRTransform_AskBgToFetchPlanSubscriptionProgress, AllWrapper);

function message_encode$81(v) {
  return ["StartDebugSelector"];
}

var message_decode$81 = message_decode$4;

var response_encode$81 = response_encode$4;

var response_decode$81 = response_decode$4;

var allMessage_encode$3 = message_encode$77;

var allMessage_decode$3 = message_decode$77;

var allResponse_encode$3 = response_encode$77;

var allResponse_decode$3 = response_decode$77;

var responseError_encode$3 = Decco.stringToJson;

var responseError_decode$3 = Decco.stringFromJson;

function wrapMessageAsAllMessage$3(message) {
  return {
          TAG: /* Message_StartDebugSelector */3,
          _0: message
        };
}

function unwrapAllResponseAsResponse$3(allResponse) {
  if (allResponse.TAG === /* Response_StartDebugSelector */3) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$3(response) {
  return {
          TAG: /* Response_StartDebugSelector */3,
          _0: response
        };
}

var MRTransform_StartDebugSelector = {
  message_encode: message_encode$81,
  message_decode: message_decode$81,
  response_encode: response_encode$81,
  response_decode: response_decode$81,
  allMessage_encode: allMessage_encode$3,
  allMessage_decode: allMessage_decode$3,
  allResponse_encode: allResponse_encode$3,
  allResponse_decode: allResponse_decode$3,
  responseError_encode: responseError_encode$3,
  responseError_decode: responseError_decode$3,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$3,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$3,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$3
};

var partial_arg$3 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var StartDebugSelector = partial_arg$3(MRTransform_StartDebugSelector, AllWrapper);

var message_encode$82 = message_encode$5;

var message_decode$82 = message_decode$5;

var response_encode$82 = response_encode$5;

var response_decode$82 = response_decode$5;

var allMessage_encode$4 = message_encode$77;

var allMessage_decode$4 = message_decode$77;

var allResponse_encode$4 = response_encode$77;

var allResponse_decode$4 = response_decode$77;

var responseError_encode$4 = Decco.stringToJson;

var responseError_decode$4 = Decco.stringFromJson;

function wrapMessageAsAllMessage$4(message) {
  return {
          TAG: /* Message_StartRecording */4,
          _0: message
        };
}

function unwrapAllResponseAsResponse$4(allResponse) {
  if (allResponse.TAG === /* Response_StartRecording */4) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$4(response) {
  return {
          TAG: /* Response_StartRecording */4,
          _0: response
        };
}

var MRTransform_StartRecording = {
  message_encode: message_encode$82,
  message_decode: message_decode$82,
  response_encode: response_encode$82,
  response_decode: response_decode$82,
  allMessage_encode: allMessage_encode$4,
  allMessage_decode: allMessage_decode$4,
  allResponse_encode: allResponse_encode$4,
  allResponse_decode: allResponse_decode$4,
  responseError_encode: responseError_encode$4,
  responseError_decode: responseError_decode$4,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$4,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$4,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$4
};

var partial_arg$4 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var StartRecording = partial_arg$4(MRTransform_StartRecording, AllWrapper);

function message_encode$83(v) {
  return ["StopRecording"];
}

var message_decode$83 = message_decode$6;

function response_encode$83(v) {
  return ["AckStopRecording"];
}

var response_decode$83 = response_decode$6;

var allMessage_encode$5 = message_encode$77;

var allMessage_decode$5 = message_decode$77;

var allResponse_encode$5 = response_encode$77;

var allResponse_decode$5 = response_decode$77;

var responseError_encode$5 = Decco.stringToJson;

var responseError_decode$5 = Decco.stringFromJson;

function wrapMessageAsAllMessage$5(message) {
  return {
          TAG: /* Message_StopRecording */5,
          _0: message
        };
}

function unwrapAllResponseAsResponse$5(allResponse) {
  if (allResponse.TAG === /* Response_StopRecording */5) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$5(response) {
  return {
          TAG: /* Response_StopRecording */5,
          _0: response
        };
}

var MRTransform_StopRecording = {
  message_encode: message_encode$83,
  message_decode: message_decode$83,
  response_encode: response_encode$83,
  response_decode: response_decode$83,
  allMessage_encode: allMessage_encode$5,
  allMessage_decode: allMessage_decode$5,
  allResponse_encode: allResponse_encode$5,
  allResponse_decode: allResponse_decode$5,
  responseError_encode: responseError_encode$5,
  responseError_decode: responseError_decode$5,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$5,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$5,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$5
};

var partial_arg$5 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var StopRecording = partial_arg$5(MRTransform_StopRecording, AllWrapper);

function message_encode$84(v) {
  return ["DidStartRecording"];
}

var message_decode$84 = message_decode$7;

var response_encode$84 = response_encode$7;

var response_decode$84 = response_decode$7;

var allMessage_encode$6 = message_encode$77;

var allMessage_decode$6 = message_decode$77;

var allResponse_encode$6 = response_encode$77;

var allResponse_decode$6 = response_decode$77;

var responseError_encode$6 = Decco.stringToJson;

var responseError_decode$6 = Decco.stringFromJson;

function wrapMessageAsAllMessage$6(message) {
  return {
          TAG: /* Message_DidStartRecording */6,
          _0: message
        };
}

function unwrapAllResponseAsResponse$6(allResponse) {
  if (allResponse.TAG === /* Response_DidStartRecording */6) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$6(response) {
  return {
          TAG: /* Response_DidStartRecording */6,
          _0: response
        };
}

var MRTransform_DidStartRecording = {
  message_encode: message_encode$84,
  message_decode: message_decode$84,
  response_encode: response_encode$84,
  response_decode: response_decode$84,
  allMessage_encode: allMessage_encode$6,
  allMessage_decode: allMessage_decode$6,
  allResponse_encode: allResponse_encode$6,
  allResponse_decode: allResponse_decode$6,
  responseError_encode: responseError_encode$6,
  responseError_decode: responseError_decode$6,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$6,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$6,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$6
};

var partial_arg$6 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var DidStartRecording = partial_arg$6(MRTransform_DidStartRecording, AllWrapper);

var message_encode$85 = message_encode$8;

var message_decode$85 = message_decode$8;

function response_encode$85(v) {
  return ["AckPossibleCommand"];
}

var response_decode$85 = response_decode$8;

var allMessage_encode$7 = message_encode$77;

var allMessage_decode$7 = message_decode$77;

var allResponse_encode$7 = response_encode$77;

var allResponse_decode$7 = response_decode$77;

var responseError_encode$7 = Decco.stringToJson;

var responseError_decode$7 = Decco.stringFromJson;

function wrapMessageAsAllMessage$7(message) {
  return {
          TAG: /* Message_NotifyBgAboutPossibleCommand */7,
          _0: message
        };
}

function unwrapAllResponseAsResponse$7(allResponse) {
  if (allResponse.TAG === /* Response_NotifyBgAboutPossibleCommand */7) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$7(response) {
  return {
          TAG: /* Response_NotifyBgAboutPossibleCommand */7,
          _0: response
        };
}

var MRTransform_NotifyBgAboutPossibleCommand = {
  message_encode: message_encode$85,
  message_decode: message_decode$85,
  response_encode: response_encode$85,
  response_decode: response_decode$85,
  allMessage_encode: allMessage_encode$7,
  allMessage_decode: allMessage_decode$7,
  allResponse_encode: allResponse_encode$7,
  allResponse_decode: allResponse_decode$7,
  responseError_encode: responseError_encode$7,
  responseError_decode: responseError_decode$7,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$7,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$7,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$7
};

var partial_arg$7 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var NotifyBgAboutPossibleCommand = partial_arg$7(MRTransform_NotifyBgAboutPossibleCommand, AllWrapper);

var message_encode$86 = message_encode$9;

var message_decode$86 = message_decode$9;

function response_encode$86(v) {
  return ["AckClearKeyThatDoesNotGenerateCommand"];
}

var response_decode$86 = response_decode$9;

var allMessage_encode$8 = message_encode$77;

var allMessage_decode$8 = message_decode$77;

var allResponse_encode$8 = response_encode$77;

var allResponse_decode$8 = response_decode$77;

var responseError_encode$8 = Decco.stringToJson;

var responseError_decode$8 = Decco.stringFromJson;

function wrapMessageAsAllMessage$8(message) {
  return {
          TAG: /* Message_ClearKeyThatDoesNotGenerateCommand */8,
          _0: message
        };
}

function unwrapAllResponseAsResponse$8(allResponse) {
  if (allResponse.TAG === /* Response_ClearKeyThatDoesNotGenerateCommand */8) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$8(response) {
  return {
          TAG: /* Response_ClearKeyThatDoesNotGenerateCommand */8,
          _0: response
        };
}

var MRTransform_ClearKeyThatDoesNotGenerateCommand = {
  message_encode: message_encode$86,
  message_decode: message_decode$86,
  response_encode: response_encode$86,
  response_decode: response_decode$86,
  allMessage_encode: allMessage_encode$8,
  allMessage_decode: allMessage_decode$8,
  allResponse_encode: allResponse_encode$8,
  allResponse_decode: allResponse_decode$8,
  responseError_encode: responseError_encode$8,
  responseError_decode: responseError_decode$8,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$8,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$8,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$8
};

var partial_arg$8 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var ClearKeyThatDoesNotGenerateCommand = partial_arg$8(MRTransform_ClearKeyThatDoesNotGenerateCommand, AllWrapper);

var message_encode$87 = message_encode$10;

var message_decode$87 = message_decode$10;

var response_encode$87 = response_encode$10;

var response_decode$87 = response_decode$10;

var allMessage_encode$9 = message_encode$77;

var allMessage_decode$9 = message_decode$77;

var allResponse_encode$9 = response_encode$77;

var allResponse_decode$9 = response_decode$77;

var responseError_encode$9 = Decco.stringToJson;

var responseError_decode$9 = Decco.stringFromJson;

function wrapMessageAsAllMessage$9(message) {
  return {
          TAG: /* Message_RecordCommand */9,
          _0: message
        };
}

function unwrapAllResponseAsResponse$9(allResponse) {
  if (allResponse.TAG === /* Response_RecordCommand */9) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$9(response) {
  return {
          TAG: /* Response_RecordCommand */9,
          _0: response
        };
}

var MRTransform_RecordCommand = {
  message_encode: message_encode$87,
  message_decode: message_decode$87,
  response_encode: response_encode$87,
  response_decode: response_decode$87,
  allMessage_encode: allMessage_encode$9,
  allMessage_decode: allMessage_decode$9,
  allResponse_encode: allResponse_encode$9,
  allResponse_decode: allResponse_decode$9,
  responseError_encode: responseError_encode$9,
  responseError_decode: responseError_decode$9,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$9,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$9,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$9
};

var partial_arg$9 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var RecordCommand = partial_arg$9(MRTransform_RecordCommand, AllWrapper);

var message_encode$88 = message_encode$11;

var message_decode$88 = message_decode$11;

var response_encode$88 = response_encode$11;

var response_decode$88 = response_decode$11;

var allMessage_encode$10 = message_encode$77;

var allMessage_decode$10 = message_decode$77;

var allResponse_encode$10 = response_encode$77;

var allResponse_decode$10 = response_decode$77;

var responseError_encode$10 = Decco.stringToJson;

var responseError_decode$10 = Decco.stringFromJson;

function wrapMessageAsAllMessage$10(message) {
  return {
          TAG: /* Message_FinishAuthoring */10,
          _0: message
        };
}

function unwrapAllResponseAsResponse$10(allResponse) {
  if (allResponse.TAG === /* Response_FinishAuthoring */10) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$10(response) {
  return {
          TAG: /* Response_FinishAuthoring */10,
          _0: response
        };
}

var MRTransform_FinishAuthoring = {
  message_encode: message_encode$88,
  message_decode: message_decode$88,
  response_encode: response_encode$88,
  response_decode: response_decode$88,
  allMessage_encode: allMessage_encode$10,
  allMessage_decode: allMessage_decode$10,
  allResponse_encode: allResponse_encode$10,
  allResponse_decode: allResponse_decode$10,
  responseError_encode: responseError_encode$10,
  responseError_decode: responseError_decode$10,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$10,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$10,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$10
};

var partial_arg$10 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var FinishAuthoring = partial_arg$10(MRTransform_FinishAuthoring, AllWrapper);

var message_encode$89 = message_encode$12;

var message_decode$89 = message_decode$12;

var response_encode$89 = response_encode$12;

var response_decode$89 = response_decode$12;

var allMessage_encode$11 = message_encode$77;

var allMessage_decode$11 = message_decode$77;

var allResponse_encode$11 = response_encode$77;

var allResponse_decode$11 = response_decode$77;

var responseError_encode$11 = Decco.stringToJson;

var responseError_decode$11 = Decco.stringFromJson;

function wrapMessageAsAllMessage$11(message) {
  return {
          TAG: /* Message_OpenPageForSmartcutId */11,
          _0: message
        };
}

function unwrapAllResponseAsResponse$11(allResponse) {
  if (allResponse.TAG === /* Response_OpenPageForSmartcutId */11) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$11(response) {
  return {
          TAG: /* Response_OpenPageForSmartcutId */11,
          _0: response
        };
}

var MRTransform_OpenPageForSmartcutId = {
  message_encode: message_encode$89,
  message_decode: message_decode$89,
  response_encode: response_encode$89,
  response_decode: response_decode$89,
  allMessage_encode: allMessage_encode$11,
  allMessage_decode: allMessage_decode$11,
  allResponse_encode: allResponse_encode$11,
  allResponse_decode: allResponse_decode$11,
  responseError_encode: responseError_encode$11,
  responseError_decode: responseError_decode$11,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$11,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$11,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$11
};

var partial_arg$11 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var OpenPageForSmartcutId = partial_arg$11(MRTransform_OpenPageForSmartcutId, AllWrapper);

var message_encode$90 = message_encode$13;

var message_decode$90 = message_decode$13;

var response_encode$90 = response_encode$13;

var response_decode$90 = response_decode$13;

var allMessage_encode$12 = message_encode$77;

var allMessage_decode$12 = message_decode$77;

var allResponse_encode$12 = response_encode$77;

var allResponse_decode$12 = response_decode$77;

var responseError_encode$12 = Decco.stringToJson;

var responseError_decode$12 = Decco.stringFromJson;

function wrapMessageAsAllMessage$12(message) {
  return {
          TAG: /* Message_ShowFormForSmartcutId */12,
          _0: message
        };
}

function unwrapAllResponseAsResponse$12(allResponse) {
  if (allResponse.TAG === /* Response_ShowFormForSmartcutId */12) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$12(response) {
  return {
          TAG: /* Response_ShowFormForSmartcutId */12,
          _0: response
        };
}

var MRTransform_ShowFormForSmartcutId = {
  message_encode: message_encode$90,
  message_decode: message_decode$90,
  response_encode: response_encode$90,
  response_decode: response_decode$90,
  allMessage_encode: allMessage_encode$12,
  allMessage_decode: allMessage_decode$12,
  allResponse_encode: allResponse_encode$12,
  allResponse_decode: allResponse_decode$12,
  responseError_encode: responseError_encode$12,
  responseError_decode: responseError_decode$12,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$12,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$12,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$12
};

var partial_arg$12 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var ShowFormForSmartcutId = partial_arg$12(MRTransform_ShowFormForSmartcutId, AllWrapper);

var message_encode$91 = message_encode$14;

var message_decode$91 = message_decode$14;

var response_encode$91 = response_encode$14;

var response_decode$91 = response_decode$14;

var allMessage_encode$13 = message_encode$77;

var allMessage_decode$13 = message_decode$77;

var allResponse_encode$13 = response_encode$77;

var allResponse_decode$13 = response_decode$77;

var responseError_encode$13 = Decco.stringToJson;

var responseError_decode$13 = Decco.stringFromJson;

function wrapMessageAsAllMessage$13(message) {
  return {
          TAG: /* Message_AskBgToAdjustModalGeometry */13,
          _0: message
        };
}

function unwrapAllResponseAsResponse$13(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToAdjustModalGeometry */13) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$13(response) {
  return {
          TAG: /* Response_AskBgToAdjustModalGeometry */13,
          _0: response
        };
}

var MRTransform_AskBgToAdjustModalGeometry = {
  message_encode: message_encode$91,
  message_decode: message_decode$91,
  response_encode: response_encode$91,
  response_decode: response_decode$91,
  allMessage_encode: allMessage_encode$13,
  allMessage_decode: allMessage_decode$13,
  allResponse_encode: allResponse_encode$13,
  allResponse_decode: allResponse_decode$13,
  responseError_encode: responseError_encode$13,
  responseError_decode: responseError_decode$13,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$13,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$13,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$13
};

var partial_arg$13 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToAdjustModalGeometry = partial_arg$13(MRTransform_AskBgToAdjustModalGeometry, AllWrapper);

var message_encode$92 = message_encode$15;

var message_decode$92 = message_decode$15;

function response_encode$92(v) {
  return ["BgDidInitializePlayback"];
}

var response_decode$92 = response_decode$15;

var allMessage_encode$14 = message_encode$77;

var allMessage_decode$14 = message_decode$77;

var allResponse_encode$14 = response_encode$77;

var allResponse_decode$14 = response_decode$77;

var responseError_encode$14 = Decco.stringToJson;

var responseError_decode$14 = Decco.stringFromJson;

function wrapMessageAsAllMessage$14(message) {
  return {
          TAG: /* Message_InitializePlayback */14,
          _0: message
        };
}

function unwrapAllResponseAsResponse$14(allResponse) {
  if (allResponse.TAG === /* Response_InitializePlayback */14) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$14(response) {
  return {
          TAG: /* Response_InitializePlayback */14,
          _0: response
        };
}

var MRTransform_InitializePlayback = {
  message_encode: message_encode$92,
  message_decode: message_decode$92,
  response_encode: response_encode$92,
  response_decode: response_decode$92,
  allMessage_encode: allMessage_encode$14,
  allMessage_decode: allMessage_decode$14,
  allResponse_encode: allResponse_encode$14,
  allResponse_decode: allResponse_decode$14,
  responseError_encode: responseError_encode$14,
  responseError_decode: responseError_decode$14,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$14,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$14,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$14
};

var partial_arg$14 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var InitializePlayback = partial_arg$14(MRTransform_InitializePlayback, AllWrapper);

var message_encode$93 = message_encode$16;

var message_decode$93 = message_decode$16;

var response_encode$93 = response_encode$16;

var response_decode$93 = response_decode$16;

var allMessage_encode$15 = message_encode$77;

var allMessage_decode$15 = message_decode$77;

var allResponse_encode$15 = response_encode$77;

var allResponse_decode$15 = response_decode$77;

var responseError_encode$15 = Decco.stringToJson;

var responseError_decode$15 = Decco.stringFromJson;

function wrapMessageAsAllMessage$15(message) {
  return {
          TAG: /* Message_GetAuthoringCommandLog */15,
          _0: message
        };
}

function unwrapAllResponseAsResponse$15(allResponse) {
  if (allResponse.TAG === /* Response_GetAuthoringCommandLog */15) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$15(response) {
  return {
          TAG: /* Response_GetAuthoringCommandLog */15,
          _0: response
        };
}

var MRTransform_GetAuthoringCommandLog = {
  message_encode: message_encode$93,
  message_decode: message_decode$93,
  response_encode: response_encode$93,
  response_decode: response_decode$93,
  allMessage_encode: allMessage_encode$15,
  allMessage_decode: allMessage_decode$15,
  allResponse_encode: allResponse_encode$15,
  allResponse_decode: allResponse_decode$15,
  responseError_encode: responseError_encode$15,
  responseError_decode: responseError_decode$15,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$15,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$15,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$15
};

var partial_arg$15 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var GetAuthoringCommandLog = partial_arg$15(MRTransform_GetAuthoringCommandLog, AllWrapper);

var message_encode$94 = message_encode$17;

var message_decode$94 = message_decode$17;

var response_encode$94 = response_encode$17;

var response_decode$94 = response_decode$17;

var allMessage_encode$16 = message_encode$77;

var allMessage_decode$16 = message_decode$77;

var allResponse_encode$16 = response_encode$77;

var allResponse_decode$16 = response_decode$77;

var responseError_encode$16 = Decco.stringToJson;

var responseError_decode$16 = Decco.stringFromJson;

function wrapMessageAsAllMessage$16(message) {
  return {
          TAG: /* Message_GetSmartcut */16,
          _0: message
        };
}

function unwrapAllResponseAsResponse$16(allResponse) {
  if (allResponse.TAG === /* Response_GetSmartcut */16) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$16(response) {
  return {
          TAG: /* Response_GetSmartcut */16,
          _0: response
        };
}

var MRTransform_GetSmartcut = {
  message_encode: message_encode$94,
  message_decode: message_decode$94,
  response_encode: response_encode$94,
  response_decode: response_decode$94,
  allMessage_encode: allMessage_encode$16,
  allMessage_decode: allMessage_decode$16,
  allResponse_encode: allResponse_encode$16,
  allResponse_decode: allResponse_decode$16,
  responseError_encode: responseError_encode$16,
  responseError_decode: responseError_decode$16,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$16,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$16,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$16
};

var partial_arg$16 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var GetSmartcut = partial_arg$16(MRTransform_GetSmartcut, AllWrapper);

function message_encode$95(v) {
  return ["GetMySmartcuts"];
}

var message_decode$95 = message_decode$18;

var response_encode$95 = response_encode$18;

var response_decode$95 = response_decode$18;

var allMessage_encode$17 = message_encode$77;

var allMessage_decode$17 = message_decode$77;

var allResponse_encode$17 = response_encode$77;

var allResponse_decode$17 = response_decode$77;

var responseError_encode$17 = Decco.stringToJson;

var responseError_decode$17 = Decco.stringFromJson;

function wrapMessageAsAllMessage$17(message) {
  return {
          TAG: /* Message_GetMySmartcuts */17,
          _0: message
        };
}

function unwrapAllResponseAsResponse$17(allResponse) {
  if (allResponse.TAG === /* Response_GetMySmartcuts */17) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$17(response) {
  return {
          TAG: /* Response_GetMySmartcuts */17,
          _0: response
        };
}

var MRTransform_GetMySmartcuts = {
  message_encode: message_encode$95,
  message_decode: message_decode$95,
  response_encode: response_encode$95,
  response_decode: response_decode$95,
  allMessage_encode: allMessage_encode$17,
  allMessage_decode: allMessage_decode$17,
  allResponse_encode: allResponse_encode$17,
  allResponse_decode: allResponse_decode$17,
  responseError_encode: responseError_encode$17,
  responseError_decode: responseError_decode$17,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$17,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$17,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$17
};

var partial_arg$17 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var GetMySmartcuts = partial_arg$17(MRTransform_GetMySmartcuts, AllWrapper);

var message_encode$96 = message_encode$19;

var message_decode$96 = message_decode$19;

var response_encode$96 = response_encode$19;

var response_decode$96 = response_decode$19;

var allMessage_encode$18 = message_encode$77;

var allMessage_decode$18 = message_decode$77;

var allResponse_encode$18 = response_encode$77;

var allResponse_decode$18 = response_decode$77;

var responseError_encode$18 = Decco.stringToJson;

var responseError_decode$18 = Decco.stringFromJson;

function wrapMessageAsAllMessage$18(message) {
  return {
          TAG: /* Message_InstallSmartcut */18,
          _0: message
        };
}

function unwrapAllResponseAsResponse$18(allResponse) {
  if (allResponse.TAG === /* Response_InstallSmartcut */18) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$18(response) {
  return {
          TAG: /* Response_InstallSmartcut */18,
          _0: response
        };
}

var MRTransform_InstallSmartcut = {
  message_encode: message_encode$96,
  message_decode: message_decode$96,
  response_encode: response_encode$96,
  response_decode: response_decode$96,
  allMessage_encode: allMessage_encode$18,
  allMessage_decode: allMessage_decode$18,
  allResponse_encode: allResponse_encode$18,
  allResponse_decode: allResponse_decode$18,
  responseError_encode: responseError_encode$18,
  responseError_decode: responseError_decode$18,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$18,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$18,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$18
};

var message_encode$97 = message_encode$20;

var message_decode$97 = message_decode$20;

var response_encode$97 = response_encode$20;

var response_decode$97 = response_decode$20;

var allMessage_encode$19 = message_encode$77;

var allMessage_decode$19 = message_decode$77;

var allResponse_encode$19 = response_encode$77;

var allResponse_decode$19 = response_decode$77;

var responseError_encode$19 = Decco.stringToJson;

var responseError_decode$19 = Decco.stringFromJson;

function wrapMessageAsAllMessage$19(message) {
  return {
          TAG: /* Message_DeleteSmartcut */19,
          _0: message
        };
}

function unwrapAllResponseAsResponse$19(allResponse) {
  if (allResponse.TAG === /* Response_DeleteSmartcut */19) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$19(response) {
  return {
          TAG: /* Response_DeleteSmartcut */19,
          _0: response
        };
}

var MRTransform_DeleteSmartcut = {
  message_encode: message_encode$97,
  message_decode: message_decode$97,
  response_encode: response_encode$97,
  response_decode: response_decode$97,
  allMessage_encode: allMessage_encode$19,
  allMessage_decode: allMessage_decode$19,
  allResponse_encode: allResponse_encode$19,
  allResponse_decode: allResponse_decode$19,
  responseError_encode: responseError_encode$19,
  responseError_decode: responseError_decode$19,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$19,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$19,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$19
};

var partial_arg$18 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var InstallSmartcut = partial_arg$18(MRTransform_InstallSmartcut, AllWrapper);

var partial_arg$19 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var DeleteSmartcut = partial_arg$19(MRTransform_DeleteSmartcut, AllWrapper);

var message_encode$98 = message_encode$21;

var message_decode$98 = message_decode$21;

var response_encode$98 = response_encode$21;

var response_decode$98 = response_decode$21;

var allMessage_encode$20 = message_encode$77;

var allMessage_decode$20 = message_decode$77;

var allResponse_encode$20 = response_encode$77;

var allResponse_decode$20 = response_decode$77;

var responseError_encode$20 = Decco.stringToJson;

var responseError_decode$20 = Decco.stringFromJson;

function wrapMessageAsAllMessage$20(message) {
  return {
          TAG: /* Message_GetExecutionHistoryForSmartcut */20,
          _0: message
        };
}

function unwrapAllResponseAsResponse$20(allResponse) {
  if (allResponse.TAG === /* Response_GetExecutionHistoryForSmartcut */20) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$20(response) {
  return {
          TAG: /* Response_GetExecutionHistoryForSmartcut */20,
          _0: response
        };
}

var MRTransform_GetExecutionHistoryForSmartcut = {
  message_encode: message_encode$98,
  message_decode: message_decode$98,
  response_encode: response_encode$98,
  response_decode: response_decode$98,
  allMessage_encode: allMessage_encode$20,
  allMessage_decode: allMessage_decode$20,
  allResponse_encode: allResponse_encode$20,
  allResponse_decode: allResponse_decode$20,
  responseError_encode: responseError_encode$20,
  responseError_decode: responseError_decode$20,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$20,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$20,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$20
};

var partial_arg$20 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var GetExecutionHistoryForSmartcut = partial_arg$20(MRTransform_GetExecutionHistoryForSmartcut, AllWrapper);

var message_encode$99 = message_encode$22;

var message_decode$99 = message_decode$22;

var response_encode$99 = response_encode$22;

var response_decode$99 = response_decode$22;

var allMessage_encode$21 = message_encode$77;

var allMessage_decode$21 = message_decode$77;

var allResponse_encode$21 = response_encode$77;

var allResponse_decode$21 = response_decode$77;

var responseError_encode$21 = Decco.stringToJson;

var responseError_decode$21 = Decco.stringFromJson;

function wrapMessageAsAllMessage$21(message) {
  return {
          TAG: /* Message_GetScheduledTriggersForSmartcut */21,
          _0: message
        };
}

function unwrapAllResponseAsResponse$21(allResponse) {
  if (allResponse.TAG === /* Response_GetScheduledTriggersForSmartcut */21) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$21(response) {
  return {
          TAG: /* Response_GetScheduledTriggersForSmartcut */21,
          _0: response
        };
}

var MRTransform_GetScheduledTriggersForSmartcut = {
  message_encode: message_encode$99,
  message_decode: message_decode$99,
  response_encode: response_encode$99,
  response_decode: response_decode$99,
  allMessage_encode: allMessage_encode$21,
  allMessage_decode: allMessage_decode$21,
  allResponse_encode: allResponse_encode$21,
  allResponse_decode: allResponse_decode$21,
  responseError_encode: responseError_encode$21,
  responseError_decode: responseError_decode$21,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$21,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$21,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$21
};

var partial_arg$21 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var GetScheduledTriggersForSmartcut = partial_arg$21(MRTransform_GetScheduledTriggersForSmartcut, AllWrapper);

var message_encode$100 = message_encode$23;

var message_decode$100 = message_decode$23;

var response_encode$100 = response_encode$23;

var response_decode$100 = response_decode$23;

var allMessage_encode$22 = message_encode$77;

var allMessage_decode$22 = message_decode$77;

var allResponse_encode$22 = response_encode$77;

var allResponse_decode$22 = response_decode$77;

var responseError_encode$22 = Decco.stringToJson;

var responseError_decode$22 = Decco.stringFromJson;

function wrapMessageAsAllMessage$22(message) {
  return {
          TAG: /* Message_FindExecutionById */22,
          _0: message
        };
}

function unwrapAllResponseAsResponse$22(allResponse) {
  if (allResponse.TAG === /* Response_FindExecutionById */22) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$22(response) {
  return {
          TAG: /* Response_FindExecutionById */22,
          _0: response
        };
}

var MRTransform_FindExecutionById = {
  message_encode: message_encode$100,
  message_decode: message_decode$100,
  response_encode: response_encode$100,
  response_decode: response_decode$100,
  allMessage_encode: allMessage_encode$22,
  allMessage_decode: allMessage_decode$22,
  allResponse_encode: allResponse_encode$22,
  allResponse_decode: allResponse_decode$22,
  responseError_encode: responseError_encode$22,
  responseError_decode: responseError_decode$22,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$22,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$22,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$22
};

var partial_arg$22 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var FindExecutionById = partial_arg$22(MRTransform_FindExecutionById, AllWrapper);

var message_encode$101 = message_encode$24;

var message_decode$101 = message_decode$24;

var response_encode$101 = response_encode$24;

var response_decode$101 = response_decode$24;

var allMessage_encode$23 = message_encode$77;

var allMessage_decode$23 = message_decode$77;

var allResponse_encode$23 = response_encode$77;

var allResponse_decode$23 = response_decode$77;

var responseError_encode$23 = Decco.stringToJson;

var responseError_decode$23 = Decco.stringFromJson;

function wrapMessageAsAllMessage$23(message) {
  return {
          TAG: /* Message_UpdateExecutionStatus */23,
          _0: message
        };
}

function unwrapAllResponseAsResponse$23(allResponse) {
  if (allResponse.TAG === /* Response_UpdateExecutionStatus */23) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$23(response) {
  return {
          TAG: /* Response_UpdateExecutionStatus */23,
          _0: response
        };
}

var MRTransform_UpdateExecutionStatus = {
  message_encode: message_encode$101,
  message_decode: message_decode$101,
  response_encode: response_encode$101,
  response_decode: response_decode$101,
  allMessage_encode: allMessage_encode$23,
  allMessage_decode: allMessage_decode$23,
  allResponse_encode: allResponse_encode$23,
  allResponse_decode: allResponse_decode$23,
  responseError_encode: responseError_encode$23,
  responseError_decode: responseError_decode$23,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$23,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$23,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$23
};

var partial_arg$23 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UpdateExecutionStatus = partial_arg$23(MRTransform_UpdateExecutionStatus, AllWrapper);

var message_encode$102 = message_encode$25;

var message_decode$102 = message_decode$25;

var response_encode$102 = response_encode$25;

var response_decode$102 = response_decode$25;

var allMessage_encode$24 = message_encode$77;

var allMessage_decode$24 = message_decode$77;

var allResponse_encode$24 = response_encode$77;

var allResponse_decode$24 = response_decode$77;

var responseError_encode$24 = Decco.stringToJson;

var responseError_decode$24 = Decco.stringFromJson;

function wrapMessageAsAllMessage$24(message) {
  return {
          TAG: /* Message_UpsertExecutionSet */24,
          _0: message
        };
}

function unwrapAllResponseAsResponse$24(allResponse) {
  if (allResponse.TAG === /* Response_UpsertExecutionSet */24) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$24(response) {
  return {
          TAG: /* Response_UpsertExecutionSet */24,
          _0: response
        };
}

var MRTransform_UpsertExecutionSet = {
  message_encode: message_encode$102,
  message_decode: message_decode$102,
  response_encode: response_encode$102,
  response_decode: response_decode$102,
  allMessage_encode: allMessage_encode$24,
  allMessage_decode: allMessage_decode$24,
  allResponse_encode: allResponse_encode$24,
  allResponse_decode: allResponse_decode$24,
  responseError_encode: responseError_encode$24,
  responseError_decode: responseError_decode$24,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$24,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$24,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$24
};

var partial_arg$24 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UpsertExecutionSet = partial_arg$24(MRTransform_UpsertExecutionSet, AllWrapper);

var message_encode$103 = message_encode$26;

var message_decode$103 = message_decode$26;

var response_encode$103 = response_encode$26;

var response_decode$103 = response_decode$26;

var allMessage_encode$25 = message_encode$77;

var allMessage_decode$25 = message_decode$77;

var allResponse_encode$25 = response_encode$77;

var allResponse_decode$25 = response_decode$77;

var responseError_encode$25 = Decco.stringToJson;

var responseError_decode$25 = Decco.stringFromJson;

function wrapMessageAsAllMessage$25(message) {
  return {
          TAG: /* Message_DeleteExecutionSet */25,
          _0: message
        };
}

function unwrapAllResponseAsResponse$25(allResponse) {
  if (allResponse.TAG === /* Response_DeleteExecutionSet */25) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$25(response) {
  return {
          TAG: /* Response_DeleteExecutionSet */25,
          _0: response
        };
}

var MRTransform_DeleteExecutionSet = {
  message_encode: message_encode$103,
  message_decode: message_decode$103,
  response_encode: response_encode$103,
  response_decode: response_decode$103,
  allMessage_encode: allMessage_encode$25,
  allMessage_decode: allMessage_decode$25,
  allResponse_encode: allResponse_encode$25,
  allResponse_decode: allResponse_decode$25,
  responseError_encode: responseError_encode$25,
  responseError_decode: responseError_decode$25,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$25,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$25,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$25
};

var partial_arg$25 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var DeleteExecutionSet = partial_arg$25(MRTransform_DeleteExecutionSet, AllWrapper);

function message_encode$104(v) {
  return ["GetExecutionSetProgress"];
}

var message_decode$104 = message_decode$27;

var response_encode$104 = response_encode$27;

var response_decode$104 = response_decode$27;

var allMessage_encode$26 = message_encode$77;

var allMessage_decode$26 = message_decode$77;

var allResponse_encode$26 = response_encode$77;

var allResponse_decode$26 = response_decode$77;

var responseError_encode$26 = Decco.stringToJson;

var responseError_decode$26 = Decco.stringFromJson;

function wrapMessageAsAllMessage$26(message) {
  return {
          TAG: /* Message_GetExecutionSetProgress */26,
          _0: message
        };
}

function unwrapAllResponseAsResponse$26(allResponse) {
  if (allResponse.TAG === /* Response_GetExecutionSetProgress */26) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$26(response) {
  return {
          TAG: /* Response_GetExecutionSetProgress */26,
          _0: response
        };
}

var MRTransform_GetExecutionSetProgress = {
  message_encode: message_encode$104,
  message_decode: message_decode$104,
  response_encode: response_encode$104,
  response_decode: response_decode$104,
  allMessage_encode: allMessage_encode$26,
  allMessage_decode: allMessage_decode$26,
  allResponse_encode: allResponse_encode$26,
  allResponse_decode: allResponse_decode$26,
  responseError_encode: responseError_encode$26,
  responseError_decode: responseError_decode$26,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$26,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$26,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$26
};

var partial_arg$26 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var GetExecutionSetProgress = partial_arg$26(MRTransform_GetExecutionSetProgress, AllWrapper);

var message_encode$105 = message_encode$28;

var message_decode$105 = message_decode$28;

var response_encode$105 = response_encode$28;

var response_decode$105 = response_decode$28;

var allMessage_encode$27 = message_encode$77;

var allMessage_decode$27 = message_decode$77;

var allResponse_encode$27 = response_encode$77;

var allResponse_decode$27 = response_decode$77;

var responseError_encode$27 = Decco.stringToJson;

var responseError_decode$27 = Decco.stringFromJson;

function wrapMessageAsAllMessage$27(message) {
  return {
          TAG: /* Message_GetExecutionSetById */27,
          _0: message
        };
}

function unwrapAllResponseAsResponse$27(allResponse) {
  if (allResponse.TAG === /* Response_GetExecutionSetById */27) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$27(response) {
  return {
          TAG: /* Response_GetExecutionSetById */27,
          _0: response
        };
}

var MRTransform_GetExecutionSetById = {
  message_encode: message_encode$105,
  message_decode: message_decode$105,
  response_encode: response_encode$105,
  response_decode: response_decode$105,
  allMessage_encode: allMessage_encode$27,
  allMessage_decode: allMessage_decode$27,
  allResponse_encode: allResponse_encode$27,
  allResponse_decode: allResponse_decode$27,
  responseError_encode: responseError_encode$27,
  responseError_decode: responseError_decode$27,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$27,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$27,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$27
};

var partial_arg$27 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var GetExecutionSetById = partial_arg$27(MRTransform_GetExecutionSetById, AllWrapper);

var message_encode$106 = message_encode$29;

var message_decode$106 = message_decode$29;

var response_encode$106 = response_encode$29;

var response_decode$106 = response_decode$29;

var allMessage_encode$28 = message_encode$77;

var allMessage_decode$28 = message_decode$77;

var allResponse_encode$28 = response_encode$77;

var allResponse_decode$28 = response_decode$77;

var responseError_encode$28 = Decco.stringToJson;

var responseError_decode$28 = Decco.stringFromJson;

function wrapMessageAsAllMessage$28(message) {
  return {
          TAG: /* Message_UpsertScheduledTriggerAndCreateAlarm */28,
          _0: message
        };
}

function unwrapAllResponseAsResponse$28(allResponse) {
  if (allResponse.TAG === /* Response_UpsertScheduledTriggerAndCreateAlarm */28) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$28(response) {
  return {
          TAG: /* Response_UpsertScheduledTriggerAndCreateAlarm */28,
          _0: response
        };
}

var MRTransform_UpsertScheduledTriggerAndCreateAlarm = {
  message_encode: message_encode$106,
  message_decode: message_decode$106,
  response_encode: response_encode$106,
  response_decode: response_decode$106,
  allMessage_encode: allMessage_encode$28,
  allMessage_decode: allMessage_decode$28,
  allResponse_encode: allResponse_encode$28,
  allResponse_decode: allResponse_decode$28,
  responseError_encode: responseError_encode$28,
  responseError_decode: responseError_decode$28,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$28,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$28,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$28
};

var partial_arg$28 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UpsertScheduledTriggerAndCreateAlarm = partial_arg$28(MRTransform_UpsertScheduledTriggerAndCreateAlarm, AllWrapper);

var message_encode$107 = message_encode$30;

var message_decode$107 = message_decode$30;

var response_encode$107 = response_encode$30;

var response_decode$107 = response_decode$30;

var allMessage_encode$29 = message_encode$77;

var allMessage_decode$29 = message_decode$77;

var allResponse_encode$29 = response_encode$77;

var allResponse_decode$29 = response_decode$77;

var responseError_encode$29 = Decco.stringToJson;

var responseError_decode$29 = Decco.stringFromJson;

function wrapMessageAsAllMessage$29(message) {
  return {
          TAG: /* Message_ArchiveScheduledTrigger */29,
          _0: message
        };
}

function unwrapAllResponseAsResponse$29(allResponse) {
  if (allResponse.TAG === /* Response_ArchiveScheduledTrigger */29) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$29(response) {
  return {
          TAG: /* Response_ArchiveScheduledTrigger */29,
          _0: response
        };
}

var MRTransform_ArchiveScheduledTrigger = {
  message_encode: message_encode$107,
  message_decode: message_decode$107,
  response_encode: response_encode$107,
  response_decode: response_decode$107,
  allMessage_encode: allMessage_encode$29,
  allMessage_decode: allMessage_decode$29,
  allResponse_encode: allResponse_encode$29,
  allResponse_decode: allResponse_decode$29,
  responseError_encode: responseError_encode$29,
  responseError_decode: responseError_decode$29,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$29,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$29,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$29
};

var partial_arg$29 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var ArchiveScheduledTrigger = partial_arg$29(MRTransform_ArchiveScheduledTrigger, AllWrapper);

var message_encode$108 = message_encode$31;

var message_decode$108 = message_decode$31;

function response_encode$108(v) {
  return ["DidSaveExternalAccount"];
}

var response_decode$108 = response_decode$31;

var allMessage_encode$30 = message_encode$77;

var allMessage_decode$30 = message_decode$77;

var allResponse_encode$30 = response_encode$77;

var allResponse_decode$30 = response_decode$77;

var responseError_encode$30 = Decco.stringToJson;

var responseError_decode$30 = Decco.stringFromJson;

function wrapMessageAsAllMessage$30(message) {
  return {
          TAG: /* Message_SaveExternalAccount */30,
          _0: message
        };
}

function unwrapAllResponseAsResponse$30(allResponse) {
  if (allResponse.TAG === /* Response_SaveExternalAccount */30) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$30(response) {
  return {
          TAG: /* Response_SaveExternalAccount */30,
          _0: response
        };
}

var MRTransform_SaveExternalAccount = {
  message_encode: message_encode$108,
  message_decode: message_decode$108,
  response_encode: response_encode$108,
  response_decode: response_decode$108,
  allMessage_encode: allMessage_encode$30,
  allMessage_decode: allMessage_decode$30,
  allResponse_encode: allResponse_encode$30,
  allResponse_decode: allResponse_decode$30,
  responseError_encode: responseError_encode$30,
  responseError_decode: responseError_decode$30,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$30,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$30,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$30
};

var partial_arg$30 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var SaveExternalAccount = partial_arg$30(MRTransform_SaveExternalAccount, AllWrapper);

var message_encode$109 = message_encode$32;

var message_decode$109 = message_decode$32;

var response_encode$109 = response_encode$32;

var response_decode$109 = response_decode$32;

var allMessage_encode$31 = message_encode$77;

var allMessage_decode$31 = message_decode$77;

var allResponse_encode$31 = response_encode$77;

var allResponse_decode$31 = response_decode$77;

var responseError_encode$31 = Decco.stringToJson;

var responseError_decode$31 = Decco.stringFromJson;

function wrapMessageAsAllMessage$31(message) {
  return {
          TAG: /* Message_FindExternalAccountById */31,
          _0: message
        };
}

function unwrapAllResponseAsResponse$31(allResponse) {
  if (allResponse.TAG === /* Response_FindExternalAccountById */31) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$31(response) {
  return {
          TAG: /* Response_FindExternalAccountById */31,
          _0: response
        };
}

var MRTransform_FindExternalAccountById = {
  message_encode: message_encode$109,
  message_decode: message_decode$109,
  response_encode: response_encode$109,
  response_decode: response_decode$109,
  allMessage_encode: allMessage_encode$31,
  allMessage_decode: allMessage_decode$31,
  allResponse_encode: allResponse_encode$31,
  allResponse_decode: allResponse_decode$31,
  responseError_encode: responseError_encode$31,
  responseError_decode: responseError_decode$31,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$31,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$31,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$31
};

var partial_arg$31 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var FindExternalAccountById = partial_arg$31(MRTransform_FindExternalAccountById, AllWrapper);

var message_encode$110 = message_encode$33;

var message_decode$110 = message_decode$33;

var response_encode$110 = response_encode$33;

var response_decode$110 = response_decode$33;

var allMessage_encode$32 = message_encode$77;

var allMessage_decode$32 = message_decode$77;

var allResponse_encode$32 = response_encode$77;

var allResponse_decode$32 = response_decode$77;

var responseError_encode$32 = Decco.stringToJson;

var responseError_decode$32 = Decco.stringFromJson;

function wrapMessageAsAllMessage$32(message) {
  return {
          TAG: /* Message_GetOAuthToken */32,
          _0: message
        };
}

function unwrapAllResponseAsResponse$32(allResponse) {
  if (allResponse.TAG === /* Response_GetOAuthToken */32) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$32(response) {
  return {
          TAG: /* Response_GetOAuthToken */32,
          _0: response
        };
}

var MRTransform_GetOAuthToken = {
  message_encode: message_encode$110,
  message_decode: message_decode$110,
  response_encode: response_encode$110,
  response_decode: response_decode$110,
  allMessage_encode: allMessage_encode$32,
  allMessage_decode: allMessage_decode$32,
  allResponse_encode: allResponse_encode$32,
  allResponse_decode: allResponse_decode$32,
  responseError_encode: responseError_encode$32,
  responseError_decode: responseError_decode$32,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$32,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$32,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$32
};

var partial_arg$32 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var GetOAuthToken = partial_arg$32(MRTransform_GetOAuthToken, AllWrapper);

var message_encode$111 = message_encode$34;

var message_decode$111 = message_decode$34;

function response_encode$111(v) {
  return ["BgDidWriteToClipboard"];
}

var response_decode$111 = response_decode$34;

var allMessage_encode$33 = message_encode$77;

var allMessage_decode$33 = message_decode$77;

var allResponse_encode$33 = response_encode$77;

var allResponse_decode$33 = response_decode$77;

var responseError_encode$33 = Decco.stringToJson;

var responseError_decode$33 = Decco.stringFromJson;

function wrapMessageAsAllMessage$33(message) {
  return {
          TAG: /* Message_AskBgToClipboard */33,
          _0: message
        };
}

function unwrapAllResponseAsResponse$33(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToClipboard */33) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$33(response) {
  return {
          TAG: /* Response_AskBgToClipboard */33,
          _0: response
        };
}

var MRTransform_AskBgToClipboard = {
  message_encode: message_encode$111,
  message_decode: message_decode$111,
  response_encode: response_encode$111,
  response_decode: response_decode$111,
  allMessage_encode: allMessage_encode$33,
  allMessage_decode: allMessage_decode$33,
  allResponse_encode: allResponse_encode$33,
  allResponse_decode: allResponse_decode$33,
  responseError_encode: responseError_encode$33,
  responseError_decode: responseError_decode$33,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$33,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$33,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$33
};

var partial_arg$33 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToClipboard = partial_arg$33(MRTransform_AskBgToClipboard, AllWrapper);

var message_encode$112 = message_encode$35;

var message_decode$112 = message_decode$35;

var response_encode$112 = response_encode$35;

var response_decode$112 = response_decode$35;

var allMessage_encode$34 = message_encode$77;

var allMessage_decode$34 = message_decode$77;

var allResponse_encode$34 = response_encode$77;

var allResponse_decode$34 = response_decode$77;

var responseError_encode$34 = Decco.stringToJson;

var responseError_decode$34 = Decco.stringFromJson;

function wrapMessageAsAllMessage$34(message) {
  return {
          TAG: /* Message_CreateGoogleSheet */34,
          _0: message
        };
}

function unwrapAllResponseAsResponse$34(allResponse) {
  if (allResponse.TAG === /* Response_CreateGoogleSheet */34) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$34(response) {
  return {
          TAG: /* Response_CreateGoogleSheet */34,
          _0: response
        };
}

var MRTransform_CreateGoogleSheet = {
  message_encode: message_encode$112,
  message_decode: message_decode$112,
  response_encode: response_encode$112,
  response_decode: response_decode$112,
  allMessage_encode: allMessage_encode$34,
  allMessage_decode: allMessage_decode$34,
  allResponse_encode: allResponse_encode$34,
  allResponse_decode: allResponse_decode$34,
  responseError_encode: responseError_encode$34,
  responseError_decode: responseError_decode$34,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$34,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$34,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$34
};

var partial_arg$34 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var CreateGoogleSheet = partial_arg$34(MRTransform_CreateGoogleSheet, AllWrapper);

var message_encode$113 = message_encode$36;

var message_decode$113 = message_decode$36;

var response_encode$113 = response_encode$36;

var response_decode$113 = response_decode$36;

var allMessage_encode$35 = message_encode$77;

var allMessage_decode$35 = message_decode$77;

var allResponse_encode$35 = response_encode$77;

var allResponse_decode$35 = response_decode$77;

var responseError_encode$35 = Decco.stringToJson;

var responseError_decode$35 = Decco.stringFromJson;

function wrapMessageAsAllMessage$35(message) {
  return {
          TAG: /* Message_FetchGoogleSheet */35,
          _0: message
        };
}

function unwrapAllResponseAsResponse$35(allResponse) {
  if (allResponse.TAG === /* Response_FetchGoogleSheet */35) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$35(response) {
  return {
          TAG: /* Response_FetchGoogleSheet */35,
          _0: response
        };
}

var MRTransform_FetchGoogleSheet = {
  message_encode: message_encode$113,
  message_decode: message_decode$113,
  response_encode: response_encode$113,
  response_decode: response_decode$113,
  allMessage_encode: allMessage_encode$35,
  allMessage_decode: allMessage_decode$35,
  allResponse_encode: allResponse_encode$35,
  allResponse_decode: allResponse_decode$35,
  responseError_encode: responseError_encode$35,
  responseError_decode: responseError_decode$35,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$35,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$35,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$35
};

var partial_arg$35 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var FetchGoogleSheet = partial_arg$35(MRTransform_FetchGoogleSheet, AllWrapper);

var message_encode$114 = message_encode$37;

var message_decode$114 = message_decode$37;

var response_encode$114 = response_encode$37;

var response_decode$114 = response_decode$37;

var allMessage_encode$36 = message_encode$77;

var allMessage_decode$36 = message_decode$77;

var allResponse_encode$36 = response_encode$77;

var allResponse_decode$36 = response_decode$77;

var responseError_encode$36 = Decco.stringToJson;

var responseError_decode$36 = Decco.stringFromJson;

function wrapMessageAsAllMessage$36(message) {
  return {
          TAG: /* Message_BatchUpdateGoogleSheet */36,
          _0: message
        };
}

function unwrapAllResponseAsResponse$36(allResponse) {
  if (allResponse.TAG === /* Response_BatchUpdateGoogleSheet */36) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$36(response) {
  return {
          TAG: /* Response_BatchUpdateGoogleSheet */36,
          _0: response
        };
}

var MRTransform_BatchUpdateGoogleSheet = {
  message_encode: message_encode$114,
  message_decode: message_decode$114,
  response_encode: response_encode$114,
  response_decode: response_decode$114,
  allMessage_encode: allMessage_encode$36,
  allMessage_decode: allMessage_decode$36,
  allResponse_encode: allResponse_encode$36,
  allResponse_decode: allResponse_decode$36,
  responseError_encode: responseError_encode$36,
  responseError_decode: responseError_decode$36,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$36,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$36,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$36
};

var partial_arg$36 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var BatchUpdateGoogleSheet = partial_arg$36(MRTransform_BatchUpdateGoogleSheet, AllWrapper);

var message_encode$115 = message_encode$38;

var message_decode$115 = message_decode$38;

var response_encode$115 = response_encode$38;

var response_decode$115 = response_decode$38;

var allMessage_encode$37 = message_encode$77;

var allMessage_decode$37 = message_decode$77;

var allResponse_encode$37 = response_encode$77;

var allResponse_decode$37 = response_decode$77;

var responseError_encode$37 = Decco.stringToJson;

var responseError_decode$37 = Decco.stringFromJson;

function wrapMessageAsAllMessage$37(message) {
  return {
          TAG: /* Message_InitGoogleAuthFlow */37,
          _0: message
        };
}

function unwrapAllResponseAsResponse$37(allResponse) {
  if (allResponse.TAG === /* Response_InitGoogleAuthFlow */37) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$37(response) {
  return {
          TAG: /* Response_InitGoogleAuthFlow */37,
          _0: response
        };
}

var MRTransform_InitGoogleAuthFlow = {
  message_encode: message_encode$115,
  message_decode: message_decode$115,
  response_encode: response_encode$115,
  response_decode: response_decode$115,
  allMessage_encode: allMessage_encode$37,
  allMessage_decode: allMessage_decode$37,
  allResponse_encode: allResponse_encode$37,
  allResponse_decode: allResponse_decode$37,
  responseError_encode: responseError_encode$37,
  responseError_decode: responseError_decode$37,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$37,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$37,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$37
};

var partial_arg$37 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var InitGoogleAuthFlow = partial_arg$37(MRTransform_InitGoogleAuthFlow, AllWrapper);

function message_encode$116(v) {
  return ["UserDidCloseGoogleOAuthModal"];
}

var message_decode$116 = message_decode$39;

function response_encode$116(v) {
  return ["AckUserDidCloseGoogleOAuthModal"];
}

var response_decode$116 = response_decode$39;

var allMessage_encode$38 = message_encode$77;

var allMessage_decode$38 = message_decode$77;

var allResponse_encode$38 = response_encode$77;

var allResponse_decode$38 = response_decode$77;

var responseError_encode$38 = Decco.stringToJson;

var responseError_decode$38 = Decco.stringFromJson;

function wrapMessageAsAllMessage$38(message) {
  return {
          TAG: /* Message_UserDidCloseGoogleOAuthModal */38,
          _0: message
        };
}

function unwrapAllResponseAsResponse$38(allResponse) {
  if (allResponse.TAG === /* Response_UserDidCloseGoogleOAuthModal */38) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$38(response) {
  return {
          TAG: /* Response_UserDidCloseGoogleOAuthModal */38,
          _0: response
        };
}

var MRTransform_UserDidCloseGoogleOAuthModal = {
  message_encode: message_encode$116,
  message_decode: message_decode$116,
  response_encode: response_encode$116,
  response_decode: response_decode$116,
  allMessage_encode: allMessage_encode$38,
  allMessage_decode: allMessage_decode$38,
  allResponse_encode: allResponse_encode$38,
  allResponse_decode: allResponse_decode$38,
  responseError_encode: responseError_encode$38,
  responseError_decode: responseError_decode$38,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$38,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$38,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$38
};

var partial_arg$38 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UserDidCloseGoogleOAuthModal = partial_arg$38(MRTransform_UserDidCloseGoogleOAuthModal, AllWrapper);

var message_encode$117 = message_encode$40;

var message_decode$117 = message_decode$40;

function response_encode$117(v) {
  return ["Ok"];
}

var response_decode$117 = response_decode$40;

var allMessage_encode$39 = message_encode$77;

var allMessage_decode$39 = message_decode$77;

var allResponse_encode$39 = response_encode$77;

var allResponse_decode$39 = response_decode$77;

var responseError_encode$39 = Decco.stringToJson;

var responseError_decode$39 = Decco.stringFromJson;

function wrapMessageAsAllMessage$39(message) {
  return {
          TAG: /* Message_MultiUrlTriggering */39,
          _0: message
        };
}

function unwrapAllResponseAsResponse$39(allResponse) {
  if (allResponse.TAG === /* Response_MultiUrlTriggering */39) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$39(response) {
  return {
          TAG: /* Response_MultiUrlTriggering */39,
          _0: response
        };
}

var MRTransform_MultiUrlTriggering = {
  message_encode: message_encode$117,
  message_decode: message_decode$117,
  response_encode: response_encode$117,
  response_decode: response_decode$117,
  allMessage_encode: allMessage_encode$39,
  allMessage_decode: allMessage_decode$39,
  allResponse_encode: allResponse_encode$39,
  allResponse_decode: allResponse_decode$39,
  responseError_encode: responseError_encode$39,
  responseError_decode: responseError_decode$39,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$39,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$39,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$39
};

var partial_arg$39 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var MultiUrlTriggering = partial_arg$39(MRTransform_MultiUrlTriggering, AllWrapper);

var message_encode$118 = message_encode$41;

var message_decode$118 = message_decode$41;

var response_encode$118 = response_encode$41;

var response_decode$118 = response_decode$41;

var allMessage_encode$40 = message_encode$77;

var allMessage_decode$40 = message_decode$77;

var allResponse_encode$40 = response_encode$77;

var allResponse_decode$40 = response_decode$77;

var responseError_encode$40 = Decco.stringToJson;

var responseError_decode$40 = Decco.stringFromJson;

function wrapMessageAsAllMessage$40(message) {
  return {
          TAG: /* Message_DebugSelector */40,
          _0: message
        };
}

function unwrapAllResponseAsResponse$40(allResponse) {
  if (allResponse.TAG === /* Response_DebugSelector */40) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$40(response) {
  return {
          TAG: /* Response_DebugSelector */40,
          _0: response
        };
}

var MRTransform_DebugSelector = {
  message_encode: message_encode$118,
  message_decode: message_decode$118,
  response_encode: response_encode$118,
  response_decode: response_decode$118,
  allMessage_encode: allMessage_encode$40,
  allMessage_decode: allMessage_decode$40,
  allResponse_encode: allResponse_encode$40,
  allResponse_decode: allResponse_decode$40,
  responseError_encode: responseError_encode$40,
  responseError_decode: responseError_decode$40,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$40,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$40,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$40
};

var partial_arg$40 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var DebugSelector = partial_arg$40(MRTransform_DebugSelector, AllWrapper);

function message_encode$119(v) {
  return ["StopPlayback"];
}

var message_decode$119 = message_decode$42;

function response_encode$119(v) {
  return ["Ok"];
}

var response_decode$119 = response_decode$42;

var allMessage_encode$41 = message_encode$77;

var allMessage_decode$41 = message_decode$77;

var allResponse_encode$41 = response_encode$77;

var allResponse_decode$41 = response_decode$77;

var responseError_encode$41 = Decco.stringToJson;

var responseError_decode$41 = Decco.stringFromJson;

function wrapMessageAsAllMessage$41(message) {
  return {
          TAG: /* Message_PlaybackModeControl */41,
          _0: message
        };
}

function unwrapAllResponseAsResponse$41(allResponse) {
  if (allResponse.TAG === /* Response_PlaybackModeControl */41) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$41(response) {
  return {
          TAG: /* Response_PlaybackModeControl */41,
          _0: response
        };
}

var MRTransform_PlaybackModeControl = {
  message_encode: message_encode$119,
  message_decode: message_decode$119,
  response_encode: response_encode$119,
  response_decode: response_decode$119,
  allMessage_encode: allMessage_encode$41,
  allMessage_decode: allMessage_decode$41,
  allResponse_encode: allResponse_encode$41,
  allResponse_decode: allResponse_decode$41,
  responseError_encode: responseError_encode$41,
  responseError_decode: responseError_decode$41,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$41,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$41,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$41
};

var partial_arg$41 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var PlaybackModeControl = partial_arg$41(MRTransform_PlaybackModeControl, AllWrapper);

var message_encode$120 = message_encode$43;

var message_decode$120 = message_decode$43;

function response_encode$120(v) {
  return ["AckUpdateLinkGroups"];
}

var response_decode$120 = response_decode$43;

var allMessage_encode$42 = message_encode$77;

var allMessage_decode$42 = message_decode$77;

var allResponse_encode$42 = response_encode$77;

var allResponse_decode$42 = response_decode$77;

var responseError_encode$42 = Decco.stringToJson;

var responseError_decode$42 = Decco.stringFromJson;

function wrapMessageAsAllMessage$42(message) {
  return {
          TAG: /* Message_UrlTriggering_AskBgToUpdateLinkGroups */42,
          _0: message
        };
}

function unwrapAllResponseAsResponse$42(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_AskBgToUpdateLinkGroups */42) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$42(response) {
  return {
          TAG: /* Response_UrlTriggering_AskBgToUpdateLinkGroups */42,
          _0: response
        };
}

var MRTransform_UrlTriggering_AskBgToUpdateLinkGroups = {
  message_encode: message_encode$120,
  message_decode: message_decode$120,
  response_encode: response_encode$120,
  response_decode: response_decode$120,
  allMessage_encode: allMessage_encode$42,
  allMessage_decode: allMessage_decode$42,
  allResponse_encode: allResponse_encode$42,
  allResponse_decode: allResponse_decode$42,
  responseError_encode: responseError_encode$42,
  responseError_decode: responseError_decode$42,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$42,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$42,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$42
};

var partial_arg$42 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UrlTriggering_AskBgToUpdateLinkGroups = partial_arg$42(MRTransform_UrlTriggering_AskBgToUpdateLinkGroups, AllWrapper);

var message_encode$121 = message_encode$44;

var message_decode$121 = message_decode$44;

function response_encode$121(v) {
  return ["AckAskBgToRecordPageAction"];
}

var response_decode$121 = response_decode$44;

var allMessage_encode$43 = message_encode$77;

var allMessage_decode$43 = message_decode$77;

var allResponse_encode$43 = response_encode$77;

var allResponse_decode$43 = response_decode$77;

var responseError_encode$43 = Decco.stringToJson;

var responseError_decode$43 = Decco.stringFromJson;

function wrapMessageAsAllMessage$43(message) {
  return {
          TAG: /* Message_UrlTriggering_AskBgToRecordPageAction */43,
          _0: message
        };
}

function unwrapAllResponseAsResponse$43(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_AskBgToRecordPageAction */43) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$43(response) {
  return {
          TAG: /* Response_UrlTriggering_AskBgToRecordPageAction */43,
          _0: response
        };
}

var MRTransform_UrlTriggering_AskBgToRecordPageAction = {
  message_encode: message_encode$121,
  message_decode: message_decode$121,
  response_encode: response_encode$121,
  response_decode: response_decode$121,
  allMessage_encode: allMessage_encode$43,
  allMessage_decode: allMessage_decode$43,
  allResponse_encode: allResponse_encode$43,
  allResponse_decode: allResponse_decode$43,
  responseError_encode: responseError_encode$43,
  responseError_decode: responseError_decode$43,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$43,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$43,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$43
};

var partial_arg$43 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UrlTriggering_AskBgToRecordPageAction = partial_arg$43(MRTransform_UrlTriggering_AskBgToRecordPageAction, AllWrapper);

var message_encode$122 = message_encode$45;

var message_decode$122 = message_decode$45;

function response_encode$122(v) {
  return ["AckAskBgToStopRecordPageAction"];
}

var response_decode$122 = response_decode$45;

var allMessage_encode$44 = message_encode$77;

var allMessage_decode$44 = message_decode$77;

var allResponse_encode$44 = response_encode$77;

var allResponse_decode$44 = response_decode$77;

var responseError_encode$44 = Decco.stringToJson;

var responseError_decode$44 = Decco.stringFromJson;

function wrapMessageAsAllMessage$44(message) {
  return {
          TAG: /* Message_UrlTriggering_AskBgToStopRecordPageAction */44,
          _0: message
        };
}

function unwrapAllResponseAsResponse$44(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_AskBgToStopRecordPageAction */44) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$44(response) {
  return {
          TAG: /* Response_UrlTriggering_AskBgToStopRecordPageAction */44,
          _0: response
        };
}

var MRTransform_UrlTriggering_AskBgToStopRecordPageAction = {
  message_encode: message_encode$122,
  message_decode: message_decode$122,
  response_encode: response_encode$122,
  response_decode: response_decode$122,
  allMessage_encode: allMessage_encode$44,
  allMessage_decode: allMessage_decode$44,
  allResponse_encode: allResponse_encode$44,
  allResponse_decode: allResponse_decode$44,
  responseError_encode: responseError_encode$44,
  responseError_decode: responseError_decode$44,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$44,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$44,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$44
};

var partial_arg$44 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UrlTriggering_AskBgToStopRecordPageAction = partial_arg$44(MRTransform_UrlTriggering_AskBgToStopRecordPageAction, AllWrapper);

var message_encode$123 = message_encode$46;

var message_decode$123 = message_decode$46;

function response_encode$123(v) {
  return ["AckAskBgToPlaybackPageAction"];
}

var response_decode$123 = response_decode$46;

var allMessage_encode$45 = message_encode$77;

var allMessage_decode$45 = message_decode$77;

var allResponse_encode$45 = response_encode$77;

var allResponse_decode$45 = response_decode$77;

var responseError_encode$45 = Decco.stringToJson;

var responseError_decode$45 = Decco.stringFromJson;

function wrapMessageAsAllMessage$45(message) {
  return {
          TAG: /* Message_UrlTriggering_AskBgToPlaybackPageAction */46,
          _0: message
        };
}

function unwrapAllResponseAsResponse$45(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_AskBgToPlaybackPageAction */46) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$45(response) {
  return {
          TAG: /* Response_UrlTriggering_AskBgToPlaybackPageAction */46,
          _0: response
        };
}

var MRTransform_UrlTriggering_AskBgToPlaybackPageAction = {
  message_encode: message_encode$123,
  message_decode: message_decode$123,
  response_encode: response_encode$123,
  response_decode: response_decode$123,
  allMessage_encode: allMessage_encode$45,
  allMessage_decode: allMessage_decode$45,
  allResponse_encode: allResponse_encode$45,
  allResponse_decode: allResponse_decode$45,
  responseError_encode: responseError_encode$45,
  responseError_decode: responseError_decode$45,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$45,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$45,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$45
};

var partial_arg$45 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UrlTriggering_AskBgToPlaybackPageAction = partial_arg$45(MRTransform_UrlTriggering_AskBgToPlaybackPageAction, AllWrapper);

var message_encode$124 = message_encode$47;

var message_decode$124 = message_decode$47;

var response_encode$124 = response_encode$47;

var response_decode$124 = response_decode$47;

var allMessage_encode$46 = message_encode$77;

var allMessage_decode$46 = message_decode$77;

var allResponse_encode$46 = response_encode$77;

var allResponse_decode$46 = response_decode$77;

var responseError_encode$46 = Decco.stringToJson;

var responseError_decode$46 = Decco.stringFromJson;

function wrapMessageAsAllMessage$46(message) {
  return {
          TAG: /* Message_UrlTriggering_DidFinishPlaybackPageAction */47,
          _0: message
        };
}

function unwrapAllResponseAsResponse$46(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_DidFinishPlaybackPageAction */47) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$46(response) {
  return {
          TAG: /* Response_UrlTriggering_DidFinishPlaybackPageAction */47,
          _0: response
        };
}

var MRTransform_UrlTriggering_DidFinishPlaybackPageAction = {
  message_encode: message_encode$124,
  message_decode: message_decode$124,
  response_encode: response_encode$124,
  response_decode: response_decode$124,
  allMessage_encode: allMessage_encode$46,
  allMessage_decode: allMessage_decode$46,
  allResponse_encode: allResponse_encode$46,
  allResponse_decode: allResponse_decode$46,
  responseError_encode: responseError_encode$46,
  responseError_decode: responseError_decode$46,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$46,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$46,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$46
};

var partial_arg$46 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UrlTriggering_DidFinishPlaybackPageAction = partial_arg$46(MRTransform_UrlTriggering_DidFinishPlaybackPageAction, AllWrapper);

var message_encode$125 = message_encode$48;

var message_decode$125 = message_decode$48;

function response_encode$125(v) {
  return ["AckAskBgToShowLinkWithId"];
}

var response_decode$125 = response_decode$48;

var allMessage_encode$47 = message_encode$77;

var allMessage_decode$47 = message_decode$77;

var allResponse_encode$47 = response_encode$77;

var allResponse_decode$47 = response_decode$77;

var responseError_encode$47 = Decco.stringToJson;

var responseError_decode$47 = Decco.stringFromJson;

function wrapMessageAsAllMessage$47(message) {
  return {
          TAG: /* Message_UrlTriggering_AskBgToShowLinkWithId */48,
          _0: message
        };
}

function unwrapAllResponseAsResponse$47(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_AskBgToShowLinkWithId */48) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$47(response) {
  return {
          TAG: /* Response_UrlTriggering_AskBgToShowLinkWithId */48,
          _0: response
        };
}

var MRTransform_UrlTriggering_AskBgToShowLinkWithId = {
  message_encode: message_encode$125,
  message_decode: message_decode$125,
  response_encode: response_encode$125,
  response_decode: response_decode$125,
  allMessage_encode: allMessage_encode$47,
  allMessage_decode: allMessage_decode$47,
  allResponse_encode: allResponse_encode$47,
  allResponse_decode: allResponse_decode$47,
  responseError_encode: responseError_encode$47,
  responseError_decode: responseError_decode$47,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$47,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$47,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$47
};

var partial_arg$47 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UrlTriggering_AskBgToShowLinkWithId = partial_arg$47(MRTransform_UrlTriggering_AskBgToShowLinkWithId, AllWrapper);

function message_encode$126(v) {
  return ["AskBgToSaveUrlTriggeringAsSmartcut"];
}

var message_decode$126 = message_decode$49;

function response_encode$126(v) {
  return ["AckAskBgToSaveUrlTriggeringAsSmartcut"];
}

var response_decode$126 = response_decode$49;

var allMessage_encode$48 = message_encode$77;

var allMessage_decode$48 = message_decode$77;

var allResponse_encode$48 = response_encode$77;

var allResponse_decode$48 = response_decode$77;

var responseError_encode$48 = Decco.stringToJson;

var responseError_decode$48 = Decco.stringFromJson;

function wrapMessageAsAllMessage$48(message) {
  return {
          TAG: /* Message_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut */49,
          _0: message
        };
}

function unwrapAllResponseAsResponse$48(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut */49) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$48(response) {
  return {
          TAG: /* Response_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut */49,
          _0: response
        };
}

var MRTransform_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut = {
  message_encode: message_encode$126,
  message_decode: message_decode$126,
  response_encode: response_encode$126,
  response_decode: response_decode$126,
  allMessage_encode: allMessage_encode$48,
  allMessage_decode: allMessage_decode$48,
  allResponse_encode: allResponse_encode$48,
  allResponse_decode: allResponse_decode$48,
  responseError_encode: responseError_encode$48,
  responseError_decode: responseError_decode$48,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$48,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$48,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$48
};

var partial_arg$48 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut = partial_arg$48(MRTransform_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut, AllWrapper);

function message_encode$127(v) {
  return ["MaybeReadyToPlaybackPagination"];
}

var message_decode$127 = message_decode$50;

function response_encode$127(v) {
  return ["AckMaybeReadyToPlaybackPagination"];
}

var response_decode$127 = response_decode$50;

var allMessage_encode$49 = message_encode$77;

var allMessage_decode$49 = message_decode$77;

var allResponse_encode$49 = response_encode$77;

var allResponse_decode$49 = response_decode$77;

var responseError_encode$49 = Decco.stringToJson;

var responseError_decode$49 = Decco.stringFromJson;

function wrapMessageAsAllMessage$49(message) {
  return {
          TAG: /* Message_UrlTriggering_MaybeReadyToPlaybackPagination */50,
          _0: message
        };
}

function unwrapAllResponseAsResponse$49(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_MaybeReadyToPlaybackPagination */50) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$49(response) {
  return {
          TAG: /* Response_UrlTriggering_MaybeReadyToPlaybackPagination */50,
          _0: response
        };
}

var MRTransform_UrlTriggering_MaybeReadyToPlaybackPagination = {
  message_encode: message_encode$127,
  message_decode: message_decode$127,
  response_encode: response_encode$127,
  response_decode: response_decode$127,
  allMessage_encode: allMessage_encode$49,
  allMessage_decode: allMessage_decode$49,
  allResponse_encode: allResponse_encode$49,
  allResponse_decode: allResponse_decode$49,
  responseError_encode: responseError_encode$49,
  responseError_decode: responseError_decode$49,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$49,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$49,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$49
};

var partial_arg$49 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UrlTriggering_MaybeReadyToPlaybackPagination = partial_arg$49(MRTransform_UrlTriggering_MaybeReadyToPlaybackPagination, AllWrapper);

var message_encode$128 = message_encode$52;

var message_decode$128 = message_decode$52;

function response_encode$128(v) {
  return ["AckAskBgToFocusTab"];
}

var response_decode$128 = response_decode$52;

var allMessage_encode$50 = message_encode$77;

var allMessage_decode$50 = message_decode$77;

var allResponse_encode$50 = response_encode$77;

var allResponse_decode$50 = response_decode$77;

var responseError_encode$50 = Decco.stringToJson;

var responseError_decode$50 = Decco.stringFromJson;

function wrapMessageAsAllMessage$50(message) {
  return {
          TAG: /* Message_AskBgToFocusTab */51,
          _0: message
        };
}

function unwrapAllResponseAsResponse$50(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToFocusTab */52) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$50(response) {
  return {
          TAG: /* Response_AskBgToFocusTab */52,
          _0: response
        };
}

var MRTransform_AskBgToFocusTab = {
  message_encode: message_encode$128,
  message_decode: message_decode$128,
  response_encode: response_encode$128,
  response_decode: response_decode$128,
  allMessage_encode: allMessage_encode$50,
  allMessage_decode: allMessage_decode$50,
  allResponse_encode: allResponse_encode$50,
  allResponse_decode: allResponse_decode$50,
  responseError_encode: responseError_encode$50,
  responseError_decode: responseError_decode$50,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$50,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$50,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$50
};

var message_encode$129 = message_encode$51;

var message_decode$129 = message_decode$51;

function response_encode$129(v) {
  return ["AckAskBgToUpdatePaginateFn"];
}

var response_decode$129 = response_decode$51;

var allMessage_encode$51 = message_encode$77;

var allMessage_decode$51 = message_decode$77;

var allResponse_encode$51 = response_encode$77;

var allResponse_decode$51 = response_decode$77;

var responseError_encode$51 = Decco.stringToJson;

var responseError_decode$51 = Decco.stringFromJson;

function wrapMessageAsAllMessage$51(message) {
  return {
          TAG: /* Message_UrlTriggering_AskBgToUpdatePaginateFn */45,
          _0: message
        };
}

function unwrapAllResponseAsResponse$51(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_AskBgToUpdatePaginateFn */45) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$51(response) {
  return {
          TAG: /* Response_UrlTriggering_AskBgToUpdatePaginateFn */45,
          _0: response
        };
}

var MRTransform_UrlTriggering_AskBgToUpdatePaginateFn = {
  message_encode: message_encode$129,
  message_decode: message_decode$129,
  response_encode: response_encode$129,
  response_decode: response_decode$129,
  allMessage_encode: allMessage_encode$51,
  allMessage_decode: allMessage_decode$51,
  allResponse_encode: allResponse_encode$51,
  allResponse_decode: allResponse_decode$51,
  responseError_encode: responseError_encode$51,
  responseError_decode: responseError_decode$51,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$51,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$51,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$51
};

var partial_arg$50 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UrlTriggering_AskBgToUpdatePaginateFn = partial_arg$50(MRTransform_UrlTriggering_AskBgToUpdatePaginateFn, AllWrapper);

var partial_arg$51 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToFocusTab = partial_arg$51(MRTransform_AskBgToFocusTab, AllWrapper);

var message_encode$130 = message_encode$53;

var message_decode$130 = message_decode$53;

function response_encode$130(v) {
  return ["AckAskBgToFocusWindow"];
}

var response_decode$130 = response_decode$53;

var allMessage_encode$52 = message_encode$77;

var allMessage_decode$52 = message_decode$77;

var allResponse_encode$52 = response_encode$77;

var allResponse_decode$52 = response_decode$77;

var responseError_encode$52 = Decco.stringToJson;

var responseError_decode$52 = Decco.stringFromJson;

function wrapMessageAsAllMessage$52(message) {
  return {
          TAG: /* Message_AskBgToFocusWindow */52,
          _0: message
        };
}

function unwrapAllResponseAsResponse$52(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToFocusWindow */53) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$52(response) {
  return {
          TAG: /* Response_AskBgToFocusWindow */53,
          _0: response
        };
}

var MRTransform_AskBgToFocusWindow = {
  message_encode: message_encode$130,
  message_decode: message_decode$130,
  response_encode: response_encode$130,
  response_decode: response_decode$130,
  allMessage_encode: allMessage_encode$52,
  allMessage_decode: allMessage_decode$52,
  allResponse_encode: allResponse_encode$52,
  allResponse_decode: allResponse_decode$52,
  responseError_encode: responseError_encode$52,
  responseError_decode: responseError_decode$52,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$52,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$52,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$52
};

var partial_arg$52 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToFocusWindow = partial_arg$52(MRTransform_AskBgToFocusWindow, AllWrapper);

var message_encode$131 = message_encode$54;

var message_decode$131 = message_decode$54;

var response_encode$131 = response_encode$54;

var response_decode$131 = response_decode$54;

var allMessage_encode$53 = message_encode$77;

var allMessage_decode$53 = message_decode$77;

var allResponse_encode$53 = response_encode$77;

var allResponse_decode$53 = response_decode$77;

var responseError_encode$53 = Decco.stringToJson;

var responseError_decode$53 = Decco.stringFromJson;

function wrapMessageAsAllMessage$53(message) {
  return {
          TAG: /* Message_SmartcutSavingProgress */53,
          _0: message
        };
}

function unwrapAllResponseAsResponse$53(allResponse) {
  if (allResponse.TAG === /* Response_SmartcutSavingProgress */51) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$53(response) {
  return {
          TAG: /* Response_SmartcutSavingProgress */51,
          _0: response
        };
}

var MRTransform_SmartcutSavingProgress = {
  message_encode: message_encode$131,
  message_decode: message_decode$131,
  response_encode: response_encode$131,
  response_decode: response_decode$131,
  allMessage_encode: allMessage_encode$53,
  allMessage_decode: allMessage_decode$53,
  allResponse_encode: allResponse_encode$53,
  allResponse_decode: allResponse_decode$53,
  responseError_encode: responseError_encode$53,
  responseError_decode: responseError_decode$53,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$53,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$53,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$53
};

var partial_arg$53 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var SmartcutSavingProgress = partial_arg$53(MRTransform_SmartcutSavingProgress, AllWrapper);

var message_encode$132 = message_encode$55;

var message_decode$132 = message_decode$55;

function response_encode$132(v) {
  return ["DidRequestPermissions"];
}

var response_decode$132 = response_decode$55;

var allMessage_encode$54 = message_encode$77;

var allMessage_decode$54 = message_decode$77;

var allResponse_encode$54 = response_encode$77;

var allResponse_decode$54 = response_decode$77;

var responseError_encode$54 = Decco.stringToJson;

var responseError_decode$54 = Decco.stringFromJson;

function wrapMessageAsAllMessage$54(message) {
  return {
          TAG: /* Message_RequestPermissions */54,
          _0: message
        };
}

function unwrapAllResponseAsResponse$54(allResponse) {
  if (allResponse.TAG === /* Response_RequestPermissions */54) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$54(response) {
  return {
          TAG: /* Response_RequestPermissions */54,
          _0: response
        };
}

var MRTransform_RequestPermissions = {
  message_encode: message_encode$132,
  message_decode: message_decode$132,
  response_encode: response_encode$132,
  response_decode: response_decode$132,
  allMessage_encode: allMessage_encode$54,
  allMessage_decode: allMessage_decode$54,
  allResponse_encode: allResponse_encode$54,
  allResponse_decode: allResponse_decode$54,
  responseError_encode: responseError_encode$54,
  responseError_decode: responseError_decode$54,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$54,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$54,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$54
};

var partial_arg$54 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var RequestPermissions = partial_arg$54(MRTransform_RequestPermissions, AllWrapper);

var message_encode$133 = message_encode$56;

var message_decode$133 = message_decode$56;

function response_encode$133(v) {
  return ["AckConfirmExecutionQuotaResult"];
}

var response_decode$133 = response_decode$56;

var allMessage_encode$55 = message_encode$77;

var allMessage_decode$55 = message_decode$77;

var allResponse_encode$55 = response_encode$77;

var allResponse_decode$55 = response_decode$77;

var responseError_encode$55 = Decco.stringToJson;

var responseError_decode$55 = Decco.stringFromJson;

function wrapMessageAsAllMessage$55(message) {
  return {
          TAG: /* Message_NotifyConfirmExecutionQuotaResult */55,
          _0: message
        };
}

function unwrapAllResponseAsResponse$55(allResponse) {
  if (allResponse.TAG === /* Response_NotifyConfirmExecutionQuotaResult */55) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$55(response) {
  return {
          TAG: /* Response_NotifyConfirmExecutionQuotaResult */55,
          _0: response
        };
}

var MRTransform_NotifyConfirmExecutionQuotaResult = {
  message_encode: message_encode$133,
  message_decode: message_decode$133,
  response_encode: response_encode$133,
  response_decode: response_decode$133,
  allMessage_encode: allMessage_encode$55,
  allMessage_decode: allMessage_decode$55,
  allResponse_encode: allResponse_encode$55,
  allResponse_decode: allResponse_decode$55,
  responseError_encode: responseError_encode$55,
  responseError_decode: responseError_decode$55,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$55,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$55,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$55
};

var partial_arg$55 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var NotifyConfirmExecutionQuotaResult = partial_arg$55(MRTransform_NotifyConfirmExecutionQuotaResult, AllWrapper);

var message_encode$134 = message_encode$57;

var message_decode$134 = message_decode$57;

function response_encode$134(v) {
  return ["BgDidTrackWithSegment"];
}

var response_decode$134 = response_decode$57;

var allMessage_encode$56 = message_encode$77;

var allMessage_decode$56 = message_decode$77;

var allResponse_encode$56 = response_encode$77;

var allResponse_decode$56 = response_decode$77;

var responseError_encode$56 = Decco.stringToJson;

var responseError_decode$56 = Decco.stringFromJson;

function wrapMessageAsAllMessage$56(message) {
  return {
          TAG: /* Message_TrackWithSegment */56,
          _0: message
        };
}

function unwrapAllResponseAsResponse$56(allResponse) {
  if (allResponse.TAG === /* Response_TrackWithSegment */56) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$56(response) {
  return {
          TAG: /* Response_TrackWithSegment */56,
          _0: response
        };
}

var MRTransform_TrackWithSegment = {
  message_encode: message_encode$134,
  message_decode: message_decode$134,
  response_encode: response_encode$134,
  response_decode: response_decode$134,
  allMessage_encode: allMessage_encode$56,
  allMessage_decode: allMessage_decode$56,
  allResponse_encode: allResponse_encode$56,
  allResponse_decode: allResponse_decode$56,
  responseError_encode: responseError_encode$56,
  responseError_decode: responseError_decode$56,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$56,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$56,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$56
};

var partial_arg$56 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var TrackWithSegment = partial_arg$56(MRTransform_TrackWithSegment, AllWrapper);

function message_encode$135(v) {
  return ["UserReadyLogInToWebsite"];
}

var message_decode$135 = message_decode$58;

function response_encode$135(v) {
  return ["AckUserReadyLogInToWebsite"];
}

var response_decode$135 = response_decode$58;

var allMessage_encode$57 = message_encode$77;

var allMessage_decode$57 = message_decode$77;

var allResponse_encode$57 = response_encode$77;

var allResponse_decode$57 = response_decode$77;

var responseError_encode$57 = Decco.stringToJson;

var responseError_decode$57 = Decco.stringFromJson;

function wrapMessageAsAllMessage$57(message) {
  return {
          TAG: /* Message_UserReadyLogInToWebsite */57,
          _0: message
        };
}

function unwrapAllResponseAsResponse$57(allResponse) {
  if (allResponse.TAG === /* Response_UserReadyLogInToWebsite */57) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$57(response) {
  return {
          TAG: /* Response_UserReadyLogInToWebsite */57,
          _0: response
        };
}

var MRTransform_UserReadyLogInToWebsite = {
  message_encode: message_encode$135,
  message_decode: message_decode$135,
  response_encode: response_encode$135,
  response_decode: response_decode$135,
  allMessage_encode: allMessage_encode$57,
  allMessage_decode: allMessage_decode$57,
  allResponse_encode: allResponse_encode$57,
  allResponse_decode: allResponse_decode$57,
  responseError_encode: responseError_encode$57,
  responseError_decode: responseError_decode$57,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$57,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$57,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$57
};

var partial_arg$57 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UserReadyLogInToWebsite = partial_arg$57(MRTransform_UserReadyLogInToWebsite, AllWrapper);

var message_encode$136 = message_encode$59;

var message_decode$136 = message_decode$59;

function response_encode$136(v) {
  return ["AckOpenNewWindow"];
}

var response_decode$136 = response_decode$59;

var allMessage_encode$58 = message_encode$77;

var allMessage_decode$58 = message_decode$77;

var allResponse_encode$58 = response_encode$77;

var allResponse_decode$58 = response_decode$77;

var responseError_encode$58 = Decco.stringToJson;

var responseError_decode$58 = Decco.stringFromJson;

function wrapMessageAsAllMessage$58(message) {
  return {
          TAG: /* Message_OpenNewWindow */58,
          _0: message
        };
}

function unwrapAllResponseAsResponse$58(allResponse) {
  if (allResponse.TAG === /* Response_OpenNewWindow */58) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$58(response) {
  return {
          TAG: /* Response_OpenNewWindow */58,
          _0: response
        };
}

var MRTransform_OpenNewWindow = {
  message_encode: message_encode$136,
  message_decode: message_decode$136,
  response_encode: response_encode$136,
  response_decode: response_decode$136,
  allMessage_encode: allMessage_encode$58,
  allMessage_decode: allMessage_decode$58,
  allResponse_encode: allResponse_encode$58,
  allResponse_decode: allResponse_decode$58,
  responseError_encode: responseError_encode$58,
  responseError_decode: responseError_decode$58,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$58,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$58,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$58
};

var partial_arg$58 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var OpenNewWindow = partial_arg$58(MRTransform_OpenNewWindow, AllWrapper);

var message_encode$137 = message_encode$60;

var message_decode$137 = message_decode$60;

function response_encode$137(v) {
  return ["AckStoreAuthStatusItem"];
}

var response_decode$137 = response_decode$60;

var allMessage_encode$59 = message_encode$77;

var allMessage_decode$59 = message_decode$77;

var allResponse_encode$59 = response_encode$77;

var allResponse_decode$59 = response_decode$77;

var responseError_encode$59 = Decco.stringToJson;

var responseError_decode$59 = Decco.stringFromJson;

function wrapMessageAsAllMessage$59(message) {
  return {
          TAG: /* Message_StoreAuthStatusItem */59,
          _0: message
        };
}

function unwrapAllResponseAsResponse$59(allResponse) {
  if (allResponse.TAG === /* Response_StoreAuthStatusItem */59) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$59(response) {
  return {
          TAG: /* Response_StoreAuthStatusItem */59,
          _0: response
        };
}

var MRTransform_StoreAuthStatusItem = {
  message_encode: message_encode$137,
  message_decode: message_decode$137,
  response_encode: response_encode$137,
  response_decode: response_decode$137,
  allMessage_encode: allMessage_encode$59,
  allMessage_decode: allMessage_decode$59,
  allResponse_encode: allResponse_encode$59,
  allResponse_decode: allResponse_decode$59,
  responseError_encode: responseError_encode$59,
  responseError_decode: responseError_decode$59,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$59,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$59,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$59
};

var partial_arg$59 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var StoreAuthStatusItem = partial_arg$59(MRTransform_StoreAuthStatusItem, AllWrapper);

var message_encode$138 = message_encode$61;

var message_decode$138 = message_decode$61;

function response_encode$138(v) {
  return ["AckHighlightElement"];
}

var response_decode$138 = response_decode$61;

var allMessage_encode$60 = message_encode$77;

var allMessage_decode$60 = message_decode$77;

var allResponse_encode$60 = response_encode$77;

var allResponse_decode$60 = response_decode$77;

var responseError_encode$60 = Decco.stringToJson;

var responseError_decode$60 = Decco.stringFromJson;

function wrapMessageAsAllMessage$60(message) {
  return {
          TAG: /* Message_AskBgToHighlightElement */60,
          _0: message
        };
}

function unwrapAllResponseAsResponse$60(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToHighlightElement */60) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$60(response) {
  return {
          TAG: /* Response_AskBgToHighlightElement */60,
          _0: response
        };
}

var MRTransform_AskBgToHighlightElement = {
  message_encode: message_encode$138,
  message_decode: message_decode$138,
  response_encode: response_encode$138,
  response_decode: response_decode$138,
  allMessage_encode: allMessage_encode$60,
  allMessage_decode: allMessage_decode$60,
  allResponse_encode: allResponse_encode$60,
  allResponse_decode: allResponse_decode$60,
  responseError_encode: responseError_encode$60,
  responseError_decode: responseError_decode$60,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$60,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$60,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$60
};

var partial_arg$60 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToHighlightElement = partial_arg$60(MRTransform_AskBgToHighlightElement, AllWrapper);

var message_encode$139 = message_encode$62;

var message_decode$139 = message_decode$62;

function response_encode$139(v) {
  return ["AckDidCloseExplainModalAndAskBgToHighlightElement"];
}

var response_decode$139 = response_decode$62;

var allMessage_encode$61 = message_encode$77;

var allMessage_decode$61 = message_decode$77;

var allResponse_encode$61 = response_encode$77;

var allResponse_decode$61 = response_decode$77;

var responseError_encode$61 = Decco.stringToJson;

var responseError_decode$61 = Decco.stringFromJson;

function wrapMessageAsAllMessage$61(message) {
  return {
          TAG: /* Message_DidCloseExplainModalAndAskBgToHighlightElement */61,
          _0: message
        };
}

function unwrapAllResponseAsResponse$61(allResponse) {
  if (allResponse.TAG === /* Response_DidCloseExplainModalAndAskBgToHighlightElement */61) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$61(response) {
  return {
          TAG: /* Response_DidCloseExplainModalAndAskBgToHighlightElement */61,
          _0: response
        };
}

var MRTransform_DidCloseExplainModalAndAskBgToHighlightElement = {
  message_encode: message_encode$139,
  message_decode: message_decode$139,
  response_encode: response_encode$139,
  response_decode: response_decode$139,
  allMessage_encode: allMessage_encode$61,
  allMessage_decode: allMessage_decode$61,
  allResponse_encode: allResponse_encode$61,
  allResponse_decode: allResponse_decode$61,
  responseError_encode: responseError_encode$61,
  responseError_decode: responseError_decode$61,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$61,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$61,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$61
};

var partial_arg$61 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var DidCloseExplainModalAndAskBgToHighlightElement = partial_arg$61(MRTransform_DidCloseExplainModalAndAskBgToHighlightElement, AllWrapper);

var message_encode$140 = message_encode$63;

var message_decode$140 = message_decode$63;

function response_encode$140(v) {
  return ["DidTeardownHighlightElementControl"];
}

var response_decode$140 = response_decode$63;

var allMessage_encode$62 = message_encode$77;

var allMessage_decode$62 = message_decode$77;

var allResponse_encode$62 = response_encode$77;

var allResponse_decode$62 = response_decode$77;

var responseError_encode$62 = Decco.stringToJson;

var responseError_decode$62 = Decco.stringFromJson;

function wrapMessageAsAllMessage$62(message) {
  return {
          TAG: /* Message_AskBgToStopHighlightElement */62,
          _0: message
        };
}

function unwrapAllResponseAsResponse$62(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToStopHighlightElement */62) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$62(response) {
  return {
          TAG: /* Response_AskBgToStopHighlightElement */62,
          _0: response
        };
}

var MRTransform_AskBgToStopHighlightElement = {
  message_encode: message_encode$140,
  message_decode: message_decode$140,
  response_encode: response_encode$140,
  response_decode: response_decode$140,
  allMessage_encode: allMessage_encode$62,
  allMessage_decode: allMessage_decode$62,
  allResponse_encode: allResponse_encode$62,
  allResponse_decode: allResponse_decode$62,
  responseError_encode: responseError_encode$62,
  responseError_decode: responseError_decode$62,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$62,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$62,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$62
};

var partial_arg$62 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToStopHighlightElement = partial_arg$62(MRTransform_AskBgToStopHighlightElement, AllWrapper);

function message_encode$141(v) {
  return ["GetUserCredentials"];
}

var message_decode$141 = message_decode$64;

var response_encode$141 = response_encode$64;

var response_decode$141 = response_decode$64;

var allMessage_encode$63 = message_encode$77;

var allMessage_decode$63 = message_decode$77;

var allResponse_encode$63 = response_encode$77;

var allResponse_decode$63 = response_decode$77;

var responseError_encode$63 = Decco.stringToJson;

var responseError_decode$63 = Decco.stringFromJson;

function wrapMessageAsAllMessage$63(message) {
  return {
          TAG: /* Message_GetUserCredentials */63,
          _0: message
        };
}

function unwrapAllResponseAsResponse$63(allResponse) {
  if (allResponse.TAG === /* Response_GetUserCredentials */63) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$63(response) {
  return {
          TAG: /* Response_GetUserCredentials */63,
          _0: response
        };
}

var MRTransform_GetUserCredentials = {
  message_encode: message_encode$141,
  message_decode: message_decode$141,
  response_encode: response_encode$141,
  response_decode: response_decode$141,
  allMessage_encode: allMessage_encode$63,
  allMessage_decode: allMessage_decode$63,
  allResponse_encode: allResponse_encode$63,
  allResponse_decode: allResponse_decode$63,
  responseError_encode: responseError_encode$63,
  responseError_decode: responseError_decode$63,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$63,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$63,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$63
};

var partial_arg$63 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var GetUserCredentials = partial_arg$63(MRTransform_GetUserCredentials, AllWrapper);

var message_encode$142 = message_encode$65;

var message_decode$142 = message_decode$65;

var response_encode$142 = response_encode$65;

var response_decode$142 = response_decode$65;

var allMessage_encode$64 = message_encode$77;

var allMessage_decode$64 = message_decode$77;

var allResponse_encode$64 = response_encode$77;

var allResponse_decode$64 = response_decode$77;

var responseError_encode$64 = Decco.stringToJson;

var responseError_decode$64 = Decco.stringFromJson;

function wrapMessageAsAllMessage$64(message) {
  return {
          TAG: /* Message_UnlockVaultWithMasterSecret */64,
          _0: message
        };
}

function unwrapAllResponseAsResponse$64(allResponse) {
  if (allResponse.TAG === /* Response_UnlockVaultWithMasterSecret */64) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$64(response) {
  return {
          TAG: /* Response_UnlockVaultWithMasterSecret */64,
          _0: response
        };
}

var MRTransform_UnlockVaultWithMasterSecret = {
  message_encode: message_encode$142,
  message_decode: message_decode$142,
  response_encode: response_encode$142,
  response_decode: response_decode$142,
  allMessage_encode: allMessage_encode$64,
  allMessage_decode: allMessage_decode$64,
  allResponse_encode: allResponse_encode$64,
  allResponse_decode: allResponse_decode$64,
  responseError_encode: responseError_encode$64,
  responseError_decode: responseError_decode$64,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$64,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$64,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$64
};

var partial_arg$64 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var UnlockVaultWithMasterSecret = partial_arg$64(MRTransform_UnlockVaultWithMasterSecret, AllWrapper);

var message_encode$143 = message_encode$66;

var message_decode$143 = message_decode$66;

var response_encode$143 = response_encode$66;

var response_decode$143 = response_decode$66;

var allMessage_encode$65 = message_encode$77;

var allMessage_decode$65 = message_decode$77;

var allResponse_encode$65 = response_encode$77;

var allResponse_decode$65 = response_decode$77;

var responseError_encode$65 = Decco.stringToJson;

var responseError_decode$65 = Decco.stringFromJson;

function wrapMessageAsAllMessage$65(message) {
  return {
          TAG: /* Message_ModifyUserCredentials */65,
          _0: message
        };
}

function unwrapAllResponseAsResponse$65(allResponse) {
  if (allResponse.TAG === /* Response_ModifyUserCredentials */65) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$65(response) {
  return {
          TAG: /* Response_ModifyUserCredentials */65,
          _0: response
        };
}

var MRTransform_ModifyUserCredentials = {
  message_encode: message_encode$143,
  message_decode: message_decode$143,
  response_encode: response_encode$143,
  response_decode: response_decode$143,
  allMessage_encode: allMessage_encode$65,
  allMessage_decode: allMessage_decode$65,
  allResponse_encode: allResponse_encode$65,
  allResponse_decode: allResponse_decode$65,
  responseError_encode: responseError_encode$65,
  responseError_decode: responseError_decode$65,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$65,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$65,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$65
};

var partial_arg$65 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var ModifyUserCredentials = partial_arg$65(MRTransform_ModifyUserCredentials, AllWrapper);

function message_encode$144(v) {
  return ["TabAskBgIfMasterSecretDoesExist"];
}

var message_decode$144 = message_decode$67;

var response_encode$144 = response_encode$67;

var response_decode$144 = response_decode$67;

var allMessage_encode$66 = message_encode$77;

var allMessage_decode$66 = message_decode$77;

var allResponse_encode$66 = response_encode$77;

var allResponse_decode$66 = response_decode$77;

var responseError_encode$66 = Decco.stringToJson;

var responseError_decode$66 = Decco.stringFromJson;

function wrapMessageAsAllMessage$66(message) {
  return {
          TAG: /* Message_AskBgIfMasterSecretDoesExist */66,
          _0: message
        };
}

function unwrapAllResponseAsResponse$66(allResponse) {
  if (allResponse.TAG === /* Response_AskBgIfMasterSecretDoesExist */66) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$66(response) {
  return {
          TAG: /* Response_AskBgIfMasterSecretDoesExist */66,
          _0: response
        };
}

var MRTransform_AskBgIfMasterSecretDoesExist = {
  message_encode: message_encode$144,
  message_decode: message_decode$144,
  response_encode: response_encode$144,
  response_decode: response_decode$144,
  allMessage_encode: allMessage_encode$66,
  allMessage_decode: allMessage_decode$66,
  allResponse_encode: allResponse_encode$66,
  allResponse_decode: allResponse_decode$66,
  responseError_encode: responseError_encode$66,
  responseError_decode: responseError_decode$66,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$66,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$66,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$66
};

var partial_arg$66 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgIfMasterSecretDoesExist = partial_arg$66(MRTransform_AskBgIfMasterSecretDoesExist, AllWrapper);

function message_encode$145(v) {
  return ["TabAskBgForMissingPasswords"];
}

var message_decode$145 = message_decode$68;

var response_encode$145 = response_encode$68;

var response_decode$145 = response_decode$68;

var allMessage_encode$67 = message_encode$77;

var allMessage_decode$67 = message_decode$77;

var allResponse_encode$67 = response_encode$77;

var allResponse_decode$67 = response_decode$77;

var responseError_encode$67 = Decco.stringToJson;

var responseError_decode$67 = Decco.stringFromJson;

function wrapMessageAsAllMessage$67(message) {
  return {
          TAG: /* Message_AskBgForMissingPasswords */67,
          _0: message
        };
}

function unwrapAllResponseAsResponse$67(allResponse) {
  if (allResponse.TAG === /* Response_AskBgForMissingPasswords */67) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$67(response) {
  return {
          TAG: /* Response_AskBgForMissingPasswords */67,
          _0: response
        };
}

var MRTransform_AskBgForMissingPasswords = {
  message_encode: message_encode$145,
  message_decode: message_decode$145,
  response_encode: response_encode$145,
  response_decode: response_decode$145,
  allMessage_encode: allMessage_encode$67,
  allMessage_decode: allMessage_decode$67,
  allResponse_encode: allResponse_encode$67,
  allResponse_decode: allResponse_decode$67,
  responseError_encode: responseError_encode$67,
  responseError_decode: responseError_decode$67,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$67,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$67,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$67
};

var partial_arg$67 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgForMissingPasswords = partial_arg$67(MRTransform_AskBgForMissingPasswords, AllWrapper);

var message_encode$146 = message_encode$69;

var message_decode$146 = message_decode$69;

var response_encode$146 = response_encode$69;

var response_decode$146 = response_decode$69;

var allMessage_encode$68 = message_encode$77;

var allMessage_decode$68 = message_decode$77;

var allResponse_encode$68 = response_encode$77;

var allResponse_decode$68 = response_decode$77;

var responseError_encode$68 = Decco.stringToJson;

var responseError_decode$68 = Decco.stringFromJson;

function wrapMessageAsAllMessage$68(message) {
  return {
          TAG: /* Message_AskBgToCreateVaultWithMasterSecret */68,
          _0: message
        };
}

function unwrapAllResponseAsResponse$68(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToCreateVaultWithMasterSecret */68) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$68(response) {
  return {
          TAG: /* Response_AskBgToCreateVaultWithMasterSecret */68,
          _0: response
        };
}

var MRTransform_AskBgToCreateVaultWithMasterSecret = {
  message_encode: message_encode$146,
  message_decode: message_decode$146,
  response_encode: response_encode$146,
  response_decode: response_decode$146,
  allMessage_encode: allMessage_encode$68,
  allMessage_decode: allMessage_decode$68,
  allResponse_encode: allResponse_encode$68,
  allResponse_decode: allResponse_decode$68,
  responseError_encode: responseError_encode$68,
  responseError_decode: responseError_decode$68,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$68,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$68,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$68
};

var partial_arg$68 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToCreateVaultWithMasterSecret = partial_arg$68(MRTransform_AskBgToCreateVaultWithMasterSecret, AllWrapper);

var message_encode$147 = message_encode$70;

var message_decode$147 = message_decode$70;

var response_encode$147 = response_encode$70;

var response_decode$147 = response_decode$70;

var allMessage_encode$69 = message_encode$77;

var allMessage_decode$69 = message_decode$77;

var allResponse_encode$69 = response_encode$77;

var allResponse_decode$69 = response_decode$77;

var responseError_encode$69 = Decco.stringToJson;

var responseError_decode$69 = Decco.stringFromJson;

function wrapMessageAsAllMessage$69(message) {
  return {
          TAG: /* Message_AskBgToResetMasterSecret */69,
          _0: message
        };
}

function unwrapAllResponseAsResponse$69(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToResetMasterSecret */69) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$69(response) {
  return {
          TAG: /* Response_AskBgToResetMasterSecret */69,
          _0: response
        };
}

var MRTransform_AskBgToResetMasterSecret = {
  message_encode: message_encode$147,
  message_decode: message_decode$147,
  response_encode: response_encode$147,
  response_decode: response_decode$147,
  allMessage_encode: allMessage_encode$69,
  allMessage_decode: allMessage_decode$69,
  allResponse_encode: allResponse_encode$69,
  allResponse_decode: allResponse_decode$69,
  responseError_encode: responseError_encode$69,
  responseError_decode: responseError_decode$69,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$69,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$69,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$69
};

var partial_arg$69 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToResetMasterSecret = partial_arg$69(MRTransform_AskBgToResetMasterSecret, AllWrapper);

var message_encode$148 = message_encode$71;

var message_decode$148 = message_decode$71;

var response_encode$148 = response_encode$71;

var response_decode$148 = response_decode$71;

var allMessage_encode$70 = message_encode$77;

var allMessage_decode$70 = message_decode$77;

var allResponse_encode$70 = response_encode$77;

var allResponse_decode$70 = response_decode$77;

var responseError_encode$70 = Decco.stringToJson;

var responseError_decode$70 = Decco.stringFromJson;

function wrapMessageAsAllMessage$70(message) {
  return {
          TAG: /* Message_AskBgToDetachLoginSmartcut */70,
          _0: message
        };
}

function unwrapAllResponseAsResponse$70(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToDetachLoginSmartcut */70) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$70(response) {
  return {
          TAG: /* Response_AskBgToDetachLoginSmartcut */70,
          _0: response
        };
}

var MRTransform_AskBgToDetachLoginSmartcut = {
  message_encode: message_encode$148,
  message_decode: message_decode$148,
  response_encode: response_encode$148,
  response_decode: response_decode$148,
  allMessage_encode: allMessage_encode$70,
  allMessage_decode: allMessage_decode$70,
  allResponse_encode: allResponse_encode$70,
  allResponse_decode: allResponse_decode$70,
  responseError_encode: responseError_encode$70,
  responseError_decode: responseError_decode$70,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$70,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$70,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$70
};

var partial_arg$70 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToDetachLoginSmartcut = partial_arg$70(MRTransform_AskBgToDetachLoginSmartcut, AllWrapper);

function message_encode$149(v) {
  return ["AskBgToEnterDataExtractionMode"];
}

var message_decode$149 = message_decode$72;

var response_encode$149 = response_encode$72;

var response_decode$149 = response_decode$72;

var allMessage_encode$71 = message_encode$77;

var allMessage_decode$71 = message_decode$77;

var allResponse_encode$71 = response_encode$77;

var allResponse_decode$71 = response_decode$77;

var responseError_encode$71 = Decco.stringToJson;

var responseError_decode$71 = Decco.stringFromJson;

function wrapMessageAsAllMessage$71(message) {
  return {
          TAG: /* Message_AskBgToEnterDataExtractionMode */71,
          _0: message
        };
}

function unwrapAllResponseAsResponse$71(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToEnterDataExtractionMode */71) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$71(response) {
  return {
          TAG: /* Response_AskBgToEnterDataExtractionMode */71,
          _0: response
        };
}

var MRTransform_AskBgToEnterDataExtractionMode = {
  message_encode: message_encode$149,
  message_decode: message_decode$149,
  response_encode: response_encode$149,
  response_decode: response_decode$149,
  allMessage_encode: allMessage_encode$71,
  allMessage_decode: allMessage_decode$71,
  allResponse_encode: allResponse_encode$71,
  allResponse_decode: allResponse_decode$71,
  responseError_encode: responseError_encode$71,
  responseError_decode: responseError_decode$71,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$71,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$71,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$71
};

var partial_arg$71 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToEnterDataExtractionMode = partial_arg$71(MRTransform_AskBgToEnterDataExtractionMode, AllWrapper);

var message_encode$150 = message_encode$73;

var message_decode$150 = message_decode$73;

var response_encode$150 = response_encode$73;

var response_decode$150 = response_decode$73;

var allMessage_encode$72 = message_encode$77;

var allMessage_decode$72 = message_decode$77;

var allResponse_encode$72 = response_encode$77;

var allResponse_decode$72 = response_decode$77;

var responseError_encode$72 = Decco.stringToJson;

var responseError_decode$72 = Decco.stringFromJson;

function wrapMessageAsAllMessage$72(message) {
  return {
          TAG: /* Message_AskBgToProcessDataExtractionSignal */72,
          _0: message
        };
}

function unwrapAllResponseAsResponse$72(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToProcessDataExtractionSignal */72) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$72(response) {
  return {
          TAG: /* Response_AskBgToProcessDataExtractionSignal */72,
          _0: response
        };
}

var MRTransform_AskBgToProcessDataExtractionSignal = {
  message_encode: message_encode$150,
  message_decode: message_decode$150,
  response_encode: response_encode$150,
  response_decode: response_decode$150,
  allMessage_encode: allMessage_encode$72,
  allMessage_decode: allMessage_decode$72,
  allResponse_encode: allResponse_encode$72,
  allResponse_decode: allResponse_decode$72,
  responseError_encode: responseError_encode$72,
  responseError_decode: responseError_decode$72,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$72,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$72,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$72
};

var partial_arg$72 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToProcessDataExtractionSignal = partial_arg$72(MRTransform_AskBgToProcessDataExtractionSignal, AllWrapper);

function message_encode$151(v) {
  return ["AskBgToExitFromDataExtractionMode"];
}

var message_decode$151 = message_decode$75;

function response_encode$151(v) {
  return ["DidExitFromDataExtractionMode"];
}

var response_decode$151 = response_decode$75;

var allMessage_encode$73 = message_encode$77;

var allMessage_decode$73 = message_decode$77;

var allResponse_encode$73 = response_encode$77;

var allResponse_decode$73 = response_decode$77;

var responseError_encode$73 = Decco.stringToJson;

var responseError_decode$73 = Decco.stringFromJson;

function wrapMessageAsAllMessage$73(message) {
  return {
          TAG: /* Message_AskBgToExitFromDataExtractionMode */73,
          _0: message
        };
}

function unwrapAllResponseAsResponse$73(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToExitFromDataExtractionMode */73) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$73(response) {
  return {
          TAG: /* Response_AskBgToExitFromDataExtractionMode */73,
          _0: response
        };
}

var MRTransform_AskBgToExitFromDataExtractionMode = {
  message_encode: message_encode$151,
  message_decode: message_decode$151,
  response_encode: response_encode$151,
  response_decode: response_decode$151,
  allMessage_encode: allMessage_encode$73,
  allMessage_decode: allMessage_decode$73,
  allResponse_encode: allResponse_encode$73,
  allResponse_decode: allResponse_decode$73,
  responseError_encode: responseError_encode$73,
  responseError_decode: responseError_decode$73,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$73,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$73,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$73
};

var partial_arg$73 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToExitFromDataExtractionMode = partial_arg$73(MRTransform_AskBgToExitFromDataExtractionMode, AllWrapper);

var message_encode$152 = message_encode$74;

var message_decode$152 = message_decode$74;

function response_encode$152(v) {
  return ["AckSaveDataExtractionAsSmartcut"];
}

var response_decode$152 = response_decode$74;

var allMessage_encode$74 = message_encode$77;

var allMessage_decode$74 = message_decode$77;

var allResponse_encode$74 = response_encode$77;

var allResponse_decode$74 = response_decode$77;

var responseError_encode$74 = Decco.stringToJson;

var responseError_decode$74 = Decco.stringFromJson;

function wrapMessageAsAllMessage$74(message) {
  return {
          TAG: /* Message_AskBgToSaveDataExtractionAsSmartcut */74,
          _0: message
        };
}

function unwrapAllResponseAsResponse$74(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToSaveDataExtractionAsSmartcut */74) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$74(response) {
  return {
          TAG: /* Response_AskBgToSaveDataExtractionAsSmartcut */74,
          _0: response
        };
}

var MRTransform_AskBgToSaveDataExtractionAsSmartcut = {
  message_encode: message_encode$152,
  message_decode: message_decode$152,
  response_encode: response_encode$152,
  response_decode: response_decode$152,
  allMessage_encode: allMessage_encode$74,
  allMessage_decode: allMessage_decode$74,
  allResponse_encode: allResponse_encode$74,
  allResponse_decode: allResponse_decode$74,
  responseError_encode: responseError_encode$74,
  responseError_decode: responseError_decode$74,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$74,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$74,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$74
};

var partial_arg$74 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToSaveDataExtractionAsSmartcut = partial_arg$74(MRTransform_AskBgToSaveDataExtractionAsSmartcut, AllWrapper);

var message_encode$153 = message_encode$76;

var message_decode$153 = message_decode$76;

function response_encode$153(v) {
  return ["DidRenderNotification"];
}

var response_decode$153 = response_decode$76;

var allMessage_encode$75 = message_encode$77;

var allMessage_decode$75 = message_decode$77;

var allResponse_encode$75 = response_encode$77;

var allResponse_decode$75 = response_decode$77;

var responseError_encode$75 = Decco.stringToJson;

var responseError_decode$75 = Decco.stringFromJson;

function wrapMessageAsAllMessage$75(message) {
  return {
          TAG: /* Message_AskBgToRenderNotification */75,
          _0: message
        };
}

function unwrapAllResponseAsResponse$75(allResponse) {
  if (allResponse.TAG === /* Response_AskBgToRenderNotification */75) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$75(response) {
  return {
          TAG: /* Response_AskBgToRenderNotification */75,
          _0: response
        };
}

var MRTransform_AskBgToRenderNotification = {
  message_encode: message_encode$153,
  message_decode: message_decode$153,
  response_encode: response_encode$153,
  response_decode: response_decode$153,
  allMessage_encode: allMessage_encode$75,
  allMessage_decode: allMessage_decode$75,
  allResponse_encode: allResponse_encode$75,
  allResponse_decode: allResponse_decode$75,
  responseError_encode: responseError_encode$75,
  responseError_decode: responseError_decode$75,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$75,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$75,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$75
};

var partial_arg$75 = ExtensionMessagingBuilders$SmartcutsMacros.MakeWrappedTabMessageSender;

var AskBgToRenderNotification = partial_arg$75(MRTransform_AskBgToRenderNotification, AllWrapper);

var message_encode$154 = message_encode$77;

var message_decode$154 = message_decode$77;

var response_encode$154 = response_encode$77;

var response_decode$154 = response_decode$77;

var All = {
  message_encode: message_encode$154,
  message_decode: message_decode$154,
  response_encode: response_encode$154,
  response_decode: response_decode$154
};

exports.AllWrapper = AllWrapper;
exports.MR_ContentScriptReady = MR_ContentScriptReady;
exports.MR_AskBgToRefreshAuthStatus = MR_AskBgToRefreshAuthStatus;
exports.MR_AskBgToFetchPlanSubscriptionProgress = MR_AskBgToFetchPlanSubscriptionProgress;
exports.MR_StartDebugSelector = MR_StartDebugSelector;
exports.MR_StartRecording = MR_StartRecording;
exports.MR_StopRecording = MR_StopRecording;
exports.MR_DidStartRecording = MR_DidStartRecording;
exports.MR_NotifyBgAboutPossibleCommand = MR_NotifyBgAboutPossibleCommand;
exports.MR_ClearKeyThatDoesNotGenerateCommand = MR_ClearKeyThatDoesNotGenerateCommand;
exports.MR_RecordCommand = MR_RecordCommand;
exports.MR_FinishAuthoring = MR_FinishAuthoring;
exports.MR_OpenPageForSmartcutId = MR_OpenPageForSmartcutId;
exports.MR_ShowFormForSmartcutId = MR_ShowFormForSmartcutId;
exports.MR_AskBgToAdjustModalGeometry = MR_AskBgToAdjustModalGeometry;
exports.MR_InitializePlayback = MR_InitializePlayback;
exports.MR_GetAuthoringCommandLog = MR_GetAuthoringCommandLog;
exports.MR_GetSmartcut = MR_GetSmartcut;
exports.MR_GetMySmartcuts = MR_GetMySmartcuts;
exports.MR_InstallSmartcut = MR_InstallSmartcut;
exports.MR_DeleteSmartcut = MR_DeleteSmartcut;
exports.MR_GetExecutionHistoryForSmartcut = MR_GetExecutionHistoryForSmartcut;
exports.MR_GetScheduledTriggersForSmartcut = MR_GetScheduledTriggersForSmartcut;
exports.MR_FindExecutionById = MR_FindExecutionById;
exports.MR_UpdateExecutionStatus = MR_UpdateExecutionStatus;
exports.MR_UpsertExecutionSet = MR_UpsertExecutionSet;
exports.MR_DeleteExecutionSet = MR_DeleteExecutionSet;
exports.MR_GetExecutionSetProgress = MR_GetExecutionSetProgress;
exports.MR_GetExecutionSetById = MR_GetExecutionSetById;
exports.MR_UpsertScheduledTriggerAndCreateAlarm = MR_UpsertScheduledTriggerAndCreateAlarm;
exports.MR_ArchiveScheduledTrigger = MR_ArchiveScheduledTrigger;
exports.MR_SaveExternalAccount = MR_SaveExternalAccount;
exports.MR_FindExternalAccountById = MR_FindExternalAccountById;
exports.MR_GetOAuthToken = MR_GetOAuthToken;
exports.MR_AskBgToClipboard = MR_AskBgToClipboard;
exports.GoogleSheet = GoogleSheet;
exports.MR_CreateGoogleSheet = MR_CreateGoogleSheet;
exports.MR_FetchGoogleSheet = MR_FetchGoogleSheet;
exports.MR_BatchUpdateGoogleSheet = MR_BatchUpdateGoogleSheet;
exports.MR_InitGoogleAuthFlow = MR_InitGoogleAuthFlow;
exports.MR_UserDidCloseGoogleOAuthModal = MR_UserDidCloseGoogleOAuthModal;
exports.MR_MultiUrlTriggering = MR_MultiUrlTriggering;
exports.MR_DebugSelector = MR_DebugSelector;
exports.MR_PlaybackModeControl = MR_PlaybackModeControl;
exports.MR_UrlTriggering_AskBgToUpdateLinkGroups = MR_UrlTriggering_AskBgToUpdateLinkGroups;
exports.MR_UrlTriggering_AskBgToRecordPageAction = MR_UrlTriggering_AskBgToRecordPageAction;
exports.MR_UrlTriggering_AskBgToStopRecordPageAction = MR_UrlTriggering_AskBgToStopRecordPageAction;
exports.MR_UrlTriggering_AskBgToPlaybackPageAction = MR_UrlTriggering_AskBgToPlaybackPageAction;
exports.MR_UrlTriggering_DidFinishPlaybackPageAction = MR_UrlTriggering_DidFinishPlaybackPageAction;
exports.MR_UrlTriggering_AskBgToShowLinkWithId = MR_UrlTriggering_AskBgToShowLinkWithId;
exports.MR_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut = MR_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut;
exports.MR_UrlTriggering_MaybeReadyToPlaybackPagination = MR_UrlTriggering_MaybeReadyToPlaybackPagination;
exports.MR_UrlTriggering_AskBgToUpdatePaginateFn = MR_UrlTriggering_AskBgToUpdatePaginateFn;
exports.MR_AskBgToFocusTab = MR_AskBgToFocusTab;
exports.MR_AskBgToFocusWindow = MR_AskBgToFocusWindow;
exports.MR_SmartcutSavingProgress = MR_SmartcutSavingProgress;
exports.MR_RequestPermissions = MR_RequestPermissions;
exports.MR_NotifyConfirmExecutionQuotaResult = MR_NotifyConfirmExecutionQuotaResult;
exports.MR_TrackWithSegment = MR_TrackWithSegment;
exports.MR_UserReadyLogInToWebsite = MR_UserReadyLogInToWebsite;
exports.MR_OpenNewWindow = MR_OpenNewWindow;
exports.MR_StoreAuthStatusItem = MR_StoreAuthStatusItem;
exports.MR_AskBgToHighlightElement = MR_AskBgToHighlightElement;
exports.MR_DidCloseExplainModalAndAskBgToHighlightElement = MR_DidCloseExplainModalAndAskBgToHighlightElement;
exports.MR_AskBgToStopHighlightElement = MR_AskBgToStopHighlightElement;
exports.MR_GetUserCredentials = MR_GetUserCredentials;
exports.MR_UnlockVaultWithMasterSecret = MR_UnlockVaultWithMasterSecret;
exports.MR_ModifyUserCredentials = MR_ModifyUserCredentials;
exports.MR_AskBgIfMasterSecretDoesExist = MR_AskBgIfMasterSecretDoesExist;
exports.MR_AskBgForMissingPasswords = MR_AskBgForMissingPasswords;
exports.MR_AskBgToCreateVaultWithMasterSecret = MR_AskBgToCreateVaultWithMasterSecret;
exports.MR_AskBgToResetMasterSecret = MR_AskBgToResetMasterSecret;
exports.MR_AskBgToDetachLoginSmartcut = MR_AskBgToDetachLoginSmartcut;
exports.MR_AskBgToEnterDataExtractionMode = MR_AskBgToEnterDataExtractionMode;
exports.MR_AskBgToProcessDataExtractionSignal = MR_AskBgToProcessDataExtractionSignal;
exports.MR_AskBgToSaveDataExtractionAsSmartcut = MR_AskBgToSaveDataExtractionAsSmartcut;
exports.MR_AskBgToExitFromDataExtractionMode = MR_AskBgToExitFromDataExtractionMode;
exports.MR_AskBgToRenderNotification = MR_AskBgToRenderNotification;
exports.MR_All = MR_All;
exports.MRTransform_ContentScriptReady = MRTransform_ContentScriptReady;
exports.ContentScriptReady = ContentScriptReady;
exports.MRTransform_AskBgToRefreshAuthStatus = MRTransform_AskBgToRefreshAuthStatus;
exports.AskBgToRefreshAuthStatus = AskBgToRefreshAuthStatus;
exports.MRTransform_AskBgToFetchPlanSubscriptionProgress = MRTransform_AskBgToFetchPlanSubscriptionProgress;
exports.AskBgToFetchPlanSubscriptionProgress = AskBgToFetchPlanSubscriptionProgress;
exports.MRTransform_StartDebugSelector = MRTransform_StartDebugSelector;
exports.StartDebugSelector = StartDebugSelector;
exports.MRTransform_StartRecording = MRTransform_StartRecording;
exports.StartRecording = StartRecording;
exports.MRTransform_StopRecording = MRTransform_StopRecording;
exports.StopRecording = StopRecording;
exports.MRTransform_DidStartRecording = MRTransform_DidStartRecording;
exports.DidStartRecording = DidStartRecording;
exports.MRTransform_NotifyBgAboutPossibleCommand = MRTransform_NotifyBgAboutPossibleCommand;
exports.NotifyBgAboutPossibleCommand = NotifyBgAboutPossibleCommand;
exports.MRTransform_ClearKeyThatDoesNotGenerateCommand = MRTransform_ClearKeyThatDoesNotGenerateCommand;
exports.ClearKeyThatDoesNotGenerateCommand = ClearKeyThatDoesNotGenerateCommand;
exports.MRTransform_RecordCommand = MRTransform_RecordCommand;
exports.RecordCommand = RecordCommand;
exports.MRTransform_FinishAuthoring = MRTransform_FinishAuthoring;
exports.FinishAuthoring = FinishAuthoring;
exports.MRTransform_OpenPageForSmartcutId = MRTransform_OpenPageForSmartcutId;
exports.OpenPageForSmartcutId = OpenPageForSmartcutId;
exports.MRTransform_ShowFormForSmartcutId = MRTransform_ShowFormForSmartcutId;
exports.ShowFormForSmartcutId = ShowFormForSmartcutId;
exports.MRTransform_AskBgToAdjustModalGeometry = MRTransform_AskBgToAdjustModalGeometry;
exports.AskBgToAdjustModalGeometry = AskBgToAdjustModalGeometry;
exports.MRTransform_InitializePlayback = MRTransform_InitializePlayback;
exports.InitializePlayback = InitializePlayback;
exports.MRTransform_GetAuthoringCommandLog = MRTransform_GetAuthoringCommandLog;
exports.GetAuthoringCommandLog = GetAuthoringCommandLog;
exports.MRTransform_GetSmartcut = MRTransform_GetSmartcut;
exports.GetSmartcut = GetSmartcut;
exports.MRTransform_GetMySmartcuts = MRTransform_GetMySmartcuts;
exports.GetMySmartcuts = GetMySmartcuts;
exports.MRTransform_InstallSmartcut = MRTransform_InstallSmartcut;
exports.MRTransform_DeleteSmartcut = MRTransform_DeleteSmartcut;
exports.InstallSmartcut = InstallSmartcut;
exports.DeleteSmartcut = DeleteSmartcut;
exports.MRTransform_GetExecutionHistoryForSmartcut = MRTransform_GetExecutionHistoryForSmartcut;
exports.GetExecutionHistoryForSmartcut = GetExecutionHistoryForSmartcut;
exports.MRTransform_GetScheduledTriggersForSmartcut = MRTransform_GetScheduledTriggersForSmartcut;
exports.GetScheduledTriggersForSmartcut = GetScheduledTriggersForSmartcut;
exports.MRTransform_FindExecutionById = MRTransform_FindExecutionById;
exports.FindExecutionById = FindExecutionById;
exports.MRTransform_UpdateExecutionStatus = MRTransform_UpdateExecutionStatus;
exports.UpdateExecutionStatus = UpdateExecutionStatus;
exports.MRTransform_UpsertExecutionSet = MRTransform_UpsertExecutionSet;
exports.UpsertExecutionSet = UpsertExecutionSet;
exports.MRTransform_DeleteExecutionSet = MRTransform_DeleteExecutionSet;
exports.DeleteExecutionSet = DeleteExecutionSet;
exports.MRTransform_GetExecutionSetProgress = MRTransform_GetExecutionSetProgress;
exports.GetExecutionSetProgress = GetExecutionSetProgress;
exports.MRTransform_GetExecutionSetById = MRTransform_GetExecutionSetById;
exports.GetExecutionSetById = GetExecutionSetById;
exports.MRTransform_UpsertScheduledTriggerAndCreateAlarm = MRTransform_UpsertScheduledTriggerAndCreateAlarm;
exports.UpsertScheduledTriggerAndCreateAlarm = UpsertScheduledTriggerAndCreateAlarm;
exports.MRTransform_ArchiveScheduledTrigger = MRTransform_ArchiveScheduledTrigger;
exports.ArchiveScheduledTrigger = ArchiveScheduledTrigger;
exports.MRTransform_SaveExternalAccount = MRTransform_SaveExternalAccount;
exports.SaveExternalAccount = SaveExternalAccount;
exports.MRTransform_FindExternalAccountById = MRTransform_FindExternalAccountById;
exports.FindExternalAccountById = FindExternalAccountById;
exports.MRTransform_GetOAuthToken = MRTransform_GetOAuthToken;
exports.GetOAuthToken = GetOAuthToken;
exports.MRTransform_AskBgToClipboard = MRTransform_AskBgToClipboard;
exports.AskBgToClipboard = AskBgToClipboard;
exports.MRTransform_CreateGoogleSheet = MRTransform_CreateGoogleSheet;
exports.CreateGoogleSheet = CreateGoogleSheet;
exports.MRTransform_FetchGoogleSheet = MRTransform_FetchGoogleSheet;
exports.FetchGoogleSheet = FetchGoogleSheet;
exports.MRTransform_BatchUpdateGoogleSheet = MRTransform_BatchUpdateGoogleSheet;
exports.BatchUpdateGoogleSheet = BatchUpdateGoogleSheet;
exports.MRTransform_InitGoogleAuthFlow = MRTransform_InitGoogleAuthFlow;
exports.InitGoogleAuthFlow = InitGoogleAuthFlow;
exports.MRTransform_UserDidCloseGoogleOAuthModal = MRTransform_UserDidCloseGoogleOAuthModal;
exports.UserDidCloseGoogleOAuthModal = UserDidCloseGoogleOAuthModal;
exports.MRTransform_MultiUrlTriggering = MRTransform_MultiUrlTriggering;
exports.MultiUrlTriggering = MultiUrlTriggering;
exports.MRTransform_DebugSelector = MRTransform_DebugSelector;
exports.DebugSelector = DebugSelector;
exports.MRTransform_PlaybackModeControl = MRTransform_PlaybackModeControl;
exports.PlaybackModeControl = PlaybackModeControl;
exports.MRTransform_UrlTriggering_AskBgToUpdateLinkGroups = MRTransform_UrlTriggering_AskBgToUpdateLinkGroups;
exports.UrlTriggering_AskBgToUpdateLinkGroups = UrlTriggering_AskBgToUpdateLinkGroups;
exports.MRTransform_UrlTriggering_AskBgToRecordPageAction = MRTransform_UrlTriggering_AskBgToRecordPageAction;
exports.UrlTriggering_AskBgToRecordPageAction = UrlTriggering_AskBgToRecordPageAction;
exports.MRTransform_UrlTriggering_AskBgToStopRecordPageAction = MRTransform_UrlTriggering_AskBgToStopRecordPageAction;
exports.UrlTriggering_AskBgToStopRecordPageAction = UrlTriggering_AskBgToStopRecordPageAction;
exports.MRTransform_UrlTriggering_AskBgToPlaybackPageAction = MRTransform_UrlTriggering_AskBgToPlaybackPageAction;
exports.UrlTriggering_AskBgToPlaybackPageAction = UrlTriggering_AskBgToPlaybackPageAction;
exports.MRTransform_UrlTriggering_DidFinishPlaybackPageAction = MRTransform_UrlTriggering_DidFinishPlaybackPageAction;
exports.UrlTriggering_DidFinishPlaybackPageAction = UrlTriggering_DidFinishPlaybackPageAction;
exports.MRTransform_UrlTriggering_AskBgToShowLinkWithId = MRTransform_UrlTriggering_AskBgToShowLinkWithId;
exports.UrlTriggering_AskBgToShowLinkWithId = UrlTriggering_AskBgToShowLinkWithId;
exports.MRTransform_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut = MRTransform_UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut;
exports.UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut = UrlTriggering_AskBgToSaveUrlTriggeringAsSmartcut;
exports.MRTransform_UrlTriggering_MaybeReadyToPlaybackPagination = MRTransform_UrlTriggering_MaybeReadyToPlaybackPagination;
exports.UrlTriggering_MaybeReadyToPlaybackPagination = UrlTriggering_MaybeReadyToPlaybackPagination;
exports.MRTransform_AskBgToFocusTab = MRTransform_AskBgToFocusTab;
exports.MRTransform_UrlTriggering_AskBgToUpdatePaginateFn = MRTransform_UrlTriggering_AskBgToUpdatePaginateFn;
exports.UrlTriggering_AskBgToUpdatePaginateFn = UrlTriggering_AskBgToUpdatePaginateFn;
exports.AskBgToFocusTab = AskBgToFocusTab;
exports.MRTransform_AskBgToFocusWindow = MRTransform_AskBgToFocusWindow;
exports.AskBgToFocusWindow = AskBgToFocusWindow;
exports.MRTransform_SmartcutSavingProgress = MRTransform_SmartcutSavingProgress;
exports.SmartcutSavingProgress = SmartcutSavingProgress;
exports.MRTransform_RequestPermissions = MRTransform_RequestPermissions;
exports.RequestPermissions = RequestPermissions;
exports.MRTransform_NotifyConfirmExecutionQuotaResult = MRTransform_NotifyConfirmExecutionQuotaResult;
exports.NotifyConfirmExecutionQuotaResult = NotifyConfirmExecutionQuotaResult;
exports.MRTransform_TrackWithSegment = MRTransform_TrackWithSegment;
exports.TrackWithSegment = TrackWithSegment;
exports.MRTransform_UserReadyLogInToWebsite = MRTransform_UserReadyLogInToWebsite;
exports.UserReadyLogInToWebsite = UserReadyLogInToWebsite;
exports.MRTransform_OpenNewWindow = MRTransform_OpenNewWindow;
exports.OpenNewWindow = OpenNewWindow;
exports.MRTransform_StoreAuthStatusItem = MRTransform_StoreAuthStatusItem;
exports.StoreAuthStatusItem = StoreAuthStatusItem;
exports.MRTransform_AskBgToHighlightElement = MRTransform_AskBgToHighlightElement;
exports.AskBgToHighlightElement = AskBgToHighlightElement;
exports.MRTransform_DidCloseExplainModalAndAskBgToHighlightElement = MRTransform_DidCloseExplainModalAndAskBgToHighlightElement;
exports.DidCloseExplainModalAndAskBgToHighlightElement = DidCloseExplainModalAndAskBgToHighlightElement;
exports.MRTransform_AskBgToStopHighlightElement = MRTransform_AskBgToStopHighlightElement;
exports.AskBgToStopHighlightElement = AskBgToStopHighlightElement;
exports.MRTransform_GetUserCredentials = MRTransform_GetUserCredentials;
exports.GetUserCredentials = GetUserCredentials;
exports.MRTransform_UnlockVaultWithMasterSecret = MRTransform_UnlockVaultWithMasterSecret;
exports.UnlockVaultWithMasterSecret = UnlockVaultWithMasterSecret;
exports.MRTransform_ModifyUserCredentials = MRTransform_ModifyUserCredentials;
exports.ModifyUserCredentials = ModifyUserCredentials;
exports.MRTransform_AskBgIfMasterSecretDoesExist = MRTransform_AskBgIfMasterSecretDoesExist;
exports.AskBgIfMasterSecretDoesExist = AskBgIfMasterSecretDoesExist;
exports.MRTransform_AskBgForMissingPasswords = MRTransform_AskBgForMissingPasswords;
exports.AskBgForMissingPasswords = AskBgForMissingPasswords;
exports.MRTransform_AskBgToCreateVaultWithMasterSecret = MRTransform_AskBgToCreateVaultWithMasterSecret;
exports.AskBgToCreateVaultWithMasterSecret = AskBgToCreateVaultWithMasterSecret;
exports.MRTransform_AskBgToResetMasterSecret = MRTransform_AskBgToResetMasterSecret;
exports.AskBgToResetMasterSecret = AskBgToResetMasterSecret;
exports.MRTransform_AskBgToDetachLoginSmartcut = MRTransform_AskBgToDetachLoginSmartcut;
exports.AskBgToDetachLoginSmartcut = AskBgToDetachLoginSmartcut;
exports.MRTransform_AskBgToEnterDataExtractionMode = MRTransform_AskBgToEnterDataExtractionMode;
exports.AskBgToEnterDataExtractionMode = AskBgToEnterDataExtractionMode;
exports.MRTransform_AskBgToProcessDataExtractionSignal = MRTransform_AskBgToProcessDataExtractionSignal;
exports.AskBgToProcessDataExtractionSignal = AskBgToProcessDataExtractionSignal;
exports.MRTransform_AskBgToExitFromDataExtractionMode = MRTransform_AskBgToExitFromDataExtractionMode;
exports.AskBgToExitFromDataExtractionMode = AskBgToExitFromDataExtractionMode;
exports.MRTransform_AskBgToSaveDataExtractionAsSmartcut = MRTransform_AskBgToSaveDataExtractionAsSmartcut;
exports.AskBgToSaveDataExtractionAsSmartcut = AskBgToSaveDataExtractionAsSmartcut;
exports.MRTransform_AskBgToRenderNotification = MRTransform_AskBgToRenderNotification;
exports.AskBgToRenderNotification = AskBgToRenderNotification;
exports.All = All;
/* Sheet Not a pure module */
